import { React, useEffect, useRef, useState } from 'react';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import LandingHeader from '../../components/header/LandingHeader';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import ndovupay from '../../assets/ndovupay.png';
import tick from '../../assets/tick.svg';
import hand from '../../assets/hand.jpg';
import ndovuHome from '../../assets/ndovuhome.png';
import cardTick from '../../assets/card-tick.svg';
import dee from '../../assets/dee.jpg';
import collab from '../../assets/collab.svg';
import receipt from '../../assets/receipt.svg';
import people from '../../assets/people.svg';
import { useNavigate } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';
import home1 from '../../assets/home1.svg';
import home2 from '../../assets/home2.svg';
import home3 from '../../assets/home3.png';
import home5 from '../../assets/home5.png';
import home6 from '../../assets/home6.png';
import home7 from '../../assets/home7.png';
import home8 from '../../assets/home8.png';
import home9 from '../../assets/home9.svg';
import home10 from '../../assets/home10.svg';
import home11 from '../../assets/home11.svg';
import home12 from '../../assets/home1.svg';
import home13 from '../../assets/home1.svg';

function Home() {
	const ref1 = useRef(null);
	const ref2 = useRef(null);
	const ref3 = useRef(null);

	const [hasMargin, sethasMargin] = useState(false);

	const navigate = useNavigate();

	const handleAbout = () => {
		console.log('CLICK 1');
		ref1.current?.scrollIntoView({ behavior: 'smooth' });
		console.log(ref1.current);
	};

	const handleFeature = () => {
		ref2.current?.scrollIntoView({ behavior: 'smooth' });
	};

	const handleWhy = () => {
		ref3.current?.scrollIntoView({ behavior: 'smooth' });
	};

	const handleGetStarted = () => {
		navigate('/sign-up');
	};

	function toggleMargin() {
		console.log(hasMargin);
		sethasMargin(!hasMargin);
	}

	useEffect(() => {}, [hasMargin]);

	return (
		<>
			<div className='p-4 lg:!p-0 !overflow-x-hidden'>
				<div className='lg:mx-[120px]'>
					<LandingHeader
						handleAbout={handleAbout}
						handleFeature={handleFeature}
						handleWhy={handleWhy}
						toggleMargin={toggleMargin}
					/>

					<div className='mt-[102px] flex flex-col lg:flex-row lg:justify-between w-full'>
						<div className='w-full lg:w-[40%] mt-[50px]'>
							<h1
								style={{
									marginTop: hasMargin ? 20 : 0,
								}}
								className='meet'
							>
								Welcome to Ndovu<span className='text-[#DB2A12]'>Pay</span>.
								Streamline Your Financial Transactions.
							</h1>

							<p className='with mt-[24px]'>
								Are you ready to transform the way your business handles
								payments? Look no further. At Ndovupay, we are dedicated to
								providing top-notch payment solutions tailored for businesses
								and corporates like yours.
							</p>

							<div className='flex items-center mt-[48px]'>
								<a
									rel='noreferrer'
									target='_blank'
									href='https://play.google.com/store/apps/details?id=com.spa.pngp'
									className=''
									type='button'
								>
									<img src={home2} alt='play store' />
								</a>
								<button
									onClick={handleWhy}
									className='p-[12px] btn text-[#fff] w-[180px] lg:h-[52px] bg-[#000] border-[1.5px] border-[#E2E8F0] ml-[24px]'
									type='button'
								>
									USSD <span className='font-bold ml-1'>*873#</span>
								</button>
							</div>
						</div>
						<div className='hidden lg:flex w-[60%]'>
							<img
								src={home1}
								className='w-[100%] h-[580px]'
								alt='NDOVUPAY'
							/>
						</div>
					</div>
				</div>

				<div
					id='about'
					className='mt-10 lg:mt-[157px] w-full lg:pl-[131px] py-[20px] '
				>
					<div className='grid grid-cols-1 lg:grid-cols-2'>
						<img
							src={home3}
							className='w-full hidden h-auto lg:w-[662] lg:h-[682px] object-contain lg:block'
							alt='sell'
						/>

						<div className='flex flex-col lg:p-[87px] lg:ml-[87px]'>
							<span className='make !text-[#DE4532]'>About us</span>
							<h2 className='make2 mt-[23px]'>
								Buy and sell anything safely without fear
							</h2>
							<p className='ndov'>
								Trust isn't just in the DNA of NdovuPay. It is our commitment to
								ensure a buyer will receive a product or service after paying
								for it and guarantee a seller will receive timely payment after
								delivering a product or service. This way we'll have done our
								part in stamping out corruption, fraud, and scam in e-commerce.
								NdovuPay enables both buyers and sellers to transact anywhere,
								anytime in a safe and secure way using any device. NdovuPay is
								an international business with an office located at Nairobi,
								Kenya.
							</p>

							<button
								onClick={handleGetStarted}
								className='p-[12px] btn bg-[#DA2811] w-[184px] mt-14'
								type='button'
							>
								<span className='btn-home-yellow !text-white'>Read more</span>
							</button>
						</div>
					</div>
				</div>

				<div className='mt-[129px] grid grid-cols-1 lg:grid-cols-2'>
					<img
						src={ndovupay}
						className='w-full md:w-[400px] h-[400] lg:ml-[173px]'
						alt='Ndovupay'
					/>

					<div className='w-full lg:w-[80%] mt-7 lg:ml-[10%] lg:mt-0'>
						<span className='make'>Make Payments</span>
						<h2 className='make2 mt-[23px]'>
							Secure, Seamless, and Reliable Payment Services
						</h2>
						<p className='ndov'>
							NdovuPay is an all-in-one account. From fast transactions for all
							payments across all your organization, to easy bookkeeping and
							management.
						</p>

						<div className='mt-[24px] px-2'>
							<div className='flex items-center mb-[23px]'>
								<img src={tick} className='w-[32px] h-[32px]' alt='tick' />
								<span className='tick ml-3'>Cross platform payments</span>
							</div>
							<div className='flex items-center mb-[23px]'>
								<img src={tick} className='w-[32px] h-[32px]' alt='tick' />
								<span className='tick ml-3'>
									Seamless transactions between Bank & M-PESA
								</span>
							</div>
							<div className='flex items-center mb-[23px]'>
								<img src={tick} className='w-[32px] h-[32px]' alt='tick' />
								<span className='tick ml-3'>Licensed & regulated</span>
							</div>
						</div>
						<div onClick={handleWhy} className='flex mt-[49px] cursor-pointer'>
							<span className='read mr-2'>Read more</span>
							<TrendingFlatIcon className='text-[#017EFA] text-[25px]' />
						</div>
					</div>
				</div>

				<div className='bg-[#212529] mt-14 w-full h-auto pb-14 lg:mt-28'>
					<div className='flex justify-center py-10'>
						<h3 className='mt-[23px] manage'>Our simple steps</h3>
					</div>

					<div className='flex justify-around items-center flex-wrap'>
						<div className='flex items-center w-full lg:w-auto justify-center lg:justify-normal'>
							<img
								src={home5}
								className='w-[90px] h-[90px] rounded-full'
								alt='step 1'
							/>
							<div className='flex flex-col ml-3'>
								<span className='text-white text-[16px]'>Agree to</span>
								<span className='text-white text-[16px]'>
									transaction terms
								</span>
							</div>
						</div>

						<div className='flex items-center w-full lg:w-auto justify-center lg:justify-normal'>
							<img
								src={home6}
								className='w-[90px] h-[90px] rounded-full'
								alt='step 1'
							/>
							<div className='flex flex-col ml-3'>
								<span className='text-white text-[16px]'>Pay safely with</span>
								<span className='text-white text-[16px]'>NdovuPay</span>
							</div>
						</div>

						<div className='flex items-center w-full lg:w-auto justify-center lg:justify-normal'>
							<img
								src={home7}
								className='w-[90px] h-[90px] rounded-full'
								alt='step 1'
							/>
							<div className='flex flex-col ml-3'>
								<span className='text-white text-[16px]'>Deliver and</span>
								<span className='text-white text-[16px]'>accept delivery</span>
							</div>
						</div>

						<div className='flex items-center w-full lg:w-auto justify-center lg:justify-normal'>
							<img
								src={home8}
								className='w-[90px] h-[90px] rounded-full'
								alt='step 1'
							/>
							<div className='flex flex-col ml-3'>
								<span className='text-white text-[16px]'>Get</span>
								<span className='text-white text-[16px]'>paid</span>
							</div>
						</div>
					</div>
				</div>

				<div
					ref={ref3}
					className='mt-[130px] flex flex-col lg:mx-[120px] lg:flex-row'
				>
					<div className='flex flex-col w-full lg:w-[44%]'>
						<h4 className='why'>Why Choose Ndovupay?</h4>
						<h3 className='all mt-[22px]'>All-in-one payments.</h3>
						<h2 className='faster'>
							Faster, easier, and more secure way of managing your money.
						</h2>
						<p className='fast-p mt-[20px]'>
							Simplify your financial operations with a comprehensive platform
							that handles both collections and disbursements across all payment
							channels, including banks and M-Pesa.
						</p>
						{/* <div className='hidden lg:flex lg:mt-[49px]'>
						<span className='read mr-2'>Read more</span>
						<TrendingFlatIcon className='text-[#017EFA] text-[25px]' />
					</div> */}
					</div>

					<div className='grid grid-cols-1 md:grid-cols-2 gap-4 w-full lg:w-[40%] lg:ml-[10%]'>
						<div className='p-[20px] flex flex-col w-full md:w-[300px]'>
							<img
								src={cardTick}
								className='w-[56px] h-[56px] rounded-full p-[10px] object-contain bg-gradient-to-t from-[#f4c85833] to-[#e3eaff00]'
								alt='Coin'
							/>
							<span className='why-span mt-[18px]'>Robust Security</span>
							<p className='why-p mt-[18px]'>
								Our platform is fortified with the latest encryption technology
								and security protocols to ensure your data and transactions are
								safeguarded at all times.
							</p>
						</div>
						<div className='p-[20px] flex flex-col w-full md:w-[300px] ml-0 lg:ml-[71px]'>
							<img
								src={collab}
								className='w-[56px] h-[56px] rounded-full p-[10px] object-contain bg-opacity-20 bg-gradient-to-t from-[#f4585833] to-[#e3eaff00]'
								alt='Coin'
							/>
							<span className='why-span mt-[18px]'>
								Hassle-Free Integration
							</span>
							<p className='why-p mt-[18px]'>
								Seamlessly integrate our payment services into your existing
								systems and applications, saving you time and resources.
							</p>
						</div>
						<div className='p-[20px] flex flex-col w-full md:w-[300px]'>
							<img
								src={receipt}
								className='w-[56px] h-[56px] rounded-full p-[10px] object-contain bg-opacity-20 bg-gradient-to-t from-[#002f6461] to-[#e3eaff00]'
								alt='Coin'
							/>
							<span className='why-span mt-[18px]'>Real-time Reporting</span>
							<p className='why-p mt-[18px]'>
								Gain deep insights into your financial transactions with our
								real-time reporting and analytics tools. Stay in control of your
								finances with ease.
							</p>
						</div>
						<div className='p-[20px] flex flex-col w-full md:w-[300px] ml-0 lg:ml-[71px]'>
							<img
								src={people}
								className='w-[56px] h-[56px] rounded-full p-[10px] object-contain bg-opacity-20 bg-gradient-to-t from-[#F7EFDA] to-[#e3eaff00]'
								alt='Coin'
							/>
							<span className='why-span mt-[18px]'> Dedicated Support</span>
							<p className='why-p mt-[18px]'>
								Our team of experts is ready to assist you around the clock.
								We're committed to providing exceptional customer support
								whenever you need it.
							</p>
						</div>
					</div>
				</div>

				<div className='flex items-center mt-[130px]'>
					<div
						ref={ref2}
						className='w-full lg:w-[704px] lg:h-[704px] bg-[#212529]'
					>
						<div className='px-2 py-3 lg:!px-[120px] lg:!py-[161px]'>
							<span className='collections'>Collections</span>
							<h3 className='mt-[23px] manage'>Manage collections</h3>

							<ol className='mt-[30px] text-white'>
								<li className='mb-[28px] flex flex-col'>
									<span className='ol'>01. Daily collection targets</span>
									<span className='ol-span mt-[12px] ml-7'>
										Know how much you collect in day
									</span>
								</li>
								<li className='mb-[28px] flex flex-col'>
									<span className='ol'>
										02. Set and monitor collection targets
									</span>
									<span className='ol-span mt-[12px] ml-7'>
										Set and monitor collection targets
									</span>
								</li>
								<li className='mb-[28px] flex flex-col'>
									<span className='ol'>03. Collections transfer</span>
									<span className='ol-span mt-[12px] ml-7'>
										Transfer collection to different wallet <br />
										accounts as per your needs
									</span>
								</li>
							</ol>
						</div>
					</div>

					<div className='hidden lg:-ml-[5%] lg:flex'>
						<img
							className='w-[751px] h-[515px] object-contain'
							src={hand}
							alt='handshake'
						/>
					</div>
				</div>

				<div className='flex flex-col mt-[130px] mb-20'>
					<div className='flex flex-col justify-center items-center text-center'>
						<h2 className='faster w-full lg:w-[35%]'>
							Take a peak at Ndovu HR, for seamless HR Management
						</h2>
						<span className='hr-desc mt-3'>
							An HR platform with cutting edge bio-metric technology. Track
							employee attendance with ease, on and off the field.
						</span>
					</div>

					<div className='grid grid-cols-1 lg:grid-cols-3 gap-7 lg:mx-[120px] mt-5'>
						<div className='flex flex-col text-center border border-gray-300'>
							<div className='curved-div w-full flex justify-center items-center bg-[#F3F7FD] p-7'>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='150'
									height='168'
									viewBox='0 0 150 168'
									fill='none'
								>
									<g
										clip-path='url(#clip0_461_5371)'
										filter='url(#filter0_d_461_5371)'
									>
										<path
											d='M76.3398 33.7898V35.9839C76.3398 36.0936 76.4123 36.1668 76.521 36.1668C76.6297 36.1668 76.7022 36.0936 76.7022 35.9839V33.7898C76.7022 33.6801 76.6297 33.6069 76.521 33.6069C76.4485 33.6069 76.3398 33.6801 76.3398 33.7898Z'
											fill='#2E353A'
										/>
										<path
											d='M76.3398 38.324V40.7009C76.3398 40.8106 76.4123 40.8838 76.521 40.8838C76.6297 40.8838 76.7022 40.8106 76.7022 40.7009V38.324C76.7022 38.2143 76.6297 38.1411 76.521 38.1411C76.4485 38.1411 76.3398 38.2508 76.3398 38.324Z'
											fill='#2E353A'
										/>
										<path
											d='M76.3398 43.0779V45.272C76.3398 45.3817 76.4123 45.4548 76.521 45.4548C76.6297 45.4548 76.7022 45.3817 76.7022 45.272V43.0779C76.7022 42.9682 76.6297 42.895 76.521 42.895C76.4485 42.895 76.3398 42.9682 76.3398 43.0779Z'
											fill='#2E353A'
										/>
										<path
											d='M111.195 70.7241H109.021C108.912 70.7241 108.84 70.7973 108.84 70.907C108.84 71.0167 108.912 71.0898 109.021 71.0898H111.195C111.304 71.0898 111.376 71.0167 111.376 70.907C111.376 70.7973 111.304 70.7241 111.195 70.7241Z'
											fill='#2E353A'
										/>
										<path
											d='M106.702 70.7241H104.347C104.238 70.7241 104.166 70.7973 104.166 70.907C104.166 71.0167 104.238 71.0898 104.347 71.0898H106.702C106.811 71.0898 106.883 71.0167 106.883 70.907C106.883 70.7973 106.775 70.7241 106.702 70.7241Z'
											fill='#2E353A'
										/>
										<path
											d='M101.992 70.7241H99.8179C99.7092 70.7241 99.6367 70.7973 99.6367 70.907C99.6367 71.0167 99.7092 71.0898 99.8179 71.0898H101.992C102.1 71.0898 102.173 71.0167 102.173 70.907C102.173 70.7973 102.1 70.7241 101.992 70.7241Z'
											fill='#2E353A'
										/>
										<path
											d='M53.2242 70.7241H51.0503C50.9416 70.7241 50.8691 70.7973 50.8691 70.907C50.8691 71.0167 50.9416 71.0898 51.0503 71.0898H53.2242C53.3329 71.0898 53.4054 71.0167 53.4054 70.907C53.4054 70.7973 53.3329 70.7241 53.2242 70.7241Z'
											fill='#2E353A'
										/>
										<path
											d='M48.7315 70.7241H46.3765C46.2678 70.7241 46.1953 70.7973 46.1953 70.907C46.1953 71.0167 46.2678 71.0898 46.3765 71.0898H48.7315C48.8402 71.0898 48.9127 71.0167 48.9127 70.907C48.9127 70.7973 48.804 70.7241 48.7315 70.7241Z'
											fill='#2E353A'
										/>
										<path
											d='M44.0211 70.7241H41.8472C41.7385 70.7241 41.666 70.7973 41.666 70.907C41.666 71.0167 41.7385 71.0898 41.8472 71.0898H44.0211C44.1298 71.0898 44.2022 71.0167 44.2022 70.907C44.2022 70.7973 44.1298 70.7241 44.0211 70.7241Z'
											fill='#2E353A'
										/>
										<path
											d='M136.812 79.6106C136.812 79.7934 136.884 79.8665 136.993 79.8665C137.101 79.8665 137.174 79.7934 137.174 79.6106V78.2941C137.174 78.1112 137.101 78.0381 136.993 78.0381C136.884 78.0381 136.812 78.1112 136.812 78.2941V79.6106ZM136.449 78.3307C136.449 77.9284 136.667 77.709 137.029 77.709C137.391 77.709 137.609 77.9284 137.609 78.3307V79.574C137.609 79.9763 137.391 80.1957 137.029 80.1957C136.667 80.1957 136.449 79.9763 136.449 79.574V78.3307Z'
											fill='#2E353A'
										/>
										<path
											d='M136.703 81.5118C136.993 81.5118 137.065 81.3655 137.102 81.2192H137.355V83.6328H136.993V81.8043H136.703V81.5118Z'
											fill='#2E353A'
										/>
										<path
											d='M136.812 86.5588C136.812 86.7416 136.884 86.8147 136.993 86.8147C137.101 86.8147 137.174 86.7416 137.174 86.5588V85.2423C137.174 85.0594 137.101 84.9863 136.993 84.9863C136.884 84.9863 136.812 85.0594 136.812 85.2423V86.5588ZM136.449 85.2423C136.449 84.84 136.667 84.6206 137.029 84.6206C137.391 84.6206 137.609 84.84 137.609 85.2423V86.4856C137.609 86.8879 137.391 87.1073 137.029 87.1073C136.667 87.1073 136.449 86.8879 136.449 86.4856V85.2423Z'
											fill='#2E353A'
										/>
										<path
											d='M136.703 88.46C136.993 88.46 137.065 88.3138 137.102 88.1675H137.355V90.581H136.993V88.7526H136.703V88.46Z'
											fill='#2E353A'
										/>
										<path
											d='M136.812 93.4699C136.812 93.6528 136.884 93.7259 136.993 93.7259C137.101 93.7259 137.174 93.6528 137.174 93.4699V92.1535C137.174 91.9706 137.101 91.8975 136.993 91.8975C136.884 91.8975 136.812 91.9706 136.812 92.1535V93.4699ZM136.449 92.19C136.449 91.7878 136.667 91.5684 137.029 91.5684C137.391 91.5684 137.609 91.7878 137.609 92.19V93.4334C137.609 93.8356 137.391 94.055 137.029 94.055C136.667 94.055 136.449 93.8356 136.449 93.4334V92.19Z'
											fill='#2E353A'
										/>
										<path
											d='M136.703 95.3716C136.993 95.3716 137.065 95.2254 137.102 95.0791H137.355V97.4926H136.993V95.6642H136.703V95.3716Z'
											fill='#2E353A'
										/>
										<path
											d='M136.812 100.382C136.812 100.564 136.884 100.638 136.993 100.638C137.101 100.638 137.174 100.564 137.174 100.382V99.0651C137.174 98.8822 137.101 98.8091 136.993 98.8091C136.884 98.8091 136.812 98.8822 136.812 99.0651V100.382ZM136.449 99.1017C136.449 98.6994 136.667 98.48 137.029 98.48C137.391 98.48 137.609 98.6994 137.609 99.1017V100.345C137.609 100.747 137.391 100.967 137.029 100.967C136.667 100.967 136.449 100.747 136.449 100.345V99.1017Z'
											fill='#2E353A'
										/>
										<path
											d='M136.812 103.856C136.812 104.038 136.884 104.112 136.993 104.112C137.101 104.112 137.174 104.038 137.174 103.856V102.539C137.174 102.356 137.101 102.283 136.993 102.283C136.884 102.283 136.812 102.356 136.812 102.539V103.856ZM136.449 102.539C136.449 102.137 136.667 101.917 137.029 101.917C137.391 101.917 137.609 102.137 137.609 102.539V103.782C137.609 104.185 137.391 104.404 137.029 104.404C136.667 104.404 136.449 104.185 136.449 103.782V102.539Z'
											fill='#2E353A'
										/>
										<path
											d='M136.812 107.293C136.812 107.476 136.884 107.549 136.993 107.549C137.101 107.549 137.174 107.476 137.174 107.293V105.977C137.174 105.794 137.101 105.721 136.993 105.721C136.884 105.721 136.812 105.794 136.812 105.977V107.293ZM136.449 106.013C136.449 105.611 136.667 105.392 137.029 105.392C137.391 105.392 137.609 105.611 137.609 106.013V107.257C137.609 107.659 137.391 107.878 137.029 107.878C136.667 107.878 136.449 107.659 136.449 107.257V106.013Z'
											fill='#2E353A'
										/>
										<path
											d='M136.703 112.669C136.993 112.669 137.065 112.522 137.102 112.376H137.355V114.79H136.993V112.961H136.703V112.669Z'
											fill='#2E353A'
										/>
										<path
											d='M136.703 116.106C136.993 116.106 137.065 115.96 137.102 115.813H137.355V118.227H136.993V116.399H136.703V116.106Z'
											fill='#2E353A'
										/>
										<path
											d='M136.703 119.58C136.993 119.58 137.065 119.434 137.102 119.288H137.355V121.701H136.993V119.873H136.703V119.58Z'
											fill='#2E353A'
										/>
										<path
											d='M136.812 124.59C136.812 124.773 136.884 124.846 136.993 124.846C137.101 124.846 137.174 124.773 137.174 124.59V123.274C137.174 123.091 137.101 123.018 136.993 123.018C136.884 123.018 136.812 123.091 136.812 123.274V124.59ZM136.449 123.31C136.449 122.908 136.667 122.688 137.029 122.688C137.391 122.688 137.609 122.908 137.609 123.31V124.553C137.609 124.956 137.391 125.175 137.029 125.175C136.667 125.175 136.449 124.956 136.449 124.553V123.31Z'
											fill='#2E353A'
										/>
										<path
											d='M136.812 128.064C136.812 128.247 136.884 128.32 136.993 128.32C137.101 128.32 137.174 128.247 137.174 128.064V126.748C137.174 126.565 137.101 126.492 136.993 126.492C136.884 126.492 136.812 126.565 136.812 126.748V128.064ZM136.449 126.784C136.449 126.382 136.667 126.163 137.029 126.163C137.391 126.163 137.609 126.382 137.609 126.784V128.028C137.609 128.43 137.391 128.649 137.029 128.649C136.667 128.649 136.449 128.43 136.449 128.028V126.784Z'
											fill='#2E353A'
										/>
										<path
											d='M136.703 129.966C136.993 129.966 137.065 129.82 137.102 129.673H137.355V132.087H136.993V130.258H136.703V129.966Z'
											fill='#2E353A'
										/>
										<path
											d='M138.732 74.6007C139.022 74.6007 139.095 74.4544 139.131 74.3081H139.385V76.7217H139.022V74.8932H138.732V74.6007Z'
											fill='#2E353A'
										/>
										<path
											d='M138.732 78.0748C139.022 78.0748 139.095 77.9285 139.131 77.7822H139.385V80.1958H139.022V78.3673H138.732V78.0748Z'
											fill='#2E353A'
										/>
										<path
											d='M138.841 86.5588C138.841 86.7416 138.913 86.8147 139.022 86.8147C139.131 86.8147 139.203 86.7416 139.203 86.5588V85.2423C139.203 85.0594 139.131 84.9863 139.022 84.9863C138.913 84.9863 138.841 85.0594 138.841 85.2423V86.5588ZM138.479 85.2423C138.479 84.84 138.696 84.6206 139.058 84.6206C139.421 84.6206 139.638 84.84 139.638 85.2423V86.4856C139.638 86.8879 139.421 87.1073 139.058 87.1073C138.696 87.1073 138.479 86.8879 138.479 86.4856V85.2423Z'
											fill='#2E353A'
										/>
										<path
											d='M138.732 95.3716C139.022 95.3716 139.095 95.2254 139.131 95.0791H139.385V97.4926H139.022V95.6642H138.732V95.3716Z'
											fill='#2E353A'
										/>
										<path
											d='M138.841 100.382C138.841 100.564 138.913 100.638 139.022 100.638C139.131 100.638 139.203 100.564 139.203 100.382V99.0651C139.203 98.8822 139.131 98.8091 139.022 98.8091C138.913 98.8091 138.841 98.8822 138.841 99.0651V100.382ZM138.479 99.1017C138.479 98.6994 138.696 98.48 139.058 98.48C139.421 98.48 139.638 98.6994 139.638 99.1017V100.345C139.638 100.747 139.421 100.967 139.058 100.967C138.696 100.967 138.479 100.747 138.479 100.345V99.1017Z'
											fill='#2E353A'
										/>
										<path
											d='M138.732 102.283C139.022 102.283 139.095 102.137 139.131 101.991H139.385V104.404H139.022V102.576H138.732V102.283Z'
											fill='#2E353A'
										/>
										<path
											d='M138.732 105.721C139.022 105.721 139.095 105.574 139.131 105.428H139.385V107.842H139.022V106.013H138.732V105.721Z'
											fill='#2E353A'
										/>
										<path
											d='M138.732 109.194C139.022 109.194 139.095 109.048 139.131 108.902H139.385V111.315H139.022V109.487H138.732V109.194Z'
											fill='#2E353A'
										/>
										<path
											d='M138.841 114.205C138.841 114.388 138.913 114.461 139.022 114.461C139.131 114.461 139.203 114.388 139.203 114.205V112.888C139.203 112.705 139.131 112.632 139.022 112.632C138.913 112.632 138.841 112.705 138.841 112.888V114.205ZM138.479 112.925C138.479 112.523 138.696 112.303 139.058 112.303C139.421 112.303 139.638 112.523 139.638 112.925V114.168C139.638 114.57 139.421 114.79 139.058 114.79C138.696 114.79 138.479 114.57 138.479 114.168V112.925Z'
											fill='#2E353A'
										/>
										<path
											d='M138.841 117.678C138.841 117.861 138.913 117.934 139.022 117.934C139.131 117.934 139.203 117.861 139.203 117.678V116.362C139.203 116.179 139.131 116.106 139.022 116.106C138.913 116.106 138.841 116.179 138.841 116.362V117.678ZM138.479 116.399C138.479 115.996 138.696 115.777 139.058 115.777C139.421 115.777 139.638 115.996 139.638 116.399V117.642C139.638 118.044 139.421 118.264 139.058 118.264C138.696 118.264 138.479 118.044 138.479 117.642V116.399Z'
											fill='#2E353A'
										/>
										<path
											d='M134.674 95.3716C134.964 95.3716 135.036 95.2254 135.072 95.0791H135.326V97.4926H134.964V95.6642H134.674V95.3716Z'
											fill='#2E353A'
										/>
										<path
											d='M134.782 100.382C134.782 100.564 134.855 100.638 134.963 100.638C135.072 100.638 135.145 100.564 135.145 100.382V99.0651C135.145 98.8822 135.072 98.8091 134.963 98.8091C134.855 98.8091 134.782 98.8822 134.782 99.0651V100.382ZM134.42 99.1017C134.42 98.6994 134.637 98.48 135 98.48C135.362 98.48 135.579 98.6994 135.579 99.1017V100.345C135.579 100.747 135.362 100.967 135 100.967C134.637 100.967 134.42 100.747 134.42 100.345V99.1017Z'
											fill='#2E353A'
										/>
										<path
											d='M134.782 103.856C134.782 104.038 134.855 104.112 134.963 104.112C135.072 104.112 135.145 104.038 135.145 103.856V102.539C135.145 102.356 135.072 102.283 134.963 102.283C134.855 102.283 134.782 102.356 134.782 102.539V103.856ZM134.42 102.539C134.42 102.137 134.637 101.917 135 101.917C135.362 101.917 135.579 102.137 135.579 102.539V103.782C135.579 104.185 135.362 104.404 135 104.404C134.637 104.404 134.42 104.185 134.42 103.782V102.539Z'
											fill='#2E353A'
										/>
										<path
											d='M134.674 105.721C134.964 105.721 135.036 105.574 135.072 105.428H135.326V107.842H134.964V106.013H134.674V105.721Z'
											fill='#2E353A'
										/>
										<path
											d='M134.674 112.669C134.964 112.669 135.036 112.522 135.072 112.376H135.326V114.79H134.964V112.961H134.674V112.669Z'
											fill='#2E353A'
										/>
										<path
											d='M134.674 116.106C134.964 116.106 135.036 115.96 135.072 115.813H135.326V118.227H134.964V116.399H134.674V116.106Z'
											fill='#2E353A'
										/>
										<path
											d='M134.674 119.58C134.964 119.58 135.036 119.434 135.072 119.288H135.326V121.701H134.964V119.873H134.674V119.58Z'
											fill='#2E353A'
										/>
										<path
											d='M132.754 86.5588C132.754 86.7416 132.826 86.8147 132.935 86.8147C133.044 86.8147 133.116 86.7416 133.116 86.5588V85.2423C133.116 85.0594 133.044 84.9863 132.935 84.9863C132.826 84.9863 132.754 85.0594 132.754 85.2423V86.5588ZM132.355 85.2423C132.355 84.84 132.573 84.6206 132.935 84.6206C133.298 84.6206 133.515 84.84 133.515 85.2423V86.4856C133.515 86.8879 133.298 87.1073 132.935 87.1073C132.573 87.1073 132.355 86.8879 132.355 86.4856V85.2423Z'
											fill='#2E353A'
										/>
										<path
											d='M132.754 93.4699C132.754 93.6528 132.826 93.7259 132.935 93.7259C133.044 93.7259 133.116 93.6528 133.116 93.4699V92.1535C133.116 91.9706 133.044 91.8975 132.935 91.8975C132.826 91.8975 132.754 91.9706 132.754 92.1535V93.4699ZM132.355 92.19C132.355 91.7878 132.573 91.5684 132.935 91.5684C133.298 91.5684 133.515 91.7878 133.515 92.19V93.4334C133.515 93.8356 133.298 94.055 132.935 94.055C132.573 94.055 132.355 93.8356 132.355 93.4334V92.19Z'
											fill='#2E353A'
										/>
										<path
											d='M132.645 102.283C132.934 102.283 133.007 102.137 133.043 101.991H133.297V104.404H132.934V102.576H132.645V102.283Z'
											fill='#2E353A'
										/>
										<path
											d='M132.645 105.721C132.934 105.721 133.007 105.574 133.043 105.428H133.297V107.842H132.934V106.013H132.645V105.721Z'
											fill='#2E353A'
										/>
										<path
											d='M132.645 116.106C132.934 116.106 133.007 115.96 133.043 115.813H133.297V118.227H132.934V116.399H132.645V116.106Z'
											fill='#2E353A'
										/>
										<path
											d='M132.754 121.116C132.754 121.299 132.826 121.372 132.935 121.372C133.044 121.372 133.116 121.299 133.116 121.116V119.799C133.116 119.617 133.044 119.543 132.935 119.543C132.826 119.543 132.754 119.617 132.754 119.799V121.116ZM132.355 119.836C132.355 119.434 132.573 119.214 132.935 119.214C133.298 119.214 133.515 119.434 133.515 119.836V121.079C133.515 121.482 133.298 121.701 132.935 121.701C132.573 121.701 132.355 121.482 132.355 121.079V119.836Z'
											fill='#2E353A'
										/>
										<path
											d='M132.645 123.018C132.934 123.018 133.007 122.871 133.043 122.725H133.297V125.139H132.934V123.31H132.645V123.018Z'
											fill='#2E353A'
										/>
										<path
											d='M48.3701 90.2521C48.3701 90.435 48.4426 90.5081 48.5513 90.5081C48.66 90.5081 48.7325 90.435 48.7325 90.2521V88.9356C48.7325 88.7528 48.66 88.6797 48.5513 88.6797C48.4426 88.6797 48.3701 88.7528 48.3701 88.9356V90.2521ZM48.0078 88.9356C48.0078 88.5334 48.2252 88.314 48.5875 88.314C48.9498 88.314 49.1672 88.5334 49.1672 88.9356V90.179C49.1672 90.5812 48.9498 90.8006 48.5875 90.8006C48.2252 90.8006 48.0078 90.5812 48.0078 90.179V88.9356Z'
											fill='#2E353A'
										/>
										<path
											d='M48.3701 93.6897C48.3701 93.8725 48.4426 93.9456 48.5513 93.9456C48.66 93.9456 48.7325 93.8725 48.7325 93.6897V92.3732C48.7325 92.1903 48.66 92.1172 48.5513 92.1172C48.4426 92.1172 48.3701 92.1903 48.3701 92.3732V93.6897ZM48.0078 92.4098C48.0078 92.0075 48.2252 91.7881 48.5875 91.7881C48.9498 91.7881 49.1672 92.0075 49.1672 92.4098V93.6531C49.1672 94.0554 48.9498 94.2748 48.5875 94.2748C48.2252 94.2748 48.0078 94.0554 48.0078 93.6531V92.4098Z'
											fill='#2E353A'
										/>
										<path
											d='M48.2617 95.5909C48.5516 95.5909 48.624 95.4446 48.6603 95.2983H48.9139V97.7119H48.5516V95.8834H48.2617V95.5909Z'
											fill='#2E353A'
										/>
										<path
											d='M48.3701 100.601C48.3701 100.784 48.4426 100.857 48.5513 100.857C48.66 100.857 48.7325 100.784 48.7325 100.601V99.2843C48.7325 99.1015 48.66 99.0283 48.5513 99.0283C48.4426 99.0283 48.3701 99.1015 48.3701 99.2843V100.601ZM48.0078 99.3209C48.0078 98.9186 48.2252 98.6992 48.5875 98.6992C48.9498 98.6992 49.1672 98.9186 49.1672 99.3209V100.564C49.1672 100.966 48.9498 101.186 48.5875 101.186C48.2252 101.186 48.0078 100.966 48.0078 100.564V99.3209Z'
											fill='#2E353A'
										/>
										<path
											d='M48.2617 102.503C48.5516 102.503 48.624 102.356 48.6603 102.21H48.9139V104.624H48.5516V102.795H48.2617V102.503Z'
											fill='#2E353A'
										/>
										<path
											d='M48.3701 107.512C48.3701 107.695 48.4426 107.768 48.5513 107.768C48.66 107.768 48.7325 107.695 48.7325 107.512V106.196C48.7325 106.013 48.66 105.94 48.5513 105.94C48.4426 105.94 48.3701 106.013 48.3701 106.196V107.512ZM48.0078 106.233C48.0078 105.83 48.2252 105.611 48.5875 105.611C48.9498 105.611 49.1672 105.83 49.1672 106.233V107.476C49.1672 107.878 48.9498 108.098 48.5875 108.098C48.2252 108.098 48.0078 107.878 48.0078 107.476V106.233Z'
											fill='#2E353A'
										/>
										<path
											d='M48.2617 109.414C48.5516 109.414 48.624 109.268 48.6603 109.122H48.9139V111.535H48.5516V109.707H48.2617V109.414Z'
											fill='#2E353A'
										/>
										<path
											d='M48.3701 114.461C48.3701 114.644 48.4426 114.717 48.5513 114.717C48.66 114.717 48.7325 114.644 48.7325 114.461V113.144C48.7325 112.961 48.66 112.888 48.5513 112.888C48.4426 112.888 48.3701 112.961 48.3701 113.144V114.461ZM48.0078 113.181C48.0078 112.778 48.2252 112.559 48.5875 112.559C48.9498 112.559 49.1672 112.778 49.1672 113.181V114.424C49.1672 114.826 48.9498 115.046 48.5875 115.046C48.2252 115.046 48.0078 114.826 48.0078 114.424V113.181Z'
											fill='#2E353A'
										/>
										<path
											d='M48.3701 117.898C48.3701 118.081 48.4426 118.154 48.5513 118.154C48.66 118.154 48.7325 118.081 48.7325 117.898V116.582C48.7325 116.399 48.66 116.326 48.5513 116.326C48.4426 116.326 48.3701 116.399 48.3701 116.582V117.898ZM48.0078 116.618C48.0078 116.216 48.2252 115.997 48.5875 115.997C48.9498 115.997 49.1672 116.216 49.1672 116.618V117.862C49.1672 118.264 48.9498 118.483 48.5875 118.483C48.2252 118.483 48.0078 118.264 48.0078 117.862V116.618Z'
											fill='#2E353A'
										/>
										<path
											d='M48.3701 121.372C48.3701 121.555 48.4426 121.628 48.5513 121.628C48.66 121.628 48.7325 121.555 48.7325 121.372V120.056C48.7325 119.873 48.66 119.8 48.5513 119.8C48.4426 119.8 48.3701 119.873 48.3701 120.056V121.372ZM48.0078 120.092C48.0078 119.69 48.2252 119.471 48.5875 119.471C48.9498 119.471 49.1672 119.69 49.1672 120.092V121.336C49.1672 121.738 48.9498 121.957 48.5875 121.957C48.2252 121.957 48.0078 121.738 48.0078 121.336V120.092Z'
											fill='#2E353A'
										/>
										<path
											d='M48.2617 123.274C48.5516 123.274 48.624 123.127 48.6603 122.981H48.9139V125.395H48.5516V123.566H48.2617V123.274Z'
											fill='#2E353A'
										/>
										<path
											d='M48.2617 126.711C48.5516 126.711 48.624 126.565 48.6603 126.418H48.9139V128.832H48.5516V127.004H48.2617V126.711Z'
											fill='#2E353A'
										/>
										<path
											d='M48.2617 130.185C48.5516 130.185 48.624 130.039 48.6603 129.893H48.9139V132.306H48.5516V130.478H48.2617V130.185Z'
											fill='#2E353A'
										/>
										<path
											d='M48.2617 133.659C48.5516 133.659 48.624 133.513 48.6603 133.367H48.9139V135.78H48.5516V133.952H48.2617V133.659Z'
											fill='#2E353A'
										/>
										<path
											d='M48.3691 138.669C48.3691 138.852 48.4416 138.925 48.5503 138.925C48.659 138.925 48.7315 138.852 48.7315 138.669V137.353C48.7315 137.17 48.659 137.097 48.5503 137.097C48.4416 137.097 48.3691 137.17 48.3691 137.353V138.669Z'
											fill='#2E353A'
										/>
										<path
											d='M50.2891 102.503C50.5789 102.503 50.6514 102.356 50.6876 102.21H50.9412V104.624H50.5789V102.795H50.2891V102.503Z'
											fill='#2E353A'
										/>
										<path
											d='M50.2891 105.977C50.5789 105.977 50.6514 105.83 50.6876 105.684H50.9412V108.098H50.5789V106.269H50.2891V105.977Z'
											fill='#2E353A'
										/>
										<path
											d='M50.3994 114.461C50.3994 114.644 50.4719 114.717 50.5806 114.717C50.6893 114.717 50.7617 114.644 50.7617 114.461V113.144C50.7617 112.961 50.6893 112.888 50.5806 112.888C50.4719 112.888 50.3994 112.961 50.3994 113.144V114.461ZM50.0371 113.181C50.0371 112.778 50.2545 112.559 50.6168 112.559C50.9791 112.559 51.1965 112.778 51.1965 113.181V114.424C51.1965 114.826 50.9791 115.046 50.6168 115.046C50.2545 115.046 50.0371 114.826 50.0371 114.424V113.181Z'
											fill='#2E353A'
										/>
										<path
											d='M50.2891 116.362C50.5789 116.362 50.6514 116.216 50.6876 116.07H50.9412V118.483H50.5789V116.655H50.2891V116.362Z'
											fill='#2E353A'
										/>
										<path
											d='M50.3994 121.372C50.3994 121.555 50.4719 121.628 50.5806 121.628C50.6893 121.628 50.7617 121.555 50.7617 121.372V120.056C50.7617 119.873 50.6893 119.8 50.5806 119.8C50.4719 119.8 50.3994 119.873 50.3994 120.056V121.372ZM50.0371 120.092C50.0371 119.69 50.2545 119.471 50.6168 119.471C50.9791 119.471 51.1965 119.69 51.1965 120.092V121.336C51.1965 121.738 50.9791 121.957 50.6168 121.957C50.2545 121.957 50.0371 121.738 50.0371 121.336V120.092Z'
											fill='#2E353A'
										/>
										<path
											d='M50.3984 128.283C50.3984 128.466 50.4709 128.539 50.5796 128.539C50.6883 128.539 50.7608 128.466 50.7608 128.283V126.967C50.7608 126.784 50.6883 126.711 50.5796 126.711C50.4709 126.711 50.3984 126.784 50.3984 126.967V128.283Z'
											fill='#2E353A'
										/>
										<path
											d='M50.2891 130.185C50.5789 130.185 50.6514 130.039 50.6876 129.893H50.9412V132.306H50.5789V130.478H50.2891V130.185Z'
											fill='#2E353A'
										/>
										<path
											d='M50.2891 133.659C50.5789 133.659 50.6514 133.513 50.6876 133.367H50.9412V135.78H50.5789V133.952H50.2891V133.659Z'
											fill='#2E353A'
										/>
										<path
											d='M50.3994 145.581C50.3994 145.764 50.4719 145.837 50.5806 145.837C50.6893 145.837 50.7617 145.764 50.7617 145.581V144.264C50.7617 144.081 50.6893 144.008 50.5806 144.008C50.4719 144.008 50.3994 144.081 50.3994 144.264V145.581ZM50.0371 144.301C50.0371 143.899 50.2545 143.679 50.6168 143.679C50.9791 143.679 51.1965 143.899 51.1965 144.301V145.544C51.1965 145.946 50.9791 146.166 50.6168 146.166C50.2545 146.166 50.0371 145.946 50.0371 145.544V144.301Z'
											fill='#2E353A'
										/>
										<path
											d='M46.34 100.601C46.34 100.784 46.4124 100.857 46.5211 100.857C46.6298 100.857 46.7023 100.784 46.7023 100.601V99.2843C46.7023 99.1015 46.6298 99.0283 46.5211 99.0283C46.4124 99.0283 46.34 99.1015 46.34 99.2843V100.601ZM45.9414 99.3209C45.9414 98.9186 46.1588 98.6992 46.5211 98.6992C46.8834 98.6992 47.1008 98.9186 47.1008 99.3209V100.564C47.1008 100.966 46.8834 101.186 46.5211 101.186C46.1588 101.186 45.9414 100.966 45.9414 100.564V99.3209Z'
											fill='#2E353A'
										/>
										<path
											d='M46.2324 102.503C46.5223 102.503 46.5947 102.356 46.631 102.21H46.8846V104.624H46.5223V102.795H46.2324V102.503Z'
											fill='#2E353A'
										/>
										<path
											d='M46.2324 105.977C46.5223 105.977 46.5947 105.83 46.631 105.684H46.8846V108.098H46.5223V106.269H46.2324V105.977Z'
											fill='#2E353A'
										/>
										<path
											d='M46.34 110.987C46.34 111.169 46.4124 111.243 46.5211 111.243C46.6298 111.243 46.7023 111.169 46.7023 110.987V109.67C46.7023 109.487 46.6298 109.414 46.5211 109.414C46.4124 109.414 46.34 109.487 46.34 109.67V110.987ZM45.9414 109.707C45.9414 109.304 46.1588 109.085 46.5211 109.085C46.8834 109.085 47.1008 109.304 47.1008 109.707V110.95C47.1008 111.352 46.8834 111.572 46.5211 111.572C46.1588 111.572 45.9414 111.352 45.9414 110.95V109.707Z'
											fill='#2E353A'
										/>
										<path
											d='M46.34 117.898C46.34 118.081 46.4124 118.154 46.5211 118.154C46.6298 118.154 46.7023 118.081 46.7023 117.898V116.582C46.7023 116.399 46.6298 116.326 46.5211 116.326C46.4124 116.326 46.34 116.399 46.34 116.582V117.898ZM45.9414 116.618C45.9414 116.216 46.1588 115.997 46.5211 115.997C46.8834 115.997 47.1008 116.216 47.1008 116.618V117.862C47.1008 118.264 46.8834 118.483 46.5211 118.483C46.1588 118.483 45.9414 118.264 45.9414 117.862V116.618Z'
											fill='#2E353A'
										/>
										<path
											d='M46.34 121.372C46.34 121.555 46.4124 121.628 46.5211 121.628C46.6298 121.628 46.7023 121.555 46.7023 121.372V120.056C46.7023 119.873 46.6298 119.8 46.5211 119.8C46.4124 119.8 46.34 119.873 46.34 120.056V121.372ZM45.9414 120.092C45.9414 119.69 46.1588 119.471 46.5211 119.471C46.8834 119.471 47.1008 119.69 47.1008 120.092V121.336C47.1008 121.738 46.8834 121.957 46.5211 121.957C46.1588 121.957 45.9414 121.738 45.9414 121.336V120.092Z'
											fill='#2E353A'
										/>
										<path
											d='M46.2324 123.274C46.5223 123.274 46.5947 123.127 46.631 122.981H46.8846V125.395H46.5223V123.566H46.2324V123.274Z'
											fill='#2E353A'
										/>
										<path
											d='M46.34 128.283C46.34 128.466 46.4124 128.539 46.5211 128.539C46.6298 128.539 46.7023 128.466 46.7023 128.283V126.967C46.7023 126.784 46.6298 126.711 46.5211 126.711C46.4124 126.711 46.34 126.784 46.34 126.967V128.283ZM45.9414 127.003C45.9414 126.601 46.1588 126.382 46.5211 126.382C46.8834 126.382 47.1008 126.601 47.1008 127.003V128.247C47.1008 128.649 46.8834 128.869 46.5211 128.869C46.1588 128.869 45.9414 128.649 45.9414 128.247V127.003Z'
											fill='#2E353A'
										/>
										<path
											d='M46.2324 130.185C46.5223 130.185 46.5947 130.039 46.631 129.893H46.8846V132.306H46.5223V130.478H46.2324V130.185Z'
											fill='#2E353A'
										/>
										<path
											d='M44.3107 93.6897C44.3107 93.8725 44.3831 93.9456 44.4918 93.9456C44.6005 93.9456 44.673 93.8725 44.673 93.6897V92.3732C44.673 92.1903 44.6005 92.1172 44.4918 92.1172C44.3831 92.1172 44.3107 92.1903 44.3107 92.3732V93.6897ZM43.9121 92.4098C43.9121 92.0075 44.1295 91.7881 44.4918 91.7881C44.8541 91.7881 45.0715 92.0075 45.0715 92.4098V93.6531C45.0715 94.0554 44.8541 94.2748 44.4918 94.2748C44.1295 94.2748 43.9121 94.0554 43.9121 93.6531V92.4098Z'
											fill='#2E353A'
										/>
										<path
											d='M44.166 99.065C44.4559 99.065 44.5283 98.9187 44.5646 98.7725H44.8182V101.186H44.4559V99.3576H44.166V99.065Z'
											fill='#2E353A'
										/>
										<path
											d='M44.166 105.977C44.4559 105.977 44.5283 105.83 44.5646 105.684H44.8182V108.098H44.4559V106.269H44.166V105.977Z'
											fill='#2E353A'
										/>
										<path
											d='M44.3107 110.987C44.3107 111.169 44.3831 111.243 44.4918 111.243C44.6005 111.243 44.673 111.169 44.673 110.987V109.67C44.673 109.487 44.6005 109.414 44.4918 109.414C44.3831 109.414 44.3107 109.487 44.3107 109.67V110.987ZM43.9121 109.707C43.9121 109.304 44.1295 109.085 44.4918 109.085C44.8541 109.085 45.0715 109.304 45.0715 109.707V110.95C45.0715 111.352 44.8541 111.572 44.4918 111.572C44.1295 111.572 43.9121 111.352 43.9121 110.95V109.707Z'
											fill='#2E353A'
										/>
										<path
											d='M44.166 119.799C44.4559 119.799 44.5283 119.653 44.5646 119.507H44.8182V121.92H44.4559V120.092H44.166V119.799Z'
											fill='#2E353A'
										/>
										<path
											d='M44.166 123.274C44.4559 123.274 44.5283 123.127 44.5646 122.981H44.8182V125.395H44.4559V123.566H44.166V123.274Z'
											fill='#2E353A'
										/>
										<path
											d='M44.166 126.711C44.4559 126.711 44.5283 126.565 44.5646 126.418H44.8182V128.832H44.4559V127.004H44.166V126.711Z'
											fill='#2E353A'
										/>
										<path
											d='M108.37 10.4953C108.37 10.6782 108.443 10.7513 108.551 10.7513C108.66 10.7513 108.732 10.6782 108.732 10.4953V9.17885C108.732 8.99601 108.66 8.92287 108.551 8.92287C108.443 8.92287 108.37 8.99601 108.37 9.17885V10.4953ZM108.008 9.21542C108.008 8.81316 108.225 8.59375 108.588 8.59375C108.95 8.59375 109.167 8.81316 109.167 9.21542V10.4588C109.167 10.861 108.95 11.0804 108.588 11.0804C108.225 11.0804 108.008 10.861 108.008 10.4588V9.21542Z'
											fill='#2E353A'
										/>
										<path
											d='M108.37 13.9695C108.37 14.1523 108.443 14.2254 108.551 14.2254C108.66 14.2254 108.732 14.1523 108.732 13.9695V12.653C108.732 12.4701 108.66 12.397 108.551 12.397C108.443 12.397 108.37 12.4701 108.37 12.653V13.9695ZM108.008 12.6895C108.008 12.2873 108.225 12.0679 108.588 12.0679C108.95 12.0679 109.167 12.2873 109.167 12.6895V13.9329C109.167 14.3351 108.95 14.5546 108.588 14.5546C108.225 14.5546 108.008 14.3351 108.008 13.9329V12.6895Z'
											fill='#2E353A'
										/>
										<path
											d='M108.262 22.7823C108.552 22.7823 108.624 22.636 108.66 22.4897H108.914V24.9033H108.552V23.0748H108.262V22.7823Z'
											fill='#2E353A'
										/>
										<path
											d='M108.262 26.2198C108.552 26.2198 108.624 26.0735 108.66 25.9272H108.914V28.3408H108.552V26.5123H108.262V26.2198Z'
											fill='#2E353A'
										/>
										<path
											d='M108.37 38.1779C108.37 38.3608 108.443 38.4339 108.551 38.4339C108.66 38.4339 108.732 38.3608 108.732 38.1779V36.8615C108.732 36.6786 108.66 36.6055 108.551 36.6055C108.443 36.6055 108.37 36.6786 108.37 36.8615V38.1779ZM108.008 36.898C108.008 36.4958 108.225 36.2764 108.588 36.2764C108.95 36.2764 109.167 36.4958 109.167 36.898V38.1414C109.167 38.5436 108.95 38.7631 108.588 38.7631C108.225 38.7631 108.008 38.5436 108.008 38.1414V36.898Z'
											fill='#2E353A'
										/>
										<path
											d='M108.37 45.0896C108.37 45.2724 108.443 45.3456 108.551 45.3456C108.66 45.3456 108.732 45.2724 108.732 45.0896V43.7731C108.732 43.5902 108.66 43.5171 108.551 43.5171C108.443 43.5171 108.37 43.5902 108.37 43.7731V45.0896ZM108.008 43.8097C108.008 43.4074 108.225 43.188 108.588 43.188C108.95 43.188 109.167 43.4074 109.167 43.8097V45.053C109.167 45.4553 108.95 45.6747 108.588 45.6747C108.225 45.6747 108.008 45.4553 108.008 45.053V43.8097Z'
											fill='#2E353A'
										/>
										<path
											d='M102.283 17.407C102.283 17.5898 102.356 17.6629 102.464 17.6629C102.573 17.6629 102.646 17.5898 102.646 17.407V16.0905C102.646 15.9076 102.573 15.8345 102.464 15.8345C102.356 15.8345 102.283 15.9076 102.283 16.0905V17.407ZM101.885 16.127C101.885 15.7248 102.102 15.5054 102.464 15.5054C102.827 15.5054 103.044 15.7248 103.044 16.127V17.3704C103.044 17.7726 102.827 17.9921 102.464 17.9921C102.102 17.9921 101.885 17.7726 101.885 17.3704V16.127Z'
											fill='#2E353A'
										/>
										<path
											d='M102.283 20.8806C102.283 21.0634 102.356 21.1366 102.464 21.1366C102.573 21.1366 102.646 21.0634 102.646 20.8806V19.5641C102.646 19.3813 102.573 19.3081 102.464 19.3081C102.356 19.3081 102.283 19.3813 102.283 19.5641V20.8806ZM101.885 19.6007C101.885 19.1984 102.102 18.979 102.464 18.979C102.827 18.979 103.044 19.1984 103.044 19.6007V20.844C103.044 21.2463 102.827 21.4657 102.464 21.4657C102.102 21.4657 101.885 21.2463 101.885 20.844V19.6007Z'
											fill='#2E353A'
										/>
										<path
											d='M102.283 24.3181C102.283 24.5009 102.356 24.5741 102.464 24.5741C102.573 24.5741 102.646 24.5009 102.646 24.3181V23.0382C102.646 22.8553 102.573 22.7822 102.464 22.7822C102.356 22.7822 102.283 22.8553 102.283 23.0382V24.3181ZM101.885 23.0382C101.885 22.6359 102.102 22.4165 102.464 22.4165C102.827 22.4165 103.044 22.6359 103.044 23.0382V24.2815C103.044 24.6838 102.827 24.9032 102.464 24.9032C102.102 24.9032 101.885 24.6838 101.885 24.2815V23.0382Z'
											fill='#2E353A'
										/>
										<path
											d='M102.137 26.2198C102.427 26.2198 102.499 26.0735 102.535 25.9272H102.789V28.3408H102.427V26.5123H102.137V26.2198Z'
											fill='#2E353A'
										/>
										<path
											d='M102.137 33.168C102.427 33.168 102.499 33.0218 102.535 32.8755H102.789V35.289H102.427V33.4606H102.137V33.168Z'
											fill='#2E353A'
										/>
										<path
											d='M102.137 36.6055C102.427 36.6055 102.499 36.4593 102.535 36.313H102.789V38.7265H102.427V36.8981H102.137V36.6055Z'
											fill='#2E353A'
										/>
										<path
											d='M102.283 45.0896C102.283 45.2724 102.356 45.3456 102.464 45.3456C102.573 45.3456 102.646 45.2724 102.646 45.0896V43.7731C102.646 43.5902 102.573 43.5171 102.464 43.5171C102.356 43.5171 102.283 43.5902 102.283 43.7731V45.0896ZM101.885 43.8097C101.885 43.4074 102.102 43.188 102.464 43.188C102.827 43.188 103.044 43.4074 103.044 43.8097V45.053C103.044 45.4553 102.827 45.6747 102.464 45.6747C102.102 45.6747 101.885 45.4553 101.885 45.053V43.8097Z'
											fill='#2E353A'
										/>
										<path
											d='M102.137 46.9908C102.427 46.9908 102.499 46.8445 102.535 46.6982H102.789V49.1118H102.427V47.2833H102.137V46.9908Z'
											fill='#2E353A'
										/>
										<path
											d='M106.341 10.4953C106.341 10.6782 106.413 10.7513 106.522 10.7513C106.631 10.7513 106.703 10.6782 106.703 10.4953V9.17885C106.703 8.99601 106.631 8.92287 106.522 8.92287C106.413 8.92287 106.341 8.99601 106.341 9.17885V10.4953ZM105.979 9.21542C105.979 8.81316 106.196 8.59375 106.558 8.59375C106.921 8.59375 107.138 8.81316 107.138 9.21542V10.4588C107.138 10.861 106.921 11.0804 106.558 11.0804C106.196 11.0804 105.979 10.861 105.979 10.4588V9.21542Z'
											fill='#2E353A'
										/>
										<path
											d='M106.232 12.397C106.522 12.397 106.595 12.2508 106.631 12.1045H106.885V14.518H106.522V12.6896H106.232V12.397Z'
											fill='#2E353A'
										/>
										<path
											d='M106.341 17.407C106.341 17.5898 106.413 17.6629 106.522 17.6629C106.631 17.6629 106.703 17.5898 106.703 17.407V16.0905C106.703 15.9076 106.631 15.8345 106.522 15.8345C106.413 15.8345 106.341 15.9076 106.341 16.0905V17.407ZM105.979 16.127C105.979 15.7248 106.196 15.5054 106.558 15.5054C106.921 15.5054 107.138 15.7248 107.138 16.127V17.3704C107.138 17.7726 106.921 17.9921 106.558 17.9921C106.196 17.9921 105.979 17.7726 105.979 17.3704V16.127Z'
											fill='#2E353A'
										/>
										<path
											d='M106.232 19.3082C106.522 19.3082 106.595 19.1619 106.631 19.0156H106.885V21.4292H106.522V19.6007H106.232V19.3082Z'
											fill='#2E353A'
										/>
										<path
											d='M106.232 22.7823C106.522 22.7823 106.595 22.636 106.631 22.4897H106.885V24.9033H106.522V23.0748H106.232V22.7823Z'
											fill='#2E353A'
										/>
										<path
											d='M106.232 26.2198C106.522 26.2198 106.595 26.0735 106.631 25.9272H106.885V28.3408H106.522V26.5123H106.232V26.2198Z'
											fill='#2E353A'
										/>
										<path
											d='M106.341 31.2663C106.341 31.4492 106.413 31.5223 106.522 31.5223C106.631 31.5223 106.703 31.4492 106.703 31.2663V29.9498C106.703 29.767 106.631 29.6939 106.522 29.6939C106.413 29.6939 106.341 29.767 106.341 29.9498V31.2663ZM105.979 29.9864C105.979 29.5842 106.196 29.3647 106.558 29.3647C106.921 29.3647 107.138 29.5842 107.138 29.9864V31.2298C107.138 31.632 106.921 31.8514 106.558 31.8514C106.196 31.8514 105.979 31.632 105.979 31.2298V29.9864Z'
											fill='#2E353A'
										/>
										<path
											d='M106.341 34.7038C106.341 34.8867 106.413 34.9598 106.522 34.9598C106.631 34.9598 106.703 34.8867 106.703 34.7038V33.3873C106.703 33.2045 106.631 33.1314 106.522 33.1314C106.413 33.1314 106.341 33.2045 106.341 33.3873V34.7038ZM105.979 33.4239C105.979 33.0217 106.196 32.8022 106.558 32.8022C106.921 32.8022 107.138 33.0217 107.138 33.4239V34.6673C107.138 35.0695 106.921 35.2889 106.558 35.2889C106.196 35.2889 105.979 35.0695 105.979 34.6673V33.4239Z'
											fill='#2E353A'
										/>
										<path
											d='M104.203 12.397C104.493 12.397 104.565 12.2508 104.602 12.1045H104.855V14.518H104.493V12.6896H104.203V12.397Z'
											fill='#2E353A'
										/>
										<path
											d='M104.311 17.407C104.311 17.5898 104.383 17.6629 104.492 17.6629C104.601 17.6629 104.673 17.5898 104.673 17.407V16.0905C104.673 15.9076 104.601 15.8345 104.492 15.8345C104.383 15.8345 104.311 15.9076 104.311 16.0905V17.407ZM103.912 16.127C103.912 15.7248 104.13 15.5054 104.492 15.5054C104.854 15.5054 105.072 15.7248 105.072 16.127V17.3704C105.072 17.7726 104.854 17.9921 104.492 17.9921C104.13 17.9921 103.912 17.7726 103.912 17.3704V16.127Z'
											fill='#2E353A'
										/>
										<path
											d='M104.311 20.8806C104.311 21.0634 104.383 21.1366 104.492 21.1366C104.601 21.1366 104.673 21.0634 104.673 20.8806V19.5641C104.673 19.3813 104.601 19.3081 104.492 19.3081C104.383 19.3081 104.311 19.3813 104.311 19.5641V20.8806ZM103.912 19.6007C103.912 19.1984 104.13 18.979 104.492 18.979C104.854 18.979 105.072 19.1984 105.072 19.6007V20.844C105.072 21.2463 104.854 21.4657 104.492 21.4657C104.13 21.4657 103.912 21.2463 103.912 20.844V19.6007Z'
											fill='#2E353A'
										/>
										<path
											d='M104.203 22.7823C104.493 22.7823 104.565 22.636 104.602 22.4897H104.855V24.9033H104.493V23.0748H104.203V22.7823Z'
											fill='#2E353A'
										/>
										<path
											d='M104.203 29.6939C104.493 29.6939 104.565 29.5476 104.602 29.4014H104.855V31.8149H104.493V29.9865H104.203V29.6939Z'
											fill='#2E353A'
										/>
										<path
											d='M104.203 33.168C104.493 33.168 104.565 33.0218 104.602 32.8755H104.855V35.289H104.493V33.4606H104.203V33.168Z'
											fill='#2E353A'
										/>
										<path
											d='M104.203 36.6055C104.493 36.6055 104.565 36.4593 104.602 36.313H104.855V38.7265H104.493V36.8981H104.203V36.6055Z'
											fill='#2E353A'
										/>
										<path
											d='M12.4639 48.7829C12.4639 48.9658 12.5363 49.0389 12.645 49.0389C12.7537 49.0389 12.8262 48.9658 12.8262 48.7829V47.4665C12.8262 47.2836 12.7537 47.2105 12.645 47.2105C12.5363 47.2105 12.4639 47.2836 12.4639 47.4665V48.7829ZM12.1016 47.503C12.1016 47.1008 12.319 46.8813 12.6813 46.8813C13.0436 46.8813 13.261 47.1008 13.261 47.503V48.7464C13.261 49.1486 13.0436 49.368 12.6813 49.368C12.319 49.368 12.1016 49.1486 12.1016 48.7464V47.503Z'
											fill='#2E353A'
										/>
										<path
											d='M12.4639 52.257C12.4639 52.4399 12.5363 52.513 12.645 52.513C12.7537 52.513 12.8262 52.4399 12.8262 52.257V50.9406C12.8262 50.7577 12.7537 50.6846 12.645 50.6846C12.5363 50.6846 12.4639 50.7577 12.4639 50.9406V52.257ZM12.1016 50.9771C12.1016 50.5749 12.319 50.3555 12.6813 50.3555C13.0436 50.3555 13.261 50.5749 13.261 50.9771V52.2205C13.261 52.6227 13.0436 52.8422 12.6813 52.8422C12.319 52.8422 12.1016 52.6227 12.1016 52.2205V50.9771Z'
											fill='#2E353A'
										/>
										<path
											d='M12.3555 54.1583C12.6453 54.1583 12.7178 54.012 12.754 53.8657H13.0076V56.2793H12.6453V54.4508H12.3555V54.1583Z'
											fill='#2E353A'
										/>
										<path
											d='M12.4639 59.1682C12.4639 59.351 12.5363 59.4242 12.645 59.4242C12.7537 59.4242 12.8262 59.351 12.8262 59.1682V57.8517C12.8262 57.6689 12.7537 57.5957 12.645 57.5957C12.5363 57.5957 12.4639 57.6689 12.4639 57.8517V59.1682ZM12.1016 57.8883C12.1016 57.486 12.319 57.2666 12.6813 57.2666C13.0436 57.2666 13.261 57.486 13.261 57.8883V59.1316C13.261 59.5339 13.0436 59.7533 12.6813 59.7533C12.319 59.7533 12.1016 59.5339 12.1016 59.1316V57.8883Z'
											fill='#2E353A'
										/>
										<path
											d='M12.3555 61.0699C12.6453 61.0699 12.7178 60.9236 12.754 60.7773H13.0076V63.1909H12.6453V61.3624H12.3555V61.0699Z'
											fill='#2E353A'
										/>
										<path
											d='M12.4639 66.0798C12.4639 66.2626 12.5363 66.3358 12.645 66.3358C12.7537 66.3358 12.8262 66.2626 12.8262 66.0798V64.7633C12.8262 64.5805 12.7537 64.5073 12.645 64.5073C12.5363 64.5073 12.4639 64.5805 12.4639 64.7633V66.0798ZM12.1016 64.7999C12.1016 64.3976 12.319 64.1782 12.6813 64.1782C13.0436 64.1782 13.261 64.3976 13.261 64.7999V66.0432C13.261 66.4455 13.0436 66.6649 12.6813 66.6649C12.319 66.6649 12.1016 66.4455 12.1016 66.0432V64.7999Z'
											fill='#2E353A'
										/>
										<path
											d='M12.3555 67.9815C12.6453 67.9815 12.7178 67.8352 12.754 67.689H13.0076V70.1025H12.6453V68.2741H12.3555V67.9815Z'
											fill='#2E353A'
										/>
										<path
											d='M12.4639 73.028C12.4639 73.2109 12.5363 73.284 12.645 73.284C12.7537 73.284 12.8262 73.2109 12.8262 73.028V71.7116C12.8262 71.5287 12.7537 71.4556 12.645 71.4556C12.5363 71.4556 12.4639 71.5287 12.4639 71.7116V73.028ZM12.1016 71.7481C12.1016 71.3459 12.319 71.1265 12.6813 71.1265C13.0436 71.1265 13.261 71.3459 13.261 71.7481V72.9915C13.261 73.3937 13.0436 73.6131 12.6813 73.6131C12.319 73.6131 12.1016 73.3937 12.1016 72.9915V71.7481Z'
											fill='#2E353A'
										/>
										<path
											d='M12.4639 76.4655C12.4639 76.6484 12.5363 76.7215 12.645 76.7215C12.7537 76.7215 12.8262 76.6484 12.8262 76.4655V75.1491C12.8262 74.9662 12.7537 74.8931 12.645 74.8931C12.5363 74.8931 12.4639 74.9662 12.4639 75.1491V76.4655ZM12.1016 75.1856C12.1016 74.7834 12.319 74.564 12.6813 74.564C13.0436 74.564 13.261 74.7834 13.261 75.1856V76.429C13.261 76.8312 13.0436 77.0506 12.6813 77.0506C12.319 77.0506 12.1016 76.8312 12.1016 76.429V75.1856Z'
											fill='#2E353A'
										/>
										<path
											d='M12.4639 79.9397C12.4639 80.1225 12.5363 80.1957 12.645 80.1957C12.7537 80.1957 12.8262 80.1225 12.8262 79.9397V78.6232C12.8262 78.4403 12.7537 78.3672 12.645 78.3672C12.5363 78.3672 12.4639 78.4403 12.4639 78.6232V79.9397ZM12.1016 78.6598C12.1016 78.2575 12.319 78.0381 12.6813 78.0381C13.0436 78.0381 13.261 78.2575 13.261 78.6598V79.9031C13.261 80.3054 13.0436 80.5248 12.6813 80.5248C12.319 80.5248 12.1016 80.3054 12.1016 79.9031V78.6598Z'
											fill='#2E353A'
										/>
										<path
											d='M12.3555 85.2784C12.6453 85.2784 12.7178 85.1321 12.754 84.9858H13.0076V87.3994H12.6453V85.5709H12.3555V85.2784Z'
											fill='#2E353A'
										/>
										<path
											d='M14.3848 61.0699C14.6746 61.0699 14.7471 60.9236 14.7833 60.7773H15.0369V63.1909H14.6746V61.3624H14.3848V61.0699Z'
											fill='#2E353A'
										/>
										<path
											d='M14.3848 64.544C14.6746 64.544 14.7471 64.3977 14.7833 64.2515H15.0369V66.665H14.6746V64.8366H14.3848V64.544Z'
											fill='#2E353A'
										/>
										<path
											d='M14.4932 69.5539C14.4932 69.7368 14.5656 69.8099 14.6743 69.8099C14.783 69.8099 14.8555 69.7368 14.8555 69.5539V68.2374C14.8555 68.0546 14.783 67.9815 14.6743 67.9815C14.5656 67.9815 14.4932 68.0546 14.4932 68.2374V69.5539ZM14.1309 68.274C14.1309 67.8718 14.3483 67.6523 14.7106 67.6523C15.0729 67.6523 15.2903 67.8718 15.2903 68.274V69.5174C15.2903 69.9196 15.0729 70.139 14.7106 70.139C14.3483 70.139 14.1309 69.9196 14.1309 69.5174V68.274Z'
											fill='#2E353A'
										/>
										<path
											d='M14.4932 73.028C14.4932 73.2109 14.5656 73.284 14.6743 73.284C14.783 73.284 14.8555 73.2109 14.8555 73.028V71.7116C14.8555 71.5287 14.783 71.4556 14.6743 71.4556C14.5656 71.4556 14.4932 71.5287 14.4932 71.7116V73.028ZM14.1309 71.7481C14.1309 71.3459 14.3483 71.1265 14.7106 71.1265C15.0729 71.1265 15.2903 71.3459 15.2903 71.7481V72.9915C15.2903 73.3937 15.0729 73.6131 14.7106 73.6131C14.3483 73.6131 14.1309 73.3937 14.1309 72.9915V71.7481Z'
											fill='#2E353A'
										/>
										<path
											d='M14.3848 74.9298C14.6746 74.9298 14.7471 74.7835 14.7833 74.6372H15.0369V77.0507H14.6746V75.2223H14.3848V74.9298Z'
											fill='#2E353A'
										/>
										<path
											d='M14.3848 81.8409C14.6746 81.8409 14.7471 81.6946 14.7833 81.5483H15.0369V83.9619H14.6746V82.1334H14.3848V81.8409Z'
											fill='#2E353A'
										/>
										<path
											d='M10.4357 59.1682C10.4357 59.351 10.5081 59.4242 10.6168 59.4242C10.7255 59.4242 10.798 59.351 10.798 59.1682V57.8517C10.798 57.6689 10.7255 57.5957 10.6168 57.5957C10.5081 57.5957 10.4357 57.6689 10.4357 57.8517V59.1682ZM10.0371 57.8883C10.0371 57.486 10.2545 57.2666 10.6168 57.2666C10.9791 57.2666 11.1965 57.486 11.1965 57.8883V59.1316C11.1965 59.5339 10.9791 59.7533 10.6168 59.7533C10.2545 59.7533 10.0371 59.5339 10.0371 59.1316V57.8883Z'
											fill='#2E353A'
										/>
										<path
											d='M10.3262 61.0699C10.616 61.0699 10.6885 60.9236 10.7247 60.7773H10.9783V63.1909H10.616V61.3624H10.3262V61.0699Z'
											fill='#2E353A'
										/>
										<path
											d='M10.3262 64.544C10.616 64.544 10.6885 64.3977 10.7247 64.2515H10.9783V66.665H10.616V64.8366H10.3262V64.544Z'
											fill='#2E353A'
										/>
										<path
											d='M10.4357 69.5539C10.4357 69.7368 10.5081 69.8099 10.6168 69.8099C10.7255 69.8099 10.798 69.7368 10.798 69.5539V68.2374C10.798 68.0546 10.7255 67.9815 10.6168 67.9815C10.5081 67.9815 10.4357 68.0546 10.4357 68.2374V69.5539ZM10.0371 68.274C10.0371 67.8718 10.2545 67.6523 10.6168 67.6523C10.9791 67.6523 11.1965 67.8718 11.1965 68.274V69.5174C11.1965 69.9196 10.9791 70.139 10.6168 70.139C10.2545 70.139 10.0371 69.9196 10.0371 69.5174V68.274Z'
											fill='#2E353A'
										/>
										<path
											d='M10.3262 71.4556C10.616 71.4556 10.6885 71.3094 10.7247 71.1631H10.9783V73.5766H10.616V71.7482H10.3262V71.4556Z'
											fill='#2E353A'
										/>
										<path
											d='M10.4357 76.4655C10.4357 76.6484 10.5081 76.7215 10.6168 76.7215C10.7255 76.7215 10.798 76.6484 10.798 76.4655V75.1491C10.798 74.9662 10.7255 74.8931 10.6168 74.8931C10.5081 74.8931 10.4357 74.9662 10.4357 75.1491V76.4655ZM10.0371 75.1856C10.0371 74.7834 10.2545 74.564 10.6168 74.564C10.9791 74.564 11.1965 74.7834 11.1965 75.1856V76.429C11.1965 76.8312 10.9791 77.0506 10.6168 77.0506C10.2545 77.0506 10.0371 76.8312 10.0371 76.429V75.1856Z'
											fill='#2E353A'
										/>
										<path
											d='M8.37013 52.257C8.37013 52.4399 8.4426 52.513 8.55129 52.513C8.65999 52.513 8.73245 52.4399 8.73245 52.257V50.9406C8.73245 50.7577 8.65999 50.6846 8.55129 50.6846C8.4426 50.6846 8.37013 50.7577 8.37013 50.9406V52.257ZM8.00781 50.9771C8.00781 50.5749 8.2252 50.3555 8.58752 50.3555C8.94984 50.3555 9.16723 50.5749 9.16723 50.9771V52.2205C9.16723 52.6227 8.94984 52.8422 8.58752 52.8422C8.2252 52.8422 8.00781 52.6227 8.00781 52.2205V50.9771Z'
											fill='#2E353A'
										/>
										<path
											d='M8.26172 57.6324C8.55157 57.6324 8.62404 57.4861 8.66027 57.3398H8.91389V59.7534H8.55157V57.9249H8.26172V57.6324Z'
											fill='#2E353A'
										/>
										<path
											d='M8.37013 62.6423C8.37013 62.8251 8.4426 62.8983 8.55129 62.8983C8.65999 62.8983 8.73245 62.8251 8.73245 62.6423V61.3258C8.73245 61.143 8.65999 61.0698 8.55129 61.0698C8.4426 61.0698 8.37013 61.143 8.37013 61.3258V62.6423ZM8.00781 61.3624C8.00781 60.9601 8.2252 60.7407 8.58752 60.7407C8.94984 60.7407 9.16723 60.9601 9.16723 61.3624V62.6057C9.16723 63.008 8.94984 63.2274 8.58752 63.2274C8.2252 63.2274 8.00781 63.008 8.00781 62.6057V61.3624Z'
											fill='#2E353A'
										/>
										<path
											d='M8.37013 69.5539C8.37013 69.7368 8.4426 69.8099 8.55129 69.8099C8.65999 69.8099 8.73245 69.7368 8.73245 69.5539V68.2374C8.73245 68.0546 8.65999 67.9815 8.55129 67.9815C8.4426 67.9815 8.37013 68.0546 8.37013 68.2374V69.5539ZM8.00781 68.274C8.00781 67.8718 8.2252 67.6523 8.58752 67.6523C8.94984 67.6523 9.16723 67.8718 9.16723 68.274V69.5174C9.16723 69.9196 8.94984 70.139 8.58752 70.139C8.2252 70.139 8.00781 69.9196 8.00781 69.5174V68.274Z'
											fill='#2E353A'
										/>
										<path
											d='M8.37013 73.028C8.37013 73.2109 8.4426 73.284 8.55129 73.284C8.65999 73.284 8.73245 73.2109 8.73245 73.028V71.7116C8.73245 71.5287 8.65999 71.4556 8.55129 71.4556C8.4426 71.4556 8.37013 71.5287 8.37013 71.7116V73.028ZM8.00781 71.7481C8.00781 71.3459 8.2252 71.1265 8.58752 71.1265C8.94984 71.1265 9.16723 71.3459 9.16723 71.7481V72.9915C9.16723 73.3937 8.94984 73.6131 8.58752 73.6131C8.2252 73.6131 8.00781 73.3937 8.00781 72.9915V71.7481Z'
											fill='#2E353A'
										/>
										<path
											d='M8.37013 76.4655C8.37013 76.6484 8.4426 76.7215 8.55129 76.7215C8.65999 76.7215 8.73245 76.6484 8.73245 76.4655V75.1491C8.73245 74.9662 8.65999 74.8931 8.55129 74.8931C8.4426 74.8931 8.37013 74.9662 8.37013 75.1491V76.4655ZM8.00781 75.1856C8.00781 74.7834 8.2252 74.564 8.58752 74.564C8.94984 74.564 9.16723 74.7834 9.16723 75.1856V76.429C9.16723 76.8312 8.94984 77.0506 8.58752 77.0506C8.2252 77.0506 8.00781 76.8312 8.00781 76.429V75.1856Z'
											fill='#2E353A'
										/>
										<path
											d='M8.26172 85.2784C8.55157 85.2784 8.62404 85.1321 8.66027 84.9858H8.91389V87.3994H8.55157V85.5709H8.26172V85.2784Z'
											fill='#2E353A'
										/>
										<path
											d='M123.079 83.1943L123.151 83.0114C117.861 80.8539 115.035 76.0634 113.514 71.7848C112.753 69.6638 112.318 67.6525 112.101 66.1898C111.992 65.4584 111.919 64.8733 111.883 64.4345C111.847 64.2151 111.847 64.0688 111.847 63.9591C111.847 63.8494 111.847 63.7762 111.847 63.7762H111.666V63.9591H113.948C113.985 63.9591 114.057 63.9225 114.093 63.9225C114.129 63.8859 114.13 63.8494 114.13 63.7762V61.9844H113.948V62.1672C119.456 62.1672 123.224 58.7297 123.26 58.7297L123.151 58.5835L123.043 58.7297C123.043 58.7297 126.847 62.1672 132.354 62.1672V61.9844H132.173V63.7762C132.173 63.8128 132.209 63.8859 132.209 63.9225C132.245 63.9591 132.282 63.9591 132.354 63.9591H134.637V63.7762H134.456C134.456 63.7762 134.456 63.8494 134.456 63.9591C134.383 64.7636 134.021 68.5668 132.463 72.6259C130.869 76.685 128.079 81.0367 123.115 83.048L123.079 83.1943L123.151 83.3771C128.55 81.1464 131.448 76.2462 133.006 71.9311C134.564 67.616 134.745 63.8128 134.745 63.8128C134.745 63.7762 134.745 63.7031 134.709 63.6665C134.673 63.63 134.637 63.5934 134.564 63.5934H132.463V61.9844C132.463 61.9478 132.427 61.8747 132.427 61.8381C132.39 61.8015 132.354 61.8015 132.282 61.8015C129.601 61.8015 127.354 60.9604 125.724 60.1193C124.927 59.7171 124.311 59.2783 123.876 58.9491C123.658 58.8029 123.477 58.6566 123.369 58.5835C123.296 58.5469 123.26 58.5103 123.26 58.4737L123.224 58.4372C123.151 58.364 123.043 58.364 122.97 58.4372L122.934 58.4737C122.535 58.8394 118.948 61.8015 113.912 61.8015C113.876 61.8015 113.803 61.8381 113.767 61.8381C113.731 61.8747 113.731 61.9112 113.731 61.9844V63.5934H111.593C111.557 63.5934 111.485 63.63 111.448 63.6665C111.412 63.7031 111.412 63.7397 111.412 63.8128C111.412 63.8128 111.593 67.5794 113.151 71.9311C114.673 76.2462 117.572 81.1464 123.006 83.3771C123.043 83.3771 123.115 83.3771 123.151 83.3771L123.079 83.1943Z'
											fill='#2E353A'
										/>
										<path
											d='M123.081 81.2194L123.153 81.0366C119.711 79.391 117.465 76.4289 116.015 73.3571C114.566 70.2853 113.914 67.177 113.66 65.312L113.479 65.3485V65.5314H115.581C115.617 65.5314 115.689 65.4948 115.725 65.4948C115.762 65.4583 115.762 65.4217 115.762 65.3485V63.447H115.581L115.617 63.6298C119.095 63.2276 121.776 61.7282 123.189 60.7409L123.081 60.5946L122.972 60.7409C124.385 61.7282 127.066 63.2641 130.544 63.6298L130.581 63.447H130.399V65.3485C130.399 65.3851 130.436 65.4583 130.436 65.4948C130.472 65.5314 130.508 65.5314 130.581 65.5314H132.682V65.3485L132.501 65.312C132.211 67.177 131.559 70.3219 130.11 73.3571C128.66 76.4289 126.45 79.391 123.008 81.0366L123.081 81.2194L123.153 81.4023C126.704 79.7201 128.986 76.6849 130.436 73.5765C131.885 70.4682 132.573 67.3233 132.827 65.4217C132.827 65.3851 132.827 65.312 132.791 65.2754C132.754 65.2388 132.718 65.2023 132.646 65.2023H130.725V63.4835C130.725 63.3738 130.653 63.3007 130.581 63.3007C127.175 62.8984 124.566 61.4357 123.153 60.4483C123.081 60.4118 123.008 60.4118 122.936 60.4483C121.523 61.3991 118.914 62.8984 115.508 63.3007C115.399 63.3007 115.363 63.3738 115.363 63.4835V65.2023H113.443C113.407 65.2023 113.334 65.2388 113.298 65.2754C113.262 65.312 113.262 65.3851 113.262 65.4217C113.552 67.3233 114.204 70.4682 115.653 73.5765C117.102 76.6849 119.385 79.7201 122.972 81.4023C123.008 81.4388 123.081 81.4388 123.117 81.4023L123.081 81.2194Z'
											fill='#2E353A'
										/>
										<path
											d='M126.776 74.2714H119.312C119.058 74.2714 118.805 74.052 118.805 73.7594V69.2615C118.805 69.0055 119.022 68.7495 119.312 68.7495H126.776C127.029 68.7495 127.283 68.9689 127.283 69.2615V73.7594C127.283 74.052 127.066 74.2714 126.776 74.2714Z'
											fill='#2E353A'
										/>
										<path
											d='M123.226 64.1785C121.486 64.1054 120.037 65.495 120.037 67.2503V67.5794C120.037 67.6892 120.146 67.7989 120.255 67.7989H121.015C121.124 67.7989 121.233 67.6892 121.233 67.5794V67.2869C121.233 66.2995 121.957 65.4219 122.936 65.3853C124.023 65.3122 124.892 66.1898 124.892 67.2503V67.5794C124.892 67.6892 125.001 67.7989 125.11 67.7989H125.87C125.979 67.7989 126.088 67.6892 126.088 67.5794V67.36C126.088 65.6779 124.856 64.2517 123.226 64.1785Z'
											fill='#2E353A'
										/>
										<path
											d='M123.84 70.9071C123.84 70.4682 123.478 70.1025 123.043 70.1025C122.608 70.1025 122.246 70.4682 122.246 70.9071C122.246 71.2362 122.427 71.4922 122.681 71.6384L122.391 72.9183H123.659L123.369 71.6384C123.659 71.4922 123.84 71.2362 123.84 70.9071Z'
											fill='white'
										/>
										<path
											d='M123.84 70.9068H124.021C124.021 70.3583 123.586 69.9194 123.043 69.9194C122.499 69.9194 122.064 70.3583 122.064 70.9068C122.064 71.309 122.282 71.6382 122.608 71.7844L122.68 71.6382L122.499 71.6016L122.209 72.8815C122.209 72.9181 122.209 72.9912 122.246 73.0278C122.282 73.0644 122.318 73.1009 122.391 73.1009H123.659C123.731 73.1009 123.767 73.0644 123.804 73.0278C123.84 72.9912 123.84 72.9181 123.84 72.8815L123.55 71.6016L123.369 71.6382L123.441 71.7844C123.767 71.6382 123.985 71.309 123.985 70.9068H123.84H123.659C123.659 71.1628 123.514 71.3456 123.296 71.4553C123.224 71.4919 123.188 71.565 123.188 71.6747L123.441 72.7352H122.644L122.898 71.6747C122.934 71.6016 122.862 71.4919 122.789 71.4553C122.572 71.3456 122.427 71.1628 122.427 70.9068C122.427 70.5777 122.717 70.2851 123.043 70.2851C123.369 70.2851 123.659 70.5777 123.659 70.9068H123.84Z'
											fill='#2E353A'
										/>
										<path
											d='M89.1666 31.23V31.0472H63.5506C62.9709 31.0472 62.5361 30.5718 62.5361 30.0232V15.542C62.5361 14.9569 63.0072 14.518 63.5506 14.518H89.1666C89.7463 14.518 90.1811 14.9934 90.1811 15.542V29.9867C90.1811 30.5718 89.7101 31.0106 89.1666 31.0106V31.23V31.4128C89.9275 31.4128 90.5434 30.7912 90.5434 30.0232V15.542C90.5434 14.774 89.9275 14.1523 89.1666 14.1523H63.5506C62.7898 14.1523 62.1738 14.774 62.1738 15.542V29.9867C62.1738 30.7546 62.7898 31.3763 63.5506 31.3763H89.1666V31.23Z'
											fill='#2E353A'
										/>
										<path
											d='M64.9996 28.853V29.0358H73.0431C73.3692 29.0358 73.6591 28.7799 73.6591 28.4507V17.1144C73.6591 16.7853 73.4054 16.5293 73.0431 16.5293H64.9996C64.6735 16.5293 64.4199 16.7853 64.4199 17.1144V28.4142C64.4199 28.7433 64.6735 28.9993 64.9996 28.9993V28.853V28.6702C64.8547 28.6702 64.7822 28.5604 64.7822 28.4507V17.1144C64.7822 16.9681 64.8909 16.895 64.9996 16.895H73.0431C73.188 16.895 73.2967 17.0047 73.2967 17.1144V28.4142C73.2967 28.5604 73.188 28.6336 73.0431 28.6336H64.9996V28.853Z'
											fill='#2E353A'
										/>
										<path
											d='M69.0219 28.8526H65.0001C64.7827 28.8526 64.6016 28.6698 64.6016 28.4504V25.6346C64.6016 25.6346 66.8479 25.5249 67.2465 25.0495C67.6088 24.5741 67.2103 23.8061 67.2103 23.8061C67.0653 23.6233 67.0291 22.4165 67.0291 22.4165C67.0291 22.4165 67.0291 22.4165 66.8842 22.38C66.7392 22.3434 66.5581 21.3195 66.5581 20.9538C66.5581 20.5881 66.8842 20.4418 66.8842 20.4418C66.8842 20.4418 66.5581 17.9917 69.0219 17.9917C71.4856 17.9917 71.1595 20.4418 71.1595 20.4418C71.1595 20.4418 71.4856 20.5881 71.4856 20.9538C71.4856 21.3195 71.3045 22.3434 71.1595 22.38C71.0146 22.4165 71.0146 22.4165 71.0146 22.4165C71.0146 22.4165 70.9784 23.6233 70.8334 23.8061C70.8334 23.8061 70.3987 24.5741 70.7972 25.0495C71.1958 25.5249 73.4421 25.6346 73.4421 25.6346V28.4504C73.4421 28.6698 73.261 28.8526 73.0436 28.8526H69.0219Z'
											fill='#2E353A'
										/>
										<path
											d='M87.5358 28.926H82.0285C81.8111 28.926 81.5938 28.7431 81.5938 28.4872C81.5938 28.2678 81.7749 28.0483 82.0285 28.0483H87.5358C87.7532 28.0483 87.9706 28.2312 87.9706 28.4872C87.9706 28.7066 87.7894 28.926 87.5358 28.926Z'
											fill='#2E353A'
										/>
										<path
											d='M87.5353 17.4797H76.1223C75.9049 17.4797 75.6875 17.2969 75.6875 17.0409C75.6875 16.8215 75.8687 16.6021 76.1223 16.6021H87.5353C87.7527 16.6021 87.9701 16.7849 87.9701 17.0409C87.9701 17.2969 87.789 17.4797 87.5353 17.4797Z'
											fill='#2E353A'
										/>
										<path
											d='M82.6803 20.3322H76.1223C75.9049 20.3322 75.6875 20.1494 75.6875 19.8934C75.6875 19.674 75.8687 19.4546 76.1223 19.4546H82.6803C82.8976 19.4546 83.115 19.6374 83.115 19.8934C83.115 20.1494 82.9339 20.3322 82.6803 20.3322Z'
											fill='#2E353A'
										/>
										<path
											d='M80.6159 23.1848H76.1594C75.942 23.1848 75.7246 23.0019 75.7246 22.746C75.7246 22.5265 75.9058 22.3071 76.1594 22.3071H80.6159C80.8333 22.3071 81.0507 22.49 81.0507 22.746C81.0145 23.0019 80.8333 23.1848 80.6159 23.1848Z'
											fill='#2E353A'
										/>
										<path
											d='M82.6803 26.0735H76.1223C75.9049 26.0735 75.6875 25.8906 75.6875 25.6346C75.6875 25.4152 75.8687 25.1958 76.1223 25.1958H82.6803C82.8976 25.1958 83.115 25.3786 83.115 25.6346C83.115 25.854 82.9339 26.0735 82.6803 26.0735Z'
											fill='#2E353A'
										/>
										<path
											d='M36.0145 59.2781H35.8333V75.4415L31.6304 79.72H20.3986V59.4609H36.0507V59.2781H35.8696H36.0145V59.0952H20.1812C20.1449 59.0952 20.0725 59.1318 20.0362 59.1318C20 59.1683 20 59.2049 20 59.2781V79.9029C20 79.9395 20.0362 80.0126 20.0362 80.0492C20.0725 80.0857 20.1087 80.0857 20.1812 80.0857H31.7029C31.7391 80.0857 31.8116 80.0492 31.8478 80.0492L36.1957 75.6609C36.2319 75.6243 36.2319 75.5878 36.2319 75.5146V59.2781C36.2319 59.2415 36.1957 59.1683 36.1957 59.1318C36.1594 59.0952 36.1232 59.0952 36.0507 59.0952V59.2781H36.0145Z'
											fill='#2E353A'
										/>
										<path
											d='M36.0147 75.5146L31.7031 79.9029V75.5146H36.0147Z'
											fill='#2E353A'
										/>
										<path
											d='M36.0153 75.5149L35.8704 75.3686L31.8849 79.4643V75.6977H36.0515V75.5149L35.9066 75.3686L36.0153 75.5149V75.332H31.6675C31.6313 75.332 31.5588 75.3686 31.5226 75.3686C31.4863 75.4052 31.4863 75.4417 31.4863 75.5149V79.9031C31.4863 79.9763 31.5226 80.0494 31.595 80.086C31.6675 80.1226 31.7399 80.086 31.7762 80.0494L36.124 75.6611C36.1602 75.6246 36.1965 75.5149 36.1602 75.4783C36.124 75.4052 36.0515 75.3686 35.9791 75.3686V75.5149H36.0153Z'
											fill='#2E353A'
										/>
										<path
											d='M24.0581 62.0937H33.6233C33.732 62.0937 33.8045 62.0206 33.8045 61.9109C33.8045 61.8012 33.732 61.728 33.6233 61.728H24.0581C23.9494 61.728 23.877 61.8012 23.877 61.9109C23.877 62.0206 23.9494 62.0937 24.0581 62.0937Z'
											fill='#2E353A'
										/>
										<path
											d='M22.6089 63.9223H33.6234C33.7321 63.9223 33.8045 63.8492 33.8045 63.7395C33.8045 63.6298 33.7321 63.5566 33.6234 63.5566H22.6089C22.5002 63.5566 22.4277 63.6298 22.4277 63.7395C22.4277 63.8492 22.5002 63.9223 22.6089 63.9223Z'
											fill='#2E353A'
										/>
										<path
											d='M22.6089 65.7143H33.6234C33.7321 65.7143 33.8045 65.6412 33.8045 65.5315C33.8045 65.4218 33.7321 65.3486 33.6234 65.3486H22.6089C22.5002 65.3486 22.4277 65.4218 22.4277 65.5315C22.4277 65.6412 22.5002 65.7143 22.6089 65.7143Z'
											fill='#2E353A'
										/>
										<path
											d='M22.6089 67.5424H33.6234C33.7321 67.5424 33.8045 67.4693 33.8045 67.3596C33.8045 67.2499 33.7321 67.1768 33.6234 67.1768H22.6089C22.5002 67.1768 22.4277 67.2499 22.4277 67.3596C22.4277 67.4693 22.5002 67.5424 22.6089 67.5424Z'
											fill='#2E353A'
										/>
										<path
											d='M22.6089 69.3711H33.6234C33.7321 69.3711 33.8045 69.2979 33.8045 69.1882C33.8045 69.0785 33.7321 69.0054 33.6234 69.0054H22.6089C22.5002 69.0054 22.4277 69.0785 22.4277 69.1882C22.4277 69.2979 22.5002 69.3711 22.6089 69.3711Z'
											fill='#2E353A'
										/>
										<path
											d='M22.6089 71.1631H33.6234C33.7321 71.1631 33.8045 71.0899 33.8045 70.9802C33.8045 70.8705 33.7321 70.7974 33.6234 70.7974H22.6089C22.5002 70.7974 22.4277 70.8705 22.4277 70.9802C22.4277 71.0899 22.5002 71.1631 22.6089 71.1631Z'
											fill='#2E353A'
										/>
										<path
											d='M22.6089 72.9917H33.6234C33.7321 72.9917 33.8045 72.9185 33.8045 72.8088C33.8045 72.6991 33.7321 72.626 33.6234 72.626H22.6089C22.5002 72.626 22.4277 72.6991 22.4277 72.8088C22.4277 72.9185 22.5002 72.9917 22.6089 72.9917Z'
											fill='#2E353A'
										/>
										<path
											d='M22.6089 74.7832H32.1741C32.2828 74.7832 32.3553 74.71 32.3553 74.6003C32.3553 74.4906 32.2828 74.4175 32.1741 74.4175H22.6089C22.5002 74.4175 22.4277 74.4906 22.4277 74.6003C22.4277 74.71 22.5002 74.7832 22.6089 74.7832Z'
											fill='#2E353A'
										/>
										<path
											d='M36.776 62.0937H38.4427V78.0743L34.2036 82.3529H22.9717V80.5975C22.9717 80.4878 22.8992 80.4147 22.7905 80.4147C22.6818 80.4147 22.6094 80.4878 22.6094 80.5975V82.5357C22.6094 82.5723 22.6456 82.6454 22.6456 82.682C22.6818 82.7185 22.7181 82.7185 22.7905 82.7185H34.3123C34.3485 82.7185 34.421 82.682 34.4572 82.682L38.805 78.2937C38.8413 78.2571 38.8413 78.2206 38.8413 78.1474V61.9109C38.8413 61.8743 38.805 61.8012 38.805 61.7646C38.7688 61.728 38.7326 61.728 38.6601 61.728H36.8123C36.7036 61.728 36.6311 61.8012 36.6311 61.9109C36.5949 62.0206 36.6673 62.0937 36.776 62.0937Z'
											fill='#2E353A'
										/>
										<path
											d='M38.6241 78.1475L34.3125 82.5357V78.1475H38.6241Z'
											fill='#2E353A'
										/>
										<path
											d='M38.6227 78.1477L38.4778 78.0014L34.4561 82.0606V78.3305H38.6227V78.1477V77.9648H34.2749C34.2387 77.9648 34.1662 78.0014 34.13 78.0014C34.0937 78.0014 34.0938 78.0746 34.0938 78.1477V82.5359C34.0938 82.6091 34.13 82.6822 34.2024 82.7188C34.2749 82.7554 34.3474 82.7188 34.3836 82.6822L38.7314 78.294C38.7677 78.2574 38.8039 78.1477 38.7677 78.1111C38.7314 78.038 38.659 78.0014 38.5865 78.0014V78.1477H38.6227Z'
											fill='#2E353A'
										/>
										<path
											d='M95.3621 93.8359H57.3186C56.4853 93.8359 55.7969 93.141 55.7969 92.3V49.5144C55.7969 48.6733 56.4853 47.9785 57.3186 47.9785H95.3621C96.1954 47.9785 96.8838 48.6733 96.8838 49.5144V92.2634C96.9201 93.141 96.2317 93.8359 95.3621 93.8359Z'
											fill='#FFAE00'
										/>
										<path
											d='M95.3616 93.8356V93.6527H57.3181C56.9558 93.6527 56.5935 93.5065 56.3761 93.2505C56.1225 92.9945 55.9776 92.6654 55.9776 92.2997V49.5141C55.9776 49.1485 56.1225 48.7828 56.3761 48.5634C56.6297 48.3074 56.9558 48.1611 57.3181 48.1611H95.3616C95.7239 48.1611 96.0862 48.3074 96.3036 48.5634C96.5573 48.8193 96.7022 49.1485 96.7022 49.5141V92.2631C96.7022 92.6288 96.5573 92.9945 96.3036 93.2139C96.05 93.4699 95.7239 93.6162 95.3616 93.6162V93.8356V94.0184C96.3036 94.0184 97.0645 93.2505 97.0645 92.2997V49.5141C97.0645 48.5634 96.3036 47.7954 95.3616 47.7954H57.3181C56.3761 47.7954 55.6152 48.5634 55.6152 49.5141V92.2631C55.6152 93.2139 56.3761 93.9819 57.3181 93.9819H95.3616V93.8356Z'
											fill='#2E353A'
										/>
										<path
											d='M96.0869 63.4467H91.9927V63.0811H96.0869C96.1956 63.0811 96.2681 63.1542 96.2681 63.2639C96.2681 63.3736 96.1956 63.4467 96.0869 63.4467ZM91.6304 63.4467H86.8478V63.0811H91.6304V63.4467ZM86.4854 63.4467H81.7028V63.0811H86.4854V63.4467ZM81.3405 63.4467H76.5579V63.0811H81.3405V63.4467ZM76.1594 63.4467H71.3768V63.0811H76.1594V63.4467ZM71.0144 63.4467H66.2318V63.0811H71.0144V63.4467ZM65.8695 63.4467H61.0869V63.0811H65.8695V63.4467ZM60.7246 63.4467H56.6304C56.5217 63.4467 56.4492 63.3736 56.4492 63.2639C56.4492 63.1542 56.5217 63.0811 56.6304 63.0811H60.7246V63.4467Z'
											fill='#FD801A'
										/>
										<path
											d='M96.0869 68.5302H91.9927V68.1646H96.0869C96.1956 68.1646 96.2681 68.2377 96.2681 68.3474C96.2681 68.4571 96.1956 68.5302 96.0869 68.5302ZM91.6304 68.5302H86.8478V68.1646H91.6304V68.5302ZM86.4854 68.5302H83.0434C82.9347 68.4205 82.826 68.2743 82.7173 68.1646H86.4854V68.5302ZM82.5362 68.5302H81.6666V68.1646H82.1739C82.3188 68.2743 82.4275 68.4205 82.5362 68.5302ZM81.3405 68.5302H80.9057C80.7246 68.384 80.5434 68.2743 80.326 68.1646H81.3405V68.5302ZM80.2173 68.5302H76.5217V68.1646H79.4202C79.7101 68.2743 79.9637 68.384 80.2173 68.5302ZM76.1594 68.5302H75.5797C75.7608 68.4205 75.942 68.3108 76.1594 68.2377V68.5302ZM74.9637 68.5302H73.297C73.4057 68.4205 73.5144 68.2743 73.6594 68.1646H75.5072C75.326 68.2743 75.1449 68.4205 74.9637 68.5302ZM72.826 68.5302H71.3768V68.1646H73.1159C73.0434 68.2743 72.9347 68.4205 72.826 68.5302ZM71.0144 68.5302H66.2318V68.1646H71.0144V68.5302ZM65.8695 68.5302H61.0869V68.1646H65.8695V68.5302ZM60.7246 68.5302H56.6304C56.5217 68.5302 56.4492 68.4571 56.4492 68.3474C56.4492 68.2377 56.5217 68.1646 56.6304 68.1646H60.7246V68.5302Z'
											fill='#FD801A'
										/>
										<path
											d='M96.0869 73.6132H91.9927V73.2476H96.0869C96.1956 73.2476 96.2681 73.3207 96.2681 73.4304C96.2681 73.5401 96.1956 73.6132 96.0869 73.6132ZM91.6304 73.6132H86.8478V73.2476H91.6304V73.6132ZM86.4854 73.6132H84.4565C84.4565 73.5035 84.4565 73.3573 84.4927 73.2476H86.4854V73.6132ZM84.0941 73.6132H82.971C82.971 73.5035 83.0072 73.3573 83.0072 73.2476H84.1304C84.1304 73.3938 84.0941 73.5035 84.0941 73.6132ZM82.6086 73.6132H81.7028V73.2476H82.6449C82.6086 73.3938 82.6086 73.5035 82.6086 73.6132ZM81.0869 73.6132H79.9637C79.9637 73.5035 79.9999 73.3573 79.9999 73.2476H81.1231C81.1231 73.3938 81.1231 73.5035 81.0869 73.6132ZM79.6014 73.6132H78.7318C78.6594 73.5401 78.5869 73.4304 78.4782 73.3573C78.4782 73.3207 78.4782 73.2841 78.4782 73.2476H79.6014C79.6376 73.3938 79.6014 73.5035 79.6014 73.6132ZM74.8188 73.6132H73.8043C73.8405 73.5035 73.913 73.3573 73.9492 73.2476H75.1811C75.1811 73.2476 75.1811 73.2476 75.1811 73.2841C75.0362 73.3938 74.9275 73.5035 74.8188 73.6132ZM73.4057 73.6132H72.2101C72.2463 73.5035 72.2825 73.3573 72.355 73.2476H73.5507C73.4782 73.3938 73.442 73.5035 73.4057 73.6132ZM71.8115 73.6132H71.3768V73.2476H71.9202C71.9202 73.3938 71.8478 73.5035 71.8115 73.6132ZM71.0144 73.6132H70.6159C70.6521 73.5035 70.6883 73.3573 70.7246 73.2476H71.0144V73.6132ZM70.2536 73.6132H66.2318V73.2476H70.3623C70.326 73.3938 70.2898 73.5035 70.2536 73.6132ZM65.8695 73.6132H61.0869V73.2476H65.8695V73.6132ZM60.7246 73.6132H56.6304C56.5217 73.6132 56.4492 73.5401 56.4492 73.4304C56.4492 73.3207 56.5217 73.2476 56.6304 73.2476H60.7246V73.6132Z'
											fill='#FD801A'
										/>
										<path
											d='M96.0869 78.7329H91.9927V78.3672H96.0869C96.1956 78.3672 96.2681 78.4403 96.2681 78.55C96.2681 78.6597 96.1956 78.7329 96.0869 78.7329ZM91.6304 78.7329H86.8478V78.3672H91.6304V78.7329ZM86.4854 78.7329H83.0797C83.1159 78.6232 83.1883 78.4769 83.2246 78.3672H86.4854V78.7329ZM82.6811 78.7329H81.6666V78.3672H82.826C82.7898 78.4769 82.7173 78.6232 82.6811 78.7329ZM81.0869 78.7329H79.8912C79.9275 78.6232 79.9637 78.4769 80.0362 78.3672H81.2681C81.1956 78.4769 81.1231 78.6232 81.0869 78.7329ZM72.8985 78.7329H72.2826C72.3188 78.6232 72.355 78.4769 72.355 78.3672H72.971C73.0072 78.4769 72.971 78.5866 72.8985 78.7329ZM71.9565 78.7329H71.3768V78.3672H72.0289C71.9927 78.4769 71.9565 78.5866 71.9565 78.7329ZM71.0144 78.7329H70.7608C70.797 78.6232 70.8333 78.4769 70.8333 78.3672H70.9782V78.7329M70.3985 78.7329H69.2391C69.2753 78.6232 69.2753 78.4769 69.3115 78.3672H70.471C70.471 78.4769 70.4347 78.5866 70.3985 78.7329ZM68.8768 78.7329H66.2318V78.3672H68.9492C68.9492 78.4769 68.913 78.5866 68.8768 78.7329ZM65.8695 78.7329H61.0869V78.3672H65.8695V78.7329ZM60.7246 78.7329H56.6304C56.5217 78.7329 56.4492 78.6597 56.4492 78.55C56.4492 78.4403 56.5217 78.3672 56.6304 78.3672H60.7246V78.7329ZM79.5289 78.5866C79.5289 78.5135 79.5289 78.4403 79.5289 78.3672H79.6014C79.6014 78.4403 79.5652 78.5135 79.5289 78.5866Z'
											fill='#FD801A'
										/>
										<path
											d='M96.0869 83.8159H91.9927V83.4502H96.0869C96.1956 83.4502 96.2681 83.5233 96.2681 83.633C96.2681 83.7427 96.1956 83.8159 96.0869 83.8159ZM91.6304 83.8159H86.8478V83.4502H91.6304V83.8159ZM86.4854 83.8159H81.7028V83.4502H86.4854V83.8159ZM81.3405 83.8159H79.9275C79.9637 83.7062 79.9999 83.5599 79.9999 83.4502H81.1594C81.1231 83.5599 81.1956 83.633 81.3043 83.6696C81.3043 83.6696 81.3043 83.6696 81.3405 83.6696V83.8159ZM72.3188 83.8159H71.3768V83.633C71.413 83.5965 71.4492 83.5599 71.4492 83.5233C71.4492 83.4868 71.4492 83.4868 71.4492 83.4502H72.3188C72.355 83.5599 72.3188 83.7062 72.3188 83.8159ZM71.0144 83.8159H66.2318V83.4502H71.0144V83.8159ZM65.8695 83.8159H61.0869V83.4502H65.8695V83.8159ZM60.7246 83.8159H56.6304C56.5217 83.8159 56.4492 83.7427 56.4492 83.633C56.4492 83.5233 56.5217 83.4502 56.6304 83.4502H60.7246V83.8159ZM79.6014 83.5599C79.6014 83.5233 79.6014 83.4868 79.6014 83.4502H79.6376C79.6376 83.4868 79.6376 83.5233 79.6014 83.5599Z'
											fill='#FD801A'
										/>
										<path
											d='M96.0869 88.8989H91.9927V88.5332H96.0869C96.1956 88.5332 96.2681 88.6063 96.2681 88.716C96.2681 88.8258 96.1956 88.8989 96.0869 88.8989ZM91.6304 88.8989H86.8478V88.5332H91.6304V88.8989ZM86.4854 88.8989H81.7028V88.5332H86.4854V88.8989ZM81.3405 88.8989H79.7826C79.7826 88.7892 79.7463 88.6429 79.7463 88.5332H81.3405V88.8989ZM71.5941 88.8989H71.3768V88.5332H71.6304C71.6304 88.6795 71.5941 88.7892 71.5941 88.8989ZM71.0144 88.8989H66.2318V88.5332H71.0144V88.8989ZM65.8695 88.8989H61.0869V88.5332H65.8695V88.8989ZM60.7246 88.8989H56.6304C56.5217 88.8989 56.4492 88.8258 56.4492 88.716C56.4492 88.6063 56.5217 88.5332 56.6304 88.5332H60.7246V88.8989Z'
											fill='#FD801A'
										/>
										<path
											d='M96.0869 58.3637H91.9927V57.998H96.0869C96.1956 57.998 96.2681 58.0712 96.2681 58.1809C96.2681 58.2906 96.1956 58.3637 96.0869 58.3637ZM91.6304 58.3637H86.8478V57.998H91.6304V58.3637ZM86.4854 58.3637H81.7028V57.998H86.4854V58.3637ZM81.3405 58.3637H76.5579V57.998H81.3405V58.3637ZM76.1594 58.3637H71.3768V57.998H76.1594V58.3637ZM71.0144 58.3637H66.2318V57.998H71.0144V58.3637ZM65.8695 58.3637H61.0869V57.998H65.8695V58.3637ZM60.7246 58.3637H56.6304C56.5217 58.3637 56.4492 58.2906 56.4492 58.1809C56.4492 58.0712 56.5217 57.998 56.6304 57.998H60.7246V58.3637Z'
											fill='#FD801A'
										/>
										<path
											d='M96.0869 53.2441H91.9927V52.8784H96.0869C96.1956 52.8784 96.2681 52.9516 96.2681 53.0613C96.2681 53.171 96.1956 53.2441 96.0869 53.2441ZM91.6304 53.2441H86.8478V52.8784H91.6304V53.2441ZM86.4854 53.2441H81.7028V52.8784H86.4854V53.2441ZM81.3405 53.2441H76.5579V52.8784H81.3405V53.2441ZM76.1594 53.2441H71.3768V52.8784H76.1594V53.2441ZM71.0144 53.2441H66.2318V52.8784H71.0144V53.2441ZM65.8695 53.2441H61.0869V52.8784H65.8695V53.2441ZM60.7246 53.2441H56.6304C56.5217 53.2441 56.4492 53.171 56.4492 53.0613C56.4492 52.9516 56.5217 52.8784 56.6304 52.8784H60.7246V53.2441Z'
											fill='#FD801A'
										/>
										<path
											d='M86.6675 93.1776C86.5588 93.1776 86.4863 93.1045 86.4863 92.9948V88.8991V88.5334V83.816V83.4503V78.7329V78.3672V73.6499V73.2842V68.5668V68.2011V63.4837V63.118V58.4006V58.035V53.3176V52.9519V48.8562C86.4863 48.7465 86.5588 48.6733 86.6675 48.6733C86.7762 48.6733 86.8486 48.7465 86.8486 48.8562V52.9519V53.3176V58.035V58.4006V63.118V63.4837V68.2011V68.5668V73.2842V73.6499V78.3672V78.7329V83.4503V83.816V88.5334V88.8991V92.9948C86.8486 93.1045 86.7762 93.1776 86.6675 93.1776Z'
											fill='#FD801A'
										/>
										<path
											d='M81.521 93.1775C81.4123 93.1775 81.3398 93.1044 81.3398 92.9947V88.899V88.5333V83.8159V83.6696H81.3761C81.4485 83.6696 81.521 83.6331 81.5572 83.5233C81.5935 83.3039 81.6659 83.1211 81.7022 82.9017V83.4136V83.7793V88.4967V88.8624V92.9581C81.7022 93.1044 81.5935 93.1775 81.521 93.1775ZM81.3398 82.9017V79.1351C81.4123 78.9157 81.521 78.6963 81.5935 78.4403C81.6297 78.3671 81.6659 78.294 81.7022 78.1843V78.3671V78.7328V81.6218C81.5572 82.024 81.4485 82.4629 81.3398 82.9017ZM81.3398 78.1112V74.4543C81.4485 73.9423 81.521 73.4303 81.521 72.9184C81.521 72.4796 81.4848 72.0407 81.3398 71.6385V69.4078C81.4848 69.5541 81.5935 69.7003 81.7022 69.8466V73.2475V73.6132V77.1238C81.5572 77.4895 81.4485 77.782 81.3398 78.1112ZM81.7022 69.2615C81.5935 69.1152 81.4485 69.0055 81.3398 68.8958V68.5301V68.1644V67.4696C81.4485 67.5428 81.5935 67.6525 81.7022 67.7256V68.1644V68.5301V69.2615ZM81.7022 67.2502C81.5935 67.1771 81.4485 67.0674 81.3398 66.9942V63.4105V63.0448V58.3274V57.9617V53.2443V52.8787V48.7829C81.3398 48.6732 81.4123 48.6001 81.521 48.6001C81.6297 48.6001 81.7022 48.6732 81.7022 48.7829V52.8787V53.2443V57.9617V58.3274V63.0448V63.4105V67.2502Z'
											fill='#FD801A'
										/>
										<path
											d='M76.1602 72.8087V72.1505C76.2689 71.9676 76.4138 71.8214 76.5225 71.6751V72.7722C76.4138 72.7722 76.3051 72.7722 76.1602 72.8087ZM76.1602 71.5288V69.9564C76.2689 69.8832 76.4138 69.8101 76.5225 69.7369V71.1266C76.4138 71.2728 76.3051 71.3825 76.1602 71.5288ZM76.1602 69.5175V68.5302V68.2376C76.2689 68.2011 76.4138 68.1279 76.5225 68.0913V68.1645V68.5302V69.3347C76.4138 69.3713 76.3051 69.4444 76.1602 69.5175ZM76.1602 67.8354V66.6286C76.2689 66.592 76.4138 66.5555 76.5225 66.5189V67.6891C76.4138 67.7622 76.3051 67.7988 76.1602 67.8354ZM76.1602 66.2629V63.4471V63.0814V58.364V57.9983V53.281V52.9153V48.8196C76.1602 48.7099 76.2326 48.6367 76.3413 48.6367C76.45 48.6367 76.5225 48.7099 76.5225 48.8196V52.9153V53.281V57.9983V58.364V63.0814V63.4471V66.1898C76.4138 66.1898 76.3051 66.2263 76.1602 66.2629Z'
											fill='#FD801A'
										/>
										<path
											d='M71.1948 93.1776C71.0861 93.1776 71.0137 93.1045 71.0137 92.9948V88.8991V88.5334V83.816V83.4503V78.7329V78.3672V77.709C71.1224 77.3067 71.2311 76.9045 71.3398 76.5388L71.376 76.3925V78.3672V78.7329V81.5122C71.2673 82.1704 71.1586 82.8286 71.0861 83.4869C71.0861 83.5966 71.1586 83.6697 71.2311 83.7063C71.2311 83.7063 71.2311 83.7063 71.2673 83.7063C71.3035 83.7063 71.3398 83.7063 71.376 83.6697V83.8526V88.5699V88.9356V93.0313C71.376 93.1045 71.3035 93.1776 71.1948 93.1776ZM71.0137 76.3194V73.6133V73.2476V72.4797C71.1224 72.1871 71.2311 71.8946 71.376 71.5654V73.2476V73.6133V75.0395C71.3035 75.332 71.2311 75.588 71.1586 75.8806L71.0137 76.3194ZM71.0137 71.5289V68.5668V68.2011V63.4837V63.118V58.4006V58.035V53.3176V52.9519V48.8562C71.0137 48.7465 71.0861 48.6733 71.1948 48.6733C71.3035 48.6733 71.376 48.7465 71.376 48.8562V52.9519V53.3176V58.035V58.4006V63.118V63.4837V68.2011V68.5668V70.7609C71.2673 70.9803 71.1224 71.2363 71.0137 71.5289Z'
											fill='#FD801A'
										/>
										<path
											d='M66.0503 93.1776C65.9416 93.1776 65.8691 93.1045 65.8691 92.9948V88.8991V88.5334V83.816V83.4503V78.7329V78.3672V73.6499V73.2842V68.5668V68.2011V63.4837V63.118V58.4006V58.035V53.3176V52.9519V48.8562C65.8691 48.7465 65.9416 48.6733 66.0503 48.6733C66.159 48.6733 66.2315 48.7465 66.2315 48.8562V52.9519V53.3176V58.035V58.4006V63.118V63.4837V68.2011V68.5668V73.2842V73.6499V78.3672V78.7329V83.4503V83.816V88.5334V88.8991V92.9948C66.2315 93.1045 66.159 93.1776 66.0503 93.1776Z'
											fill='#FD801A'
										/>
										<path
											d='M60.9058 93.1776C60.7971 93.1776 60.7246 93.1045 60.7246 92.9948V88.8991V88.5334V83.816V83.4503V78.7329V78.3672V73.6499V73.2842V68.5668V68.2011V63.4837V63.118V58.4006V58.035V53.3176V52.9519V48.8562C60.7246 48.7465 60.7971 48.6733 60.9058 48.6733C61.0145 48.6733 61.0869 48.7465 61.0869 48.8562V52.9519V53.3176V58.035V58.4006V63.118V63.4837V68.2011V68.5668V73.2842V73.6499V78.3672V78.7329V83.4503V83.816V88.5334V88.8991V92.9948C61.0869 93.1045 61.0145 93.1776 60.9058 93.1776Z'
											fill='#FD801A'
										/>
										<path
											d='M91.812 93.1776C91.7033 93.1776 91.6309 93.1045 91.6309 92.9948V88.8991V88.5334V83.816V83.4503V78.7329V78.3672V73.6499V73.2842V68.5668V68.2011V63.4837V63.118V58.4006V58.035V53.3176V52.9519V48.8562C91.6309 48.7465 91.7033 48.6733 91.812 48.6733C91.9207 48.6733 91.9932 48.7465 91.9932 48.8562V52.9519V53.3176V58.035V58.4006V63.118V63.4837V68.2011V68.5668V73.2842V73.6499V78.3672V78.7329V83.4503V83.816V88.5334V88.8991V92.9948C91.9932 93.1045 91.9207 93.1776 91.812 93.1776Z'
											fill='#FD801A'
										/>
										<path
											d='M75.1086 84.9128C75.6159 82.3896 76.1956 80.232 76.9202 78.1476C77.0652 77.7087 77.2463 77.2699 77.4275 76.7945C77.6086 76.3191 77.8985 75.5878 78.1159 74.8929C78.3333 74.1616 78.5144 73.4668 78.5144 72.9548C78.5144 72.772 78.4782 72.5891 78.4057 72.4428C78.297 72.2234 78.0796 72.0771 77.8623 72.0771C77.826 72.0771 77.7898 72.0771 77.7536 72.0771C77.7173 72.0771 77.6811 72.1137 77.6449 72.1503C77.1014 72.6257 76.6666 73.4302 76.3043 74.3444C75.942 75.2586 75.6521 76.2826 75.4347 77.1236L75.2898 77.7087C74.6376 79.976 74.2391 82.353 73.9492 84.73C73.9492 84.8397 74.0217 84.9128 74.0941 84.9494C74.2028 84.9494 74.2753 84.8762 74.3115 84.8031C74.6014 82.4261 74.9999 80.0857 75.6521 77.855L75.797 77.2699C76.0507 76.4288 76.3043 75.4049 76.6666 74.5273C77.0289 73.6496 77.4275 72.8451 77.8985 72.4794L77.8623 72.4063V72.4794H77.8985L77.8623 72.4063V72.4794C77.9347 72.4794 78.0434 72.5525 78.0797 72.6622C78.1159 72.7354 78.1521 72.8451 78.1521 72.9914C78.1521 73.4302 77.971 74.125 77.7536 74.8198C77.5362 75.5146 77.2463 76.2094 77.0652 76.7214C76.884 77.1968 76.7028 77.6356 76.5579 78.111C75.8333 80.1954 75.2536 82.353 74.7463 84.9128C74.7101 85.0225 74.7825 85.0957 74.8912 85.1322C74.9999 85.1688 75.0724 84.9859 75.1086 84.9128Z'
											fill='#2E353A'
										/>
										<path
											d='M76.5942 85.0223C77.0652 82.6454 77.6087 80.6341 78.2971 78.6594C78.442 78.2571 78.6232 77.7817 78.8043 77.3429C79.3478 75.9533 80 74.3077 80 72.9546C80 72.5158 79.9275 72.1135 79.7464 71.7844C79.3841 71.053 78.6594 70.5776 77.8623 70.5776C77.4275 70.5776 77.029 70.7239 76.7029 70.9799C75.9783 71.6016 75.4348 72.5158 75 73.5397C74.5652 74.5636 74.2754 75.6973 73.9855 76.6846L73.8406 77.2697C73.1884 79.5004 72.7536 81.8774 72.5 84.2178C72.5 84.3275 72.5725 84.4007 72.6449 84.4372C72.7536 84.4372 72.8261 84.3641 72.8623 84.291C73.1522 81.9505 73.587 79.6101 74.2029 77.3794L74.3478 76.7943C74.6377 75.807 74.9275 74.6733 75.3623 73.686C75.7609 72.6986 76.3043 71.7844 76.9565 71.2724C77.2464 71.053 77.5362 70.9433 77.8985 70.9433C78.5507 70.9433 79.1667 71.3456 79.4565 71.9307C79.6014 72.2232 79.6739 72.5524 79.6739 72.9546C79.6739 74.198 79.058 75.807 78.5145 77.1966C78.3333 77.672 78.1522 78.1108 78.0072 78.5496C77.3188 80.5244 76.7754 82.5722 76.3043 84.9492C76.2681 85.0589 76.3406 85.132 76.4493 85.1686C76.4855 85.1686 76.5942 85.0955 76.5942 85.0223Z'
											fill='#2E353A'
										/>
										<path
											d='M78.1522 84.8764C78.5508 82.9382 79.058 81.0366 79.7102 79.1716C80.0001 78.3305 80.4348 77.3066 80.8334 76.2095C81.1957 75.149 81.4856 74.0154 81.4856 72.9549C81.4856 72.2967 81.3769 71.675 81.087 71.1265C80.4711 69.8466 79.1667 69.0786 77.8624 69.0786C77.1377 69.0786 76.3769 69.3346 75.7609 69.8466C74.7827 70.6511 74.0943 71.8578 73.587 73.1378C73.0798 74.4177 72.7174 75.7707 72.3914 76.9043C71.7754 79.0619 71.3406 81.2926 71.0508 83.5233C71.0508 83.633 71.1232 83.7062 71.1957 83.7427C71.3044 83.7427 71.3769 83.6696 71.4131 83.5964C71.703 81.3658 72.1377 79.1716 72.7537 77.0141C73.0798 75.8804 73.4059 74.5639 73.9131 73.284C74.4203 72.0407 75.0725 70.8705 75.9783 70.1391C76.558 69.6637 77.2102 69.4809 77.8624 69.4809C79.0218 69.4809 80.1812 70.1757 80.7609 71.3093C81.0145 71.8213 81.1232 72.3698 81.1232 72.9915C81.1232 73.9788 80.8334 75.0759 80.4711 76.1364C80.1088 77.1969 79.674 78.2208 79.3479 79.0985C78.6957 81.0001 78.1885 82.9016 77.7899 84.8764C77.7537 84.9861 77.8261 85.0592 77.9348 85.0958C78.0435 85.0226 78.1522 84.9495 78.1522 84.8764Z'
											fill='#2E353A'
										/>
										<path
											d='M79.7823 84.4007C80.1809 82.6819 80.6157 81.1095 81.1229 79.6467C81.2316 79.281 81.4128 78.8788 81.5939 78.4034C82.2461 76.7578 83.007 74.8196 83.007 72.918C83.007 72.077 82.862 71.1993 82.4635 70.3948C81.5939 68.6395 79.8186 67.5059 77.8983 67.5059C76.7751 67.5059 75.7244 67.8715 74.8548 68.6029C72.6809 70.3948 71.8475 73.43 71.1591 75.8436L71.0142 76.4287C70.4707 78.3668 70.0359 80.4147 69.7461 82.4259C69.7461 82.5357 69.7823 82.6088 69.891 82.6454C69.9997 82.6454 70.0722 82.6088 70.1084 82.4991C70.3983 80.4878 70.7968 78.4765 71.3765 76.5384L71.5215 75.9898C72.2099 73.5763 73.0432 70.6142 75.1084 68.932C75.9055 68.2738 76.8838 67.9081 77.9345 67.9081C79.7099 67.9081 81.3765 68.9686 82.1736 70.5776C82.5359 71.309 82.6809 72.1135 82.6809 72.918C82.6809 74.7099 81.9562 76.6481 81.3041 78.2937C81.1229 78.7325 80.978 79.1713 80.8331 79.537C80.3258 81.0363 79.8548 82.6088 79.4925 84.3275C79.4562 84.4372 79.5287 84.5104 79.6374 84.5469C79.6736 84.5835 79.7823 84.5104 79.7823 84.4007Z'
											fill='#2E353A'
										/>
										<path
											d='M81.5222 83.5599C81.812 82.3531 82.1744 81.256 82.5367 80.159C82.6454 79.7933 82.8265 79.4276 82.9715 78.9888C83.6236 77.27 84.4932 75.1125 84.4932 72.9183C84.4932 71.8578 84.312 70.7974 83.7686 69.7369C82.6454 67.4696 80.3628 66.0068 77.8628 66.0068C76.4135 66.0068 75.0367 66.5188 73.8773 67.433C71.341 69.5174 70.4352 72.8086 69.6744 75.4416L69.5294 75.9901C69.0584 77.6357 68.6961 79.3179 68.4062 81.0001C68.4062 81.1098 68.4425 81.1829 68.5512 81.2195C68.6599 81.2195 68.7323 81.1829 68.7686 81.0732C69.0584 79.391 69.4207 77.7454 69.8918 76.0998L70.0367 75.5513C70.7613 72.9184 71.6671 69.7369 74.0947 67.7256C75.1816 66.8479 76.4497 66.3725 77.8628 66.3725C80.1816 66.3725 82.3918 67.7621 83.4425 69.8831C83.9135 70.8705 84.1309 71.8944 84.1309 72.8818C84.1309 75.0028 83.2976 77.1238 82.6454 78.8059C82.4642 79.2448 82.3193 79.647 82.2106 79.9761C81.8483 81.0732 81.486 82.2068 81.1961 83.4136C81.1599 83.5233 81.2323 83.5965 81.341 83.633C81.4135 83.7062 81.5222 83.633 81.5222 83.5599Z'
											fill='#2E353A'
										/>
										<path
											d='M83.3339 82.0606C83.5151 80.8904 84.0585 79.5739 84.602 78.1477C85.1455 76.7215 85.689 75.1491 85.7977 73.4303C85.7977 73.1744 85.8339 72.955 85.8339 72.7355C85.8339 70.0294 84.9281 68.2376 84.2397 67.2868C84.0585 67.0308 83.9498 66.7017 83.9498 66.3726C83.9498 66.1897 83.9861 65.9703 84.0585 65.7875C84.2397 65.2755 84.4209 64.5441 84.4209 63.703C84.4209 63.0082 84.3122 62.2037 84.0223 61.3261C83.9861 61.2164 83.8774 61.1798 83.8049 61.2163C83.6962 61.2529 83.66 61.3626 83.6962 61.4358C83.9861 62.2768 84.0585 63.0082 84.0585 63.6665C84.0585 64.471 83.9136 65.1658 83.7325 65.6412C83.66 65.8606 83.6238 66.1166 83.6238 66.3726C83.6238 66.7748 83.7324 67.1771 83.9861 67.5062C84.6382 68.3838 85.5078 70.1026 85.5078 72.7355C85.5078 72.955 85.5078 73.1744 85.4716 73.4303C85.3629 75.0759 84.8556 76.6118 84.3122 78.038C83.7687 79.4642 83.189 80.8173 83.0078 82.0606C83.0078 82.1703 83.044 82.2434 83.1527 82.28C83.2252 82.2434 83.3339 82.1703 83.3339 82.0606Z'
											fill='#2E353A'
										/>
										<path
											d='M78.514 56.9742C80.9778 58.5467 82.6082 60.9968 82.7169 64.1417V64.2149C82.7169 64.5806 82.6082 64.8365 82.4271 65.0194C82.2459 65.2022 81.956 65.2754 81.63 65.2754C81.4126 65.2754 81.1589 65.2388 80.9053 65.1657C80.072 64.9097 78.8039 64.5074 77.3546 64.5074C75.9778 64.5074 74.4198 64.8731 72.9343 66.1165C71.4488 67.3232 69.9995 69.3711 68.8401 72.7354C68.1155 74.7833 67.6807 77.014 67.3184 79.2081C67.3184 79.3178 67.3546 79.3909 67.4633 79.4275C67.572 79.4275 67.6444 79.3909 67.6807 79.2812C68.043 77.1237 68.4778 74.893 69.1662 72.8817C70.3256 69.5905 71.7386 67.6158 73.1517 66.4456C74.5647 65.2754 76.014 64.9463 77.3546 64.9463C78.7314 64.9463 79.9633 65.3485 80.7966 65.6045C81.0865 65.6776 81.3763 65.7508 81.63 65.7508C82.0285 65.7508 82.3908 65.6411 82.6807 65.3851C82.9343 65.1291 83.1155 64.7634 83.1155 64.3246V64.2514C83.0068 60.9602 81.3039 58.4004 78.7314 56.7914C78.6589 56.7548 78.5502 56.7548 78.4778 56.8645C78.4053 56.828 78.4415 56.9377 78.514 56.9742Z'
											fill='#2E353A'
										/>
										<path
											d='M73.587 57.1939C74.2029 57.1939 76.087 57.1939 78.0435 58.2544C78.9855 58.7663 79.8188 59.5708 80.3985 60.4119C80.9783 61.2164 81.3043 62.0941 81.3043 62.6061C81.3043 62.8255 81.2319 63.0083 81.1594 63.0815C81.0145 63.1912 80.9058 63.2277 80.7246 63.2643C80.471 63.2643 80.1449 63.1912 79.7101 63.0815C79.2754 63.0083 78.7319 62.8986 78.0435 62.8986C76.9928 62.8986 75.6884 63.118 73.9493 63.8128C71.558 64.8002 69.8913 66.8115 68.7319 69.0787C68.2246 70.1027 67.7899 71.1632 67.4275 72.2602C66.9565 73.6499 66.5942 75.076 66.3043 76.5388C66.2681 76.6485 66.3406 76.7216 66.4493 76.7582C66.558 76.7948 66.6304 76.7216 66.6667 76.6119C66.9565 75.1857 67.3188 73.7596 67.7899 72.3699C68.1522 71.3094 68.5507 70.2489 69.058 69.225C70.1812 67.0309 71.8116 65.0927 74.0942 64.1419C75.7971 63.4471 77.0652 63.2643 78.0435 63.2643C78.6956 63.2643 79.2029 63.3374 79.6377 63.4471C80.0725 63.5203 80.4348 63.63 80.7246 63.63C80.9783 63.63 81.2319 63.5568 81.4493 63.374C81.6304 63.1912 81.7029 62.9352 81.7029 62.6426C81.7029 61.9844 81.3406 61.1067 80.7246 60.2291C80.1087 59.3514 79.2754 58.5103 78.2609 57.9618C76.2319 56.8647 74.2754 56.8647 73.6594 56.8647C73.5507 56.8647 73.4783 56.9379 73.4783 57.0476C73.4058 57.0842 73.4783 57.1939 73.587 57.1939Z'
											fill='#2E353A'
										/>
										<path
											d='M70.9056 59.022C71.8839 58.766 72.7535 58.6929 73.4781 58.6563C73.5506 58.6563 73.6593 58.6563 73.7317 58.6563C75.5071 58.6563 76.7752 59.0951 77.6085 59.6071C78.0071 59.8631 78.3332 60.1556 78.5143 60.4116C78.6955 60.6676 78.8042 60.887 78.8042 61.0333C78.8042 61.1064 78.8042 61.143 78.768 61.1796C78.6955 61.2893 78.5868 61.3258 78.4056 61.399C78.2245 61.4355 78.0071 61.4356 77.7172 61.4356C77.6448 61.4356 77.5361 61.4356 77.4636 61.4356C77.1375 61.4356 76.8114 61.4356 76.4129 61.4721C72.8622 61.9109 70.0723 63.9588 68.1883 66.9574C67.2462 68.4568 66.5578 70.1024 66.0143 71.7845C65.9056 72.0771 65.8332 72.4062 65.7245 72.6988C65.6882 72.8085 65.7607 72.8816 65.8332 72.9182C65.9419 72.9547 66.0143 72.8816 66.0506 72.8085C66.1593 72.5159 66.2317 72.1868 66.3404 71.8942C66.8839 70.2486 67.5723 68.6396 68.4781 67.1403C70.3259 64.2148 73.0071 62.2401 76.4491 61.8378C76.8114 61.8012 77.1375 61.8012 77.4636 61.8012C77.5723 61.8012 77.6448 61.8012 77.7172 61.8012C78.0071 61.8012 78.2245 61.8012 78.4781 61.7647C78.6955 61.7281 78.9129 61.6184 79.0578 61.4356C79.1303 61.3258 79.1665 61.2161 79.1665 61.0699C79.1665 60.8139 79.0578 60.5213 78.8042 60.2288C78.1158 59.3511 76.4854 58.3638 73.7317 58.3638C73.6593 58.3638 73.5506 58.3638 73.4781 58.3638C72.7535 58.3638 71.8114 58.4369 70.7969 58.7295C70.6882 58.766 70.652 58.8392 70.6883 58.9489C70.6883 59.022 70.7969 59.0586 70.9056 59.022Z'
											fill='#2E353A'
										/>
										<path
											d='M68.9484 61.5087C70.76 60.0826 72.3904 59.8631 73.6948 59.8631C73.7672 59.8631 73.8397 59.8631 73.9122 59.8631C74.1658 59.8631 74.6368 59.8997 75.0354 60.0094C75.2527 60.046 75.4339 60.1191 75.5788 60.1923C75.7238 60.2654 75.7962 60.3385 75.8325 60.4117V60.4482H75.8687L75.8325 60.4117V60.4482H75.8687L75.8325 60.4117H75.8687V60.3751H75.9049V60.3385C75.9049 60.3385 75.8687 60.3751 75.7962 60.3751C75.6513 60.4117 75.4339 60.4117 75.1078 60.4482C74.202 60.558 72.6803 60.7774 70.8687 61.9841C66.7745 64.7268 66.2672 67.3598 66.2672 67.3963C66.231 67.506 66.3035 67.5792 66.4122 67.6157C66.5209 67.6523 66.5933 67.5792 66.6296 67.4695C66.6658 67.3598 67.2093 64.9096 71.0861 62.2767C72.5716 61.2893 73.8035 60.9602 74.7093 60.8505C75.1441 60.7774 75.5064 60.7774 75.76 60.7408C75.9049 60.7042 76.0136 60.7042 76.0861 60.6677C76.1223 60.6311 76.1948 60.5945 76.231 60.558C76.2672 60.5214 76.3035 60.4482 76.3035 60.3751C76.3035 60.3385 76.3035 60.2654 76.2672 60.2288C76.1948 60.046 76.0498 59.8997 75.8687 59.79C75.6151 59.6437 75.2527 59.534 74.9267 59.4975C74.6006 59.4243 74.2745 59.4243 74.0571 59.4243C73.9846 59.4243 73.9122 59.4243 73.8397 59.4243C72.4991 59.4243 70.7238 59.6803 68.8759 61.1431C68.8035 61.2162 68.7672 61.3259 68.8397 61.399C68.731 61.5453 68.8759 61.5453 68.9484 61.5087Z'
											fill='#2E353A'
										/>
										<path
											d='M85.0356 80.2685C85.0356 80.2685 85.5429 79.1714 86.0501 77.6355C86.5574 76.0996 87.0646 74.0883 87.0646 72.2599C87.0646 72.0771 87.0646 71.8942 87.0646 71.7114C86.9921 70.5046 86.666 69.5172 86.3037 68.6761C85.9776 67.8716 85.6516 67.2134 85.5429 66.738C85.5066 66.5917 85.5066 66.4454 85.5066 66.3357C85.5066 66.0432 85.5791 65.8603 85.6153 65.6044C85.6878 65.385 85.7602 65.129 85.7602 64.7998C85.7602 64.6901 85.7603 64.5804 85.724 64.4707C85.724 64.361 85.6153 64.2879 85.5066 64.3245C85.3979 64.3245 85.3255 64.4342 85.3617 64.5439C85.3617 64.6536 85.3979 64.7633 85.3979 64.8364C85.3979 65.0924 85.3255 65.3118 85.2892 65.5312C85.2168 65.7506 85.1443 66.0066 85.1443 66.3357C85.1443 66.482 85.1443 66.6283 85.1805 66.8111C85.2892 67.3962 85.6153 68.0179 85.9414 68.8224C86.2675 69.6269 86.5936 70.5777 86.666 71.7114C86.666 71.8942 86.666 72.0771 86.666 72.2599C86.666 74.0152 86.1588 75.9899 85.6878 77.5258C85.4342 78.2938 85.1805 78.952 84.9994 79.3908C84.8907 79.6102 84.8182 79.7931 84.782 79.9394C84.7458 80.0491 84.7095 80.1222 84.7095 80.1222C84.6733 80.1953 84.7095 80.305 84.782 80.3782C84.8907 80.4147 84.9994 80.3782 85.0356 80.2685Z'
											fill='#2E353A'
										/>
										<path
											d='M58.7315 57.6693V51.0869H65.2532C65.3619 51.0869 65.4344 51.0137 65.4344 50.904C65.4344 50.7943 65.3619 50.7212 65.2532 50.7212H58.5503C58.5141 50.7212 58.4416 50.7578 58.4054 50.7578C58.3691 50.7943 58.3691 50.8309 58.3691 50.904V57.6693C58.3691 57.779 58.4416 57.8521 58.5503 57.8521C58.659 57.8521 58.7315 57.779 58.7315 57.6693Z'
											fill='#2E353A'
										/>
										<path
											d='M65.2532 90.691H58.7315V84.1086C58.7315 83.9989 58.659 83.9258 58.5503 83.9258C58.4416 83.9258 58.3691 83.9989 58.3691 84.1086V90.8739C58.3691 90.9104 58.4054 90.9836 58.4054 91.0201C58.4416 91.0567 58.4778 91.0567 58.5503 91.0567H65.2532C65.3619 91.0567 65.4344 90.9836 65.4344 90.8739C65.4344 90.7642 65.3619 90.691 65.2532 90.691Z'
											fill='#2E353A'
										/>
										<path
											d='M94.3113 57.6693V50.904C94.3113 50.8675 94.2751 50.7943 94.2751 50.7578C94.2389 50.7212 94.2026 50.7212 94.1301 50.7212H87.4273C87.3186 50.7212 87.2461 50.7943 87.2461 50.904C87.2461 51.0137 87.3186 51.0869 87.4273 51.0869H93.949V57.6693C93.949 57.779 94.0215 57.8521 94.1301 57.8521C94.2388 57.8521 94.3113 57.779 94.3113 57.6693Z'
											fill='#2E353A'
										/>
										<path
											d='M87.4644 91.0567H94.1673C94.2035 91.0567 94.276 91.0201 94.3122 91.0201C94.3484 90.9836 94.3484 90.947 94.3484 90.8739V84.1086C94.3484 83.9989 94.276 83.9258 94.1673 83.9258C94.0586 83.9258 93.9861 83.9989 93.9861 84.1086V90.691H87.4644C87.3557 90.691 87.2832 90.7642 87.2832 90.8739C87.2832 90.9836 87.3557 91.0567 87.4644 91.0567Z'
											fill='#2E353A'
										/>
										<path
											d='M122.572 153.004C120.833 150.371 118.985 147.592 117.5 145.252C115.579 142.29 114.202 140.169 114.202 140.169C113.478 136.695 112.427 135.341 111.376 132.453C110.326 129.6 111.195 127.04 111.63 123.493C112.065 119.946 111.376 116.655 111.014 114.424C110.652 112.193 111.086 110.072 111.014 109.597C110.942 109.085 108.876 106.489 108.043 104.551C107.681 103.673 107.173 102.905 106.557 102.21C105.797 101.369 104.927 100.747 104.057 100.382C103.586 100.199 103.188 100.089 102.789 100.053C101.811 99.9063 101.014 100.089 100.217 100.089C99.0937 100.089 96.7749 98.151 95.2169 97.8584C94.927 97.7853 94.6372 97.7487 94.3473 97.7487C93.0792 97.639 91.7387 97.7487 90.2531 97.8584C88.7676 97.9681 87.0285 96.5419 85.6517 96.1031H85.6155C85.2531 95.9934 84.9633 95.9568 84.6372 95.9934C83.1517 96.2494 80.3981 96.5054 80.3981 96.5054C80.3981 96.5054 80.1444 94.5672 80.0357 91.9708C79.9995 91.532 79.9995 91.0932 79.9271 90.6543C79.7821 89.0453 79.5647 87.6191 79.5285 86.3026C79.5285 85.9735 79.5285 85.6078 79.5285 85.2787C79.6372 83.4137 79.601 81.951 79.5285 79.1352C79.5285 79.0254 79.5285 78.9523 79.5285 78.8426C79.5285 77.965 79.5285 77.1239 79.4923 76.3559C79.3836 74.4909 78.985 73.1379 77.1372 72.8453C75.543 72.5893 74.4198 73.3938 73.7676 76.0634C73.0792 78.7329 72.6082 78.5501 72.4271 82.4629C72.2459 86.3758 71.3763 88.8625 71.485 90.8372C71.5937 92.8119 71.1952 96.6882 71.1952 96.6882C70.4705 96.3225 69.7821 96.6151 69.6372 96.9442C69.4923 97.2733 68.9488 100.309 68.5502 102.466C68.1517 104.404 66.4126 106.196 65.7966 107.513V107.549C65.7242 107.695 65.6517 107.842 65.6155 107.988C65.2531 109.341 65.4343 112.267 65.4343 115.997C65.4343 119.727 64.4923 123.566 65.4343 126.053C65.6155 126.528 65.9053 127.004 66.2314 127.443C67.6444 129.198 70.2531 130.734 72.6082 133.55C75.543 137.097 77.6444 139.693 79.6372 140.863C81.0502 141.704 81.6662 142.399 81.9198 143.313C82.0285 143.679 82.0647 144.081 82.0647 144.52C82.101 145.325 82.4995 145.91 83.2242 146.934C83.9488 147.958 84.9633 149.384 86.1952 151.797C86.9923 153.406 88.1879 156.405 89.456 159.769L122.572 153.004Z'
											fill='white'
										/>
										<path
											d='M69.6367 96.9075C69.7092 96.6881 70.0715 96.5052 70.5063 96.5052C70.0715 96.4687 69.7092 96.6881 69.6367 96.9075Z'
											fill='#C4D9C3'
										/>
										<path
											d='M71.4121 94.0185C71.4121 93.9088 71.4121 93.7625 71.4483 93.6528C71.4121 93.7625 71.4121 93.8722 71.4121 94.0185Z'
											fill='#7C86BD'
										/>
										<path
											d='M71.4863 90.3984C71.4863 89.9231 71.5226 89.4477 71.595 88.8991C71.5226 89.4477 71.4863 89.9596 71.4863 90.3984ZM71.6313 88.5334C71.8124 87.217 72.1385 85.7176 72.3197 83.8161C72.1385 85.7176 71.8486 87.2535 71.6313 88.5334Z'
											fill='#FFAE00'
										/>
										<path
											d='M71.5938 88.8989C71.5938 88.7892 71.63 88.6429 71.63 88.5332C71.63 88.6795 71.5938 88.7892 71.5938 88.8989Z'
											fill='#7C86BD'
										/>
										<path
											d='M69.8922 119.617C69.7835 119.617 69.711 119.58 69.6385 119.544C68.2255 118.739 68.1168 111.645 68.5516 109.999C68.9864 108.354 68.9139 107 68.9139 107C68.769 106.964 68.5878 106.927 68.4066 106.927C67.7182 106.927 66.7037 107.183 65.7617 107.476V107.439C66.4139 106.123 68.153 104.331 68.5153 102.393C68.9501 100.235 69.4936 97.1634 69.6023 96.8709C69.6748 96.6515 70.0371 96.4686 70.4719 96.4686C70.5081 96.4686 70.5443 96.4686 70.5806 96.4686C70.7617 96.4686 70.9429 96.5418 71.1603 96.6515C71.1603 96.6515 71.1603 96.6149 71.1603 96.5783C71.1965 96.3224 71.3052 95.2253 71.3777 94.0185C71.3777 93.9088 71.3777 93.7625 71.4139 93.6528C71.4501 92.958 71.4864 92.2632 71.4864 91.6416C71.4864 91.349 71.4864 91.0564 71.4501 90.837C71.4501 90.6908 71.4501 90.5811 71.4501 90.4348C71.4501 89.9594 71.4864 89.484 71.5588 88.9355C71.5588 88.8257 71.5951 88.6795 71.5951 88.5698C71.7762 87.2533 72.1023 85.754 72.2835 83.8524C72.2835 83.7427 72.3197 83.5964 72.3197 83.4867C72.3197 83.4136 72.3197 83.3404 72.3197 83.2673C72.3559 83.0113 72.3559 82.7553 72.3559 82.4628C72.5371 78.5499 73.0443 78.7327 73.6965 76.0632C74.3124 73.6862 75.2182 72.8086 76.5588 72.8086C76.74 72.8086 76.8849 72.8086 77.0661 72.8452C78.9139 73.1377 79.3124 74.4908 79.4211 76.3558C79.2037 76.1729 78.9864 75.9901 78.769 75.8072C78.2617 75.4415 77.6458 75.1856 77.0298 75.1856C76.9211 75.1856 76.8487 75.1856 76.74 75.2221C75.9066 75.3318 75.1458 76.2095 74.6748 77.1237C74.0951 78.2573 73.9139 79.4641 74.4936 79.4641C74.6023 79.4641 74.711 79.4276 74.8197 79.3544C75.3632 79.0984 76.1965 78.9887 77.0298 78.9887C77.8994 78.9887 78.8052 79.0619 79.4574 79.1716C79.4936 80.7806 79.5298 81.9508 79.5298 82.9747C79.5298 83.1941 79.5298 83.377 79.5298 83.5964C79.5298 83.9255 79.5298 84.2546 79.4936 84.5838C79.4936 84.8397 79.4574 85.0592 79.4574 85.3151C79.4574 85.498 79.4211 85.7174 79.4211 85.9368C79.4211 86.0831 79.4211 86.1928 79.4211 86.3391C79.0588 86.2659 78.6603 86.2294 78.2617 86.2294C75.8342 86.2294 72.5371 87.2533 72.4646 88.4601C72.3922 90.1788 72.1748 94.2014 73.0443 95.1522C73.9139 96.103 75.7617 96.688 75.7617 96.688C75.6168 96.688 75.4719 96.7246 75.3632 96.7246H75.3269C74.711 96.8709 74.2037 97.1634 73.8052 97.6023C71.9936 99.4673 71.9211 103.6 72.5371 105.574C74.8922 113.363 71.4864 119.617 69.8922 119.617Z'
											fill='#DCDCDC'
										/>
										<path
											d='M82.0658 144.52C82.0658 144.081 81.9933 143.679 81.9208 143.313C81.6672 142.399 81.0513 141.704 79.6382 140.863C77.6817 139.693 75.5802 137.06 72.6092 133.549C75.544 137.097 77.6455 139.693 79.6382 140.863C81.0513 141.704 81.6672 142.399 81.9208 143.313C81.9933 143.679 82.0295 144.045 82.0658 144.52Z'
											fill='#C4D9C3'
										/>
										<path
											d='M82.0658 144.52C82.0658 144.081 81.9933 143.679 81.9208 143.313C81.6672 142.399 81.0513 141.704 79.6382 140.863C77.6817 139.693 75.5802 137.06 72.6092 133.549C70.2542 130.734 67.6455 129.198 66.2324 127.442C68.0078 128.43 70.4353 127.918 71.1962 129.454C72.3194 131.684 77.5005 135.049 77.5005 135.049C82.573 140.132 82.0658 144.52 82.0658 144.52Z'
											fill='#DCDCDC'
										/>
										<path
											d='M85.5787 96.1377C85.3251 96.0656 85.1077 96.0296 84.8903 96.0296C85.1077 95.9936 85.3251 96.0656 85.5787 96.1377Z'
											fill='#C4D9C3'
										/>
										<path
											d='M82.3548 116.399C82.3186 116.399 82.3186 116.399 82.2824 116.399C81.2679 116.289 80.1084 110.95 80.036 108.463C79.8186 100.894 80.1084 97.7487 80.1084 97.7487C80.1084 97.7487 79.565 93.5433 79.9273 90.6909C79.9635 91.1297 79.9997 91.5686 80.036 92.0074C80.1447 94.6038 80.3983 96.5419 80.3983 96.5419C80.3983 96.5419 83.1519 96.286 84.6374 96.03C84.7099 96.03 84.7824 96.03 84.8548 96.03C85.0722 96.03 85.2896 96.0665 85.5432 96.1397C85.5432 96.1397 85.5432 96.1397 85.5795 96.1397C85.5795 96.1397 85.5795 96.1397 85.5432 96.1397C84.9273 96.1397 83.3331 100.089 83.1882 101.479C82.8258 105.172 84.6737 116.399 82.3548 116.399Z'
											fill='#DCDCDC'
										/>
										<path
											d='M90.0717 97.8947C89.6732 97.8947 89.2746 97.7849 88.8398 97.6387C89.2746 97.7849 89.7094 97.8947 90.0717 97.8947ZM90.3254 97.8947C90.434 97.8947 90.579 97.8947 90.6877 97.8581C90.5427 97.8581 90.434 97.8947 90.3254 97.8947ZM90.6877 97.8581H90.7239C90.7239 97.8581 90.7239 97.8581 90.6877 97.8581ZM94.3109 97.7849C93.9848 97.7484 93.6225 97.7484 93.2964 97.7484C93.6225 97.7118 93.9848 97.7484 94.3109 97.7849Z'
											fill='#C4D9C3'
										/>
										<path
											d='M90.4703 99.4308C89.1297 99.4308 86.8834 96.6882 85.6152 96.1396C86.5935 96.4688 87.7167 97.2367 88.8399 97.639C89.2747 97.7852 89.6732 97.895 90.0718 97.895C90.108 97.895 90.1805 97.895 90.2167 97.895C90.2529 97.895 90.2529 97.895 90.2891 97.895C90.3978 97.895 90.5428 97.895 90.6515 97.8584H90.6877H90.7239C90.7602 97.8584 90.7602 97.8584 90.7964 97.8584H90.8326C91.7022 97.7853 92.4993 97.7487 93.2602 97.7487C93.6225 97.7487 93.9486 97.7487 94.2747 97.7852H94.3109C93.0065 97.895 91.7022 99.2114 90.6152 99.4308C90.6152 99.4308 90.5428 99.4308 90.4703 99.4308Z'
											fill='#DCDCDC'
										/>
										<path
											d='M100.217 100.124C100.434 100.124 100.688 100.124 100.941 100.088C100.688 100.124 100.47 100.124 100.217 100.124Z'
											fill='#C4D9C3'
										/>
										<path
											d='M99.8191 117.386C99.7104 117.386 99.6017 117.313 99.493 117.167C97.2829 114.388 99.6017 104.807 97.9713 101.113C97.4641 99.9429 95.6525 98.0779 95.2539 97.895C96.7756 98.1876 99.1307 100.126 100.254 100.126C100.471 100.126 100.725 100.126 100.979 100.089C101.305 100.053 101.631 100.053 101.993 100.053C102.247 100.053 102.537 100.053 102.79 100.089H102.826C102.355 100.601 101.486 102.1 101.268 102.795C100.254 106.013 101.051 117.386 99.8191 117.386Z'
											fill='#DCDCDC'
										/>
										<path
											d='M117.463 145.215C116.703 144.045 116.014 142.984 115.471 142.18C116.014 143.021 116.703 144.045 117.463 145.215Z'
											fill='#7C86BD'
										/>
										<path
											d='M115.471 142.18C114.673 140.936 114.166 140.168 114.166 140.168C113.478 136.987 112.572 135.561 111.594 133.184C112.536 135.597 113.478 136.987 114.166 140.168C114.202 140.168 114.673 140.936 115.471 142.18Z'
											fill='#C4D9C3'
										/>
										<path
											d='M117.5 145.288C115.761 143.313 113.986 141.448 112.79 140.754C109.928 139.035 109.094 137.279 108.841 134.317C108.587 131.355 109.348 131.428 110.181 128.503C110.978 125.87 109.71 122.652 109.565 122.652C109.565 122.652 109.529 122.689 109.565 122.762C109.674 123.53 108.333 128.942 107.319 129.198C107.283 129.198 107.246 129.198 107.21 129.198C106.304 129.198 105.978 125.724 105.833 122.835C105.725 119.873 107.319 106.05 106.848 103.344C106.775 102.905 106.667 102.539 106.486 102.21C107.102 102.868 107.609 103.673 107.971 104.55C108.768 106.489 110.87 109.085 110.942 109.597C110.942 109.633 110.942 109.67 110.942 109.707C110.942 110.145 110.797 111.169 110.797 112.449C110.797 113.071 110.833 113.729 110.942 114.424C111.232 116.143 111.703 118.52 111.703 121.116C111.703 121.884 111.667 122.689 111.558 123.493C111.268 125.797 110.797 127.698 110.797 129.49C110.797 130.478 110.942 131.428 111.304 132.416C111.377 132.672 111.486 132.891 111.558 133.111C112.5 135.524 113.442 136.914 114.131 140.095C114.131 140.095 114.638 140.863 115.435 142.107C115.978 142.948 116.667 143.972 117.428 145.142C117.464 145.251 117.5 145.251 117.5 145.288Z'
											fill='#DCDCDC'
										/>
										<path
											d='M91.8107 123.42C91.702 123.42 91.6296 123.31 91.5209 123.127C90.9049 121.628 89.1296 104.843 91.0499 104.843C91.1948 104.843 91.3397 104.916 91.5209 105.135C92.1731 105.83 92.5716 114.936 92.9702 117.166C93.2962 119.105 92.4629 123.42 91.8107 123.42Z'
											fill='#DCDCDC'
										/>
										<path
											d='M89.1303 158.416C88.0434 155.564 87.0289 153.114 86.3405 151.688C85.1448 149.238 84.0941 147.811 83.3695 146.787C83.0072 146.276 82.7173 145.873 82.5361 145.544C82.355 145.178 82.2463 144.849 82.2463 144.52C82.2463 144.081 82.1738 143.643 82.0651 143.277C81.9202 142.801 81.7028 142.363 81.3043 141.96C80.9057 141.558 80.3985 141.156 79.6738 140.754C77.7535 139.62 75.6521 137.024 72.7173 133.476C70.326 130.624 67.7173 129.088 66.3405 127.369C66.0144 126.931 65.7246 126.492 65.5434 126.016C65.2535 125.212 65.1448 124.261 65.1448 123.201C65.1448 121.08 65.5434 118.52 65.5434 116.033C65.5434 114.168 65.5072 112.486 65.5072 111.133C65.5072 109.78 65.5434 108.719 65.7246 108.061C65.7608 107.951 65.797 107.805 65.8695 107.659L65.6883 107.586L65.8332 107.659V107.622C66.1231 107.001 66.739 106.196 67.3188 105.355C67.8985 104.477 68.4419 103.563 68.6231 102.539C68.8405 101.442 69.0941 100.162 69.2753 99.0652C69.384 98.5166 69.4564 98.0412 69.5651 97.6755C69.6014 97.4927 69.6376 97.3464 69.6738 97.2367C69.7101 97.127 69.7101 97.0539 69.7463 97.0173C69.7463 96.9807 69.855 96.871 69.9637 96.8344C70.0724 96.7613 70.2535 96.7247 70.4347 96.7247C70.6159 96.7247 70.8333 96.7613 71.0506 96.871C71.0869 96.9076 71.1593 96.9076 71.2318 96.871C71.3043 96.8345 71.3043 96.7979 71.3405 96.7247C71.3405 96.7247 71.6666 93.7627 71.6666 91.6782C71.6666 91.3857 71.6666 91.0931 71.6303 90.8372C71.6303 90.6909 71.6303 90.5812 71.6303 90.4349C71.6303 88.5699 72.3912 86.1198 72.5724 82.4629C72.6811 80.5247 72.826 79.6105 73.0434 78.8426C73.2608 78.0746 73.5506 77.453 73.913 76.0999C74.2028 74.9297 74.6014 74.1252 75.0361 73.6498C75.4709 73.1744 75.9782 72.955 76.5941 72.955C76.739 72.955 76.9202 72.955 77.1014 72.9916C77.9709 73.1378 78.4782 73.5035 78.8043 74.0521C79.1303 74.6006 79.239 75.4051 79.3115 76.3193C79.3115 76.3559 79.3477 76.3925 79.3477 76.429L79.4927 76.2828H79.3115C79.3477 77.0507 79.3477 77.8918 79.3477 78.7694C79.3477 78.8791 79.3477 78.9523 79.3477 79.062C79.384 80.671 79.4202 81.8412 79.4202 82.8652C79.4202 83.6697 79.384 84.401 79.3477 85.2056C79.3477 85.425 79.3115 85.6078 79.3115 85.8272C79.3115 85.9735 79.3115 86.0832 79.3115 86.2295C79.3477 87.546 79.5651 89.0087 79.7101 90.6178C79.7463 91.0566 79.7825 91.4588 79.8188 91.9342C79.9275 94.5672 80.1811 96.4688 80.1811 96.4688C80.1811 96.5785 80.2898 96.6516 80.3622 96.615C80.3622 96.615 83.1159 96.3591 84.6376 96.1031C84.7101 96.1031 84.7825 96.1031 84.855 96.1031C85.0724 96.1031 85.2898 96.1396 85.5072 96.2128L85.5434 96.0299L85.4709 96.2128H85.5072C86.1593 96.4322 86.9202 96.8345 87.6811 97.2367C88.4419 97.639 89.239 97.9681 90.0361 97.9681C90.0724 97.9681 90.1448 97.9681 90.1811 97.9681C91.268 97.8949 92.2463 97.7852 93.1883 97.7852C93.5506 97.7852 93.913 97.7852 94.239 97.8218C94.5289 97.8584 94.8188 97.8949 95.0724 97.9315C95.797 98.0778 96.7753 98.6263 97.6811 99.1383C98.1521 99.3943 98.5869 99.6503 98.9854 99.8331C99.384 100.016 99.7463 100.162 100.109 100.162C100.688 100.162 101.232 100.089 101.812 100.089C102.065 100.089 102.355 100.089 102.645 100.162C103.007 100.199 103.406 100.308 103.84 100.491C104.674 100.82 105.543 101.442 106.268 102.247C106.848 102.905 107.355 103.673 107.717 104.55C108.116 105.538 108.84 106.671 109.493 107.622C109.819 108.098 110.109 108.536 110.326 108.866C110.435 109.048 110.507 109.195 110.58 109.304C110.652 109.414 110.688 109.524 110.688 109.524C110.688 109.56 110.688 109.597 110.688 109.634C110.688 109.853 110.652 110.219 110.616 110.694C110.58 111.169 110.543 111.755 110.543 112.376C110.543 112.998 110.58 113.693 110.688 114.387C110.978 116.106 111.449 118.483 111.449 121.08C111.449 121.848 111.413 122.615 111.304 123.42C111.014 125.724 110.543 127.589 110.543 129.454C110.543 130.441 110.688 131.429 111.051 132.453C111.594 133.879 112.101 134.939 112.572 136.073C113.043 137.206 113.478 138.413 113.877 140.132L113.913 140.205C113.913 140.205 115.29 142.363 117.21 145.288C118.551 147.336 120.145 149.75 121.703 152.127C121.775 152.2 121.884 152.236 121.956 152.163C122.029 152.09 122.065 151.98 121.993 151.907C120.435 149.53 118.84 147.117 117.5 145.069C116.522 143.606 115.725 142.326 115.109 141.412C114.819 140.973 114.565 140.607 114.42 140.351C114.275 140.095 114.167 139.986 114.167 139.986L114.022 140.095L114.203 140.059C113.84 138.304 113.369 137.097 112.898 135.927C112.427 134.793 111.884 133.732 111.377 132.306C111.014 131.319 110.906 130.405 110.906 129.454C110.906 127.662 111.377 125.797 111.667 123.457C111.775 122.652 111.812 121.848 111.812 121.08C111.812 118.447 111.34 116.07 111.051 114.351C110.942 113.693 110.906 112.998 110.906 112.413C110.906 111.791 110.942 111.206 110.978 110.767C111.014 110.292 111.051 109.926 111.051 109.67C111.051 109.634 111.051 109.56 111.051 109.524C111.051 109.414 110.978 109.304 110.906 109.195C110.652 108.756 110.145 107.988 109.565 107.11C108.985 106.233 108.406 105.282 108.08 104.441C107.717 103.563 107.174 102.722 106.558 102.064C105.797 101.223 104.891 100.564 103.985 100.199C103.514 100.016 103.08 99.9062 102.681 99.8697C102.355 99.8331 102.065 99.7965 101.812 99.7965C101.196 99.7965 100.616 99.8697 100.109 99.8697C99.8912 99.8697 99.5289 99.76 99.1666 99.5771C98.5869 99.3211 97.8985 98.8823 97.1738 98.48C96.4854 98.0778 95.7608 97.7487 95.1448 97.6024C94.855 97.5293 94.5651 97.4927 94.2753 97.4927C93.913 97.4561 93.5506 97.4561 93.1883 97.4561C92.2101 97.4561 91.2318 97.5658 90.1448 97.639C90.1086 97.639 90.0361 97.639 89.9999 97.639C89.3477 97.639 88.5869 97.3099 87.826 96.9442C87.0651 96.5785 86.3043 96.1397 85.6159 95.8837H85.5796C85.326 95.8105 85.0724 95.7374 84.8188 95.7374C84.7101 95.7374 84.6376 95.7374 84.5651 95.774C83.8405 95.8837 82.7898 96.0299 81.884 96.1031C81.4492 96.1396 81.0506 96.1762 80.7608 96.2128C80.4709 96.2494 80.2898 96.2494 80.2898 96.2494V96.4322L80.4709 96.3956C80.4709 96.3956 80.4709 96.2859 80.4347 96.0665C80.3622 95.4083 80.1811 93.8358 80.1086 91.8977C80.0724 91.4588 80.0724 91.02 79.9999 90.5812C79.855 88.9721 79.6376 87.5094 79.6014 86.2295C79.6014 86.0832 79.6014 85.9735 79.6014 85.8272C79.6014 85.6078 79.6014 85.425 79.6376 85.2056C79.6738 84.401 79.7101 83.6697 79.7101 82.8286C79.7101 81.7681 79.6738 80.6345 79.6376 79.0254C79.6376 78.9157 79.6376 78.8426 79.6376 78.7329C79.6376 77.8552 79.6376 77.0141 79.6014 76.2096C79.6014 76.1731 79.5651 76.1365 79.5651 76.0999L79.4202 76.2462H79.6014C79.5651 75.2954 79.4202 74.4909 79.0579 73.8326C78.6956 73.1744 78.0796 72.7356 77.1014 72.5893C76.9202 72.5527 76.739 72.5527 76.5579 72.5527C75.8695 72.5527 75.2173 72.8087 74.7101 73.3573C74.2028 73.9058 73.8043 74.7469 73.5144 75.9536C73.1883 77.2701 72.8985 77.8918 72.6448 78.6963C72.3912 79.5008 72.2463 80.4516 72.1376 82.3898C71.9564 86.0101 71.1956 88.4236 71.1956 90.3618C71.1956 90.508 71.1956 90.6543 71.1956 90.764C71.1956 91.02 71.2318 91.276 71.2318 91.5685C71.2318 92.5925 71.1593 93.8358 71.0506 94.8232C71.0144 95.3351 70.9782 95.7374 70.9419 96.0665C70.9057 96.3591 70.9057 96.5419 70.9057 96.5419L71.0869 96.5785L71.1593 96.4322C70.9057 96.2859 70.6159 96.2494 70.3985 96.2494C70.1448 96.2494 69.9275 96.3225 69.7463 96.3956C69.5651 96.5053 69.4202 96.615 69.3477 96.7613C69.3115 96.8345 69.3115 96.9076 69.2753 97.0173C69.0941 97.8584 68.6231 100.418 68.2246 102.32C68.0434 103.234 67.5361 104.148 66.9564 104.989C66.413 105.83 65.797 106.598 65.4709 107.293V107.33C65.3985 107.476 65.326 107.659 65.2898 107.805C65.1086 108.536 65.0361 109.597 65.0361 110.95C65.0361 112.34 65.0724 113.985 65.0724 115.85C65.0724 118.3 64.6738 120.86 64.6738 123.018C64.6738 124.115 64.7825 125.102 65.1086 125.98C65.2898 126.492 65.5796 126.967 65.9419 127.406C67.3912 129.198 69.9999 130.734 72.3188 133.513C75.2898 137.06 77.355 139.657 79.384 140.9C80.0724 141.302 80.5796 141.704 80.9057 142.07C81.268 142.436 81.4492 142.802 81.5579 143.24C81.6666 143.569 81.7028 143.972 81.7028 144.411C81.7028 144.849 81.8477 145.215 82.0651 145.617C82.2825 146.02 82.5724 146.422 82.9347 146.934C83.6593 147.958 84.6738 149.347 85.8695 151.797C86.5579 153.187 87.5724 155.637 88.6231 158.49C88.6593 158.599 88.768 158.636 88.8405 158.599C89.1303 158.636 89.1666 158.526 89.1303 158.416Z'
											fill='#2E353A'
										/>
										<path
											d='M71.0149 96.6515C71.0149 98.0046 70.9425 99.5405 70.8338 100.894C70.7251 102.247 70.5439 103.453 70.3627 104.112C70.254 104.477 70.1816 105.062 70.1454 105.721C70.0729 106.745 70.0367 107.988 69.9642 109.195C69.8917 110.365 69.7468 111.498 69.4569 112.193C69.4207 112.303 69.4569 112.376 69.5656 112.413C69.6743 112.449 69.7468 112.413 69.783 112.303C70.1816 111.279 70.2903 109.597 70.3627 107.988C70.399 107.183 70.4352 106.415 70.4714 105.721C70.5077 105.062 70.5801 104.514 70.6526 104.185C70.87 103.453 71.0149 102.247 71.1236 100.894C71.2323 99.5039 71.3048 97.968 71.3048 96.615C71.3048 96.5053 71.2323 96.4321 71.1236 96.4321C71.0149 96.4321 71.0149 96.5418 71.0149 96.6515Z'
											fill='#2E353A'
										/>
										<path
											d='M72.7174 98.9189C72.7174 98.9189 72.7537 98.8824 72.7899 98.8458C72.9711 98.6264 73.4783 98.151 74.058 97.6756C74.6377 97.2368 75.3261 96.8345 75.8696 96.8345C76.5218 96.8345 77.2102 97.0539 77.8986 97.3099C78.587 97.5659 79.3479 97.8219 80.1088 97.9316C80.2175 97.9316 80.3261 97.9316 80.4348 97.9316C81.1595 97.9316 81.8841 97.6756 82.5725 97.4196C83.2609 97.1271 83.9493 96.8345 84.5653 96.7248C84.674 96.6882 84.7464 96.6151 84.7102 96.5054C84.674 96.3957 84.6015 96.3226 84.4928 96.3591C83.8044 96.5054 83.116 96.7979 82.4276 97.0539C81.7392 97.3099 81.0508 97.5659 80.3986 97.5659C80.2899 97.5659 80.2175 97.5659 80.1088 97.5659C79.3841 97.4928 78.6957 97.2368 77.9711 96.9808C77.2464 96.7248 76.558 96.5054 75.7972 96.5054C75.3986 96.5054 75.0001 96.6517 74.6015 96.8711C73.4421 97.4928 72.3914 98.7361 72.3551 98.7361C72.2827 98.8092 72.2827 98.9189 72.3551 98.9921C72.5363 98.9921 72.645 98.9921 72.7174 98.9189Z'
											fill='#2E353A'
										/>
										<path
											d='M73.6958 89.0087H73.7321C73.9494 88.9355 74.9277 88.6064 75.906 88.6064C76.4494 88.6064 76.9929 88.7161 77.3915 88.9721C77.4639 89.0452 77.5726 89.0087 77.6451 88.9355C77.7176 88.8624 77.6813 88.7527 77.6089 88.6795C77.1378 88.3504 76.5219 88.2407 75.906 88.2407C74.7103 88.2407 73.5871 88.6795 73.5871 88.6795C73.4784 88.7161 73.4422 88.8258 73.4784 88.899C73.5147 89.0087 73.6234 89.0452 73.6958 89.0087Z'
											fill='#2E353A'
										/>
										<path
											d='M75.6167 87.8017C75.6167 87.8017 75.7616 87.7651 75.979 87.7651C76.3051 87.7651 76.8124 87.8382 77.4283 88.1308C77.5008 88.1674 77.6095 88.1308 77.6819 88.0577C77.7182 87.9845 77.6819 87.8748 77.6095 87.8017C76.9211 87.4726 76.3776 87.3994 76.0153 87.3994C75.7254 87.3994 75.5805 87.436 75.5805 87.436C75.4718 87.4726 75.4355 87.5457 75.4355 87.6554C75.4355 87.7651 75.508 87.8382 75.6167 87.8017Z'
											fill='#2E353A'
										/>
										<path
											d='M74.9283 81.1829C75.0733 81.1463 75.5805 81.0366 76.2327 81.0366C76.595 81.0366 77.0298 81.0732 77.4646 81.1829C77.5733 81.2194 77.6457 81.1463 77.682 81.0366C77.7182 80.9269 77.6457 80.8537 77.537 80.8172C77.066 80.7075 76.6312 80.6709 76.2327 80.6709C75.4356 80.6709 74.8559 80.8172 74.8559 80.8172C74.7472 80.8537 74.7109 80.9269 74.7109 81.0366C74.7472 81.1463 74.8559 81.2194 74.9283 81.1829Z'
											fill='#2E353A'
										/>
										<path
											d='M65.8325 107.622C65.8325 107.622 65.9412 107.585 66.0861 107.512C66.3397 107.403 66.702 107.22 67.1006 107.074C67.4629 106.927 67.8615 106.781 68.0788 106.781C68.1875 106.781 68.26 106.671 68.2238 106.562C68.2238 106.452 68.1151 106.379 68.0064 106.415C67.6441 106.452 67.0644 106.708 66.5571 106.891C66.0499 107.11 65.6513 107.293 65.6513 107.293C65.5788 107.329 65.5064 107.439 65.5788 107.549C65.6513 107.659 65.76 107.695 65.8325 107.622Z'
											fill='#2E353A'
										/>
										<path
											d='M69.9277 109.926C69.9277 109.926 69.6741 110.328 69.4205 110.804C69.1669 111.279 68.8408 111.864 68.7321 112.267C68.6958 112.376 68.7683 112.449 68.877 112.486C68.9857 112.523 69.0582 112.449 69.0944 112.34C69.1669 112.011 69.4567 111.425 69.7466 110.95C69.8915 110.731 70.0002 110.511 70.1089 110.328C70.2176 110.182 70.2538 110.072 70.2538 110.072C70.2901 109.999 70.2901 109.89 70.1814 109.816C70.0727 109.816 69.964 109.816 69.9277 109.926Z'
											fill='#2E353A'
										/>
										<path
											d='M74.8916 74.3079L74.7105 74.2713C74.7105 74.2713 74.5293 75.6975 74.5293 76.7214C74.5293 76.9774 74.5293 77.2334 74.5655 77.4162C74.5655 77.526 74.6018 77.5991 74.638 77.6722C74.6742 77.7454 74.7105 77.8185 74.7829 77.8916C74.8916 77.9648 75.0003 78.0014 75.1452 78.0379C75.6163 78.1476 76.4134 78.2573 77.138 78.2573C77.5003 78.2573 77.8264 78.2208 78.1163 78.1842C78.2612 78.1476 78.3699 78.1111 78.4786 78.0745C78.5873 78.0379 78.6597 77.9648 78.7322 77.8551C78.8047 77.6722 78.8409 77.4162 78.9134 77.1237C79.0221 76.2095 79.0583 74.9296 79.0583 74.9296C79.0583 74.893 79.0583 74.8564 79.0221 74.8199C79.0221 74.8199 78.7684 74.4176 78.3699 73.9788C77.9713 73.5765 77.3554 73.1377 76.6307 73.1377C76.051 73.1377 75.3989 73.4302 74.7467 74.1982C74.7105 74.2348 74.7105 74.2713 74.7105 74.3079H74.8916L75.0365 74.4176C75.6525 73.6862 76.196 73.4668 76.6307 73.4668C77.2105 73.4668 77.7177 73.8325 78.1163 74.1982C78.2974 74.381 78.4423 74.5639 78.551 74.7102C78.5873 74.7833 78.6235 74.8564 78.6597 74.893L78.696 74.9296L78.8409 74.8199H78.6597C78.6597 74.8199 78.6597 74.9661 78.6597 75.1856C78.6597 75.5147 78.6235 76.0266 78.5873 76.5386C78.551 76.7946 78.551 77.014 78.5148 77.1968C78.4786 77.3797 78.4423 77.5625 78.4061 77.6357C78.3699 77.6722 78.1887 77.7454 77.9713 77.7819C77.7539 77.8185 77.4641 77.8185 77.1742 77.8185C76.7032 77.8185 76.196 77.7819 75.7974 77.7088C75.58 77.6722 75.3989 77.6357 75.2539 77.5991C75.109 77.5625 75.0003 77.526 75.0003 77.526C75.0003 77.526 74.9641 77.4894 74.9641 77.4528C74.9278 77.3065 74.8916 77.014 74.8916 76.6483C74.8916 76.1363 74.9278 75.5512 74.9641 75.0758C75.0003 74.8199 75.0003 74.637 75.0365 74.4907C75.0365 74.3445 75.0728 74.2713 75.0728 74.2713L74.8916 74.3079Z'
											fill='#2E353A'
										/>
										<path
											d='M68.6233 102.575C68.6233 102.575 69.2755 102.246 69.9277 101.698C70.2537 101.405 70.5798 101.076 70.8335 100.674C71.0871 100.272 71.2682 99.8328 71.3045 99.3209C71.3045 99.2477 71.3045 99.1746 71.3045 99.1014C71.3045 98.6992 71.2682 98.3701 71.1595 98.1141C71.0871 97.9312 70.9784 97.785 70.8697 97.6387C70.6885 97.4558 70.4711 97.3827 70.2175 97.3461C70.0001 97.3096 69.7465 97.3096 69.4929 97.3096C69.3842 97.3096 69.3117 97.3827 69.3117 97.4924C69.3117 97.6021 69.3842 97.6753 69.4929 97.6753C69.7103 97.6753 69.9277 97.6753 70.1088 97.7118C70.2537 97.7118 70.3624 97.7484 70.4711 97.8215C70.6161 97.8947 70.7248 98.0044 70.7972 98.1872C70.8697 98.3701 70.9421 98.6992 70.9421 99.138C70.9421 99.2112 70.9421 99.2843 70.9421 99.3209C70.9421 99.7231 70.761 100.125 70.5436 100.491C70.1813 101.04 69.674 101.478 69.2393 101.808C69.0219 101.954 68.8407 102.1 68.6958 102.173C68.6233 102.21 68.5871 102.246 68.5146 102.283C68.4784 102.32 68.4421 102.319 68.4421 102.319C68.3697 102.356 68.3335 102.466 68.3697 102.575C68.4059 102.612 68.5146 102.649 68.6233 102.575Z'
											fill='#2E353A'
										/>
										<path
											d='M107.573 106.598C107.573 106.744 107.573 106.891 107.573 107.037C107.573 108.646 107.392 111.389 107.174 113.875C106.993 116.362 106.776 118.593 106.739 119.178C106.703 119.617 106.703 120.238 106.703 120.897C106.703 122.213 106.739 123.603 106.739 123.639C106.739 123.749 106.812 123.822 106.921 123.822C107.029 123.822 107.102 123.749 107.102 123.639C107.102 123.639 107.102 123.274 107.102 122.762C107.102 122.25 107.065 121.555 107.065 120.897C107.065 120.238 107.065 119.617 107.102 119.214C107.138 118.629 107.355 116.399 107.536 113.912C107.718 111.425 107.935 108.683 107.935 107.074C107.935 106.927 107.935 106.744 107.935 106.635C107.935 106.525 107.863 106.452 107.754 106.452C107.681 106.415 107.573 106.488 107.573 106.598Z'
											fill='#2E353A'
										/>
										<path
											d='M89.6369 100.052C90.1441 100.82 90.4702 101.369 90.6514 101.881C90.8326 102.393 90.905 102.905 90.905 103.563C90.905 104.733 90.7239 106.452 90.7239 109.56C90.7239 112.23 90.8688 115.996 91.3398 121.408C91.3398 121.518 91.4485 121.591 91.521 121.591C91.6297 121.591 91.7021 121.482 91.7021 121.408C91.2311 116.033 91.0862 112.303 91.0862 109.597C91.0862 106.488 91.2673 104.806 91.2673 103.599C91.2673 102.905 91.1949 102.356 91.0137 101.771C90.8326 101.186 90.4702 100.637 89.963 99.8694C89.8905 99.7963 89.7818 99.7597 89.7094 99.8328C89.6007 99.8694 89.6007 99.9791 89.6369 100.052Z'
											fill='#2E353A'
										/>
										<path
											d='M114.312 140.022C114.312 140.022 114.276 139.986 114.203 139.949C113.986 139.766 113.406 139.291 112.827 138.742C112.537 138.486 112.247 138.194 112.029 137.901C111.812 137.609 111.631 137.353 111.558 137.17C111.522 137.06 111.413 137.024 111.341 137.06C111.232 137.097 111.196 137.206 111.232 137.28C111.341 137.572 111.595 137.901 111.885 138.267C112.754 139.254 114.095 140.315 114.095 140.351C114.167 140.424 114.276 140.388 114.348 140.315C114.385 140.205 114.385 140.095 114.312 140.022Z'
											fill='#2E353A'
										/>
										<path
											d='M80.5433 139.401C80.8694 139.986 81.1955 140.937 81.3767 141.741C81.5941 142.546 81.7028 143.277 81.7028 143.35V143.387C81.739 143.496 81.8477 143.533 81.9201 143.496C82.0288 143.46 82.0651 143.35 82.0288 143.277C82.0288 143.204 81.8839 142.472 81.7028 141.631C81.4854 140.79 81.1955 139.839 80.8332 139.181C80.797 139.108 80.652 139.072 80.5796 139.108C80.5071 139.181 80.5071 139.291 80.5433 139.401Z'
											fill='#2E353A'
										/>
									</g>
									<defs>
										<filter
											id='filter0_d_461_5371'
											x='-4'
											y='0'
											width='158'
											height='170'
											filterUnits='userSpaceOnUse'
											color-interpolation-filters='sRGB'
										>
											<feFlood flood-opacity='0' result='BackgroundImageFix' />
											<feColorMatrix
												in='SourceAlpha'
												type='matrix'
												values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
												result='hardAlpha'
											/>
											<feOffset dy='4' />
											<feGaussianBlur stdDeviation='2' />
											<feComposite in2='hardAlpha' operator='out' />
											<feColorMatrix
												type='matrix'
												values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0'
											/>
											<feBlend
												mode='normal'
												in2='BackgroundImageFix'
												result='effect1_dropShadow_461_5371'
											/>
											<feBlend
												mode='normal'
												in='SourceGraphic'
												in2='effect1_dropShadow_461_5371'
												result='shape'
											/>
										</filter>
										<clipPath id='clip0_461_5371'>
											<rect width='150' height='162' fill='white' />
										</clipPath>
									</defs>
								</svg>
							</div>

							<div className='flex items-center flex-col justify-center p-8 mt-3'>
								<span className='hr-grid-head'>BIO METRIC CAPTURE</span>
								<span className='hr-grid-text my-3'>
									A top notch Face-ID & Fingerprint bio-metrics system for
									forward thinking companies.
								</span>
								<a rel='noreferrer' target='_blank' href='https://ndovuhr.com'>
									<div className='flex items-center justify-center'>
										<span className='hr-grid-footer mr-3'>Learn more</span>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='9'
											height='13'
											viewBox='0 0 9 13'
											fill='none'
										>
											<g clip-path='url(#clip0_461_5635)'>
												<path
													d='M5.11977 6.51033L0.826773 2.21733C0.731263 2.12509 0.65508 2.01474 0.602671 1.89274C0.550262 1.77074 0.522676 1.63951 0.521522 1.50674C0.520368 1.37396 0.54567 1.24228 0.595951 1.11938C0.646232 0.996485 0.720485 0.884834 0.814377 0.790941C0.90827 0.697048 1.01992 0.622795 1.14282 0.572514C1.26572 0.522233 1.3974 0.496931 1.53017 0.498085C1.66295 0.499239 1.79417 0.526824 1.91617 0.579234C2.03818 0.631643 2.14852 0.707825 2.24077 0.803336L7.24077 5.80334C7.42824 5.99086 7.53355 6.24517 7.53355 6.51033C7.53355 6.7755 7.42824 7.02981 7.24077 7.21733L2.24077 12.2173C2.05217 12.3995 1.79956 12.5003 1.53737 12.498C1.27517 12.4957 1.02436 12.3906 0.838953 12.2052C0.653545 12.0197 0.548376 11.7689 0.546097 11.5067C0.543819 11.2445 0.644614 10.9919 0.826772 10.8033L5.11977 6.51033Z'
													fill='#387E1B'
												/>
											</g>
											<defs>
												<clipPath id='clip0_461_5635'>
													<rect
														width='8'
														height='13'
														fill='white'
														transform='translate(0.521484)'
													/>
												</clipPath>
											</defs>
										</svg>
									</div>
								</a>
							</div>
						</div>

						<div className='flex flex-col text-center border border-gray-300'>
							<div className='curved-div w-full flex justify-center items-center bg-[#F3F7FD] p-7'>
								<img
									className='w-[110px] h-[165px] object-contain'
									src={home9}
									alt='Face scanner'
								/>
							</div>

							<div className='flex items-center flex-col justify-center p-8 mt-3'>
								<span className='hr-grid-head'>EASY MANAGEMENT OF CASUALS</span>
								<span className='hr-grid-text my-3'>
									The fastest way to clock-in and clock-out casuals on the field
									without hassle.
								</span>
								<a rel='noreferrer' target='_blank' href='https://ndovuhr.com'>
									<div className='flex items-center justify-center'>
										<span className='hr-grid-footer mr-3'>Learn more</span>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='9'
											height='13'
											viewBox='0 0 9 13'
											fill='none'
										>
											<g clip-path='url(#clip0_461_5635)'>
												<path
													d='M5.11977 6.51033L0.826773 2.21733C0.731263 2.12509 0.65508 2.01474 0.602671 1.89274C0.550262 1.77074 0.522676 1.63951 0.521522 1.50674C0.520368 1.37396 0.54567 1.24228 0.595951 1.11938C0.646232 0.996485 0.720485 0.884834 0.814377 0.790941C0.90827 0.697048 1.01992 0.622795 1.14282 0.572514C1.26572 0.522233 1.3974 0.496931 1.53017 0.498085C1.66295 0.499239 1.79417 0.526824 1.91617 0.579234C2.03818 0.631643 2.14852 0.707825 2.24077 0.803336L7.24077 5.80334C7.42824 5.99086 7.53355 6.24517 7.53355 6.51033C7.53355 6.7755 7.42824 7.02981 7.24077 7.21733L2.24077 12.2173C2.05217 12.3995 1.79956 12.5003 1.53737 12.498C1.27517 12.4957 1.02436 12.3906 0.838953 12.2052C0.653545 12.0197 0.548376 11.7689 0.546097 11.5067C0.543819 11.2445 0.644614 10.9919 0.826772 10.8033L5.11977 6.51033Z'
													fill='#387E1B'
												/>
											</g>
											<defs>
												<clipPath id='clip0_461_5635'>
													<rect
														width='8'
														height='13'
														fill='white'
														transform='translate(0.521484)'
													/>
												</clipPath>
											</defs>
										</svg>
									</div>
								</a>
							</div>
						</div>

						<div className='flex flex-col text-center border border-gray-300'>
							<div className='curved-div w-full flex justify-center items-center bg-[#F3F7FD] p-7'>
								<img
									className='w-[110px] h-[165px] object-contain'
									src={home10}
									alt='Face scanner'
								/>
							</div>

							<div className='flex items-center flex-col justify-center p-8 mt-3'>
								<span className='hr-grid-head'>SEAMLESS PAYROLL</span>
								<span className='hr-grid-text my-3'>
									Accurate and easy to use payroll management for your HR team.
								</span>
								<a rel='noreferrer' target='_blank' href='https://ndovuhr.com'>
									<div className='flex items-center justify-center'>
										<span className='hr-grid-footer mr-3'>Learn more</span>
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='9'
											height='13'
											viewBox='0 0 9 13'
											fill='none'
										>
											<g clip-path='url(#clip0_461_5635)'>
												<path
													d='M5.11977 6.51033L0.826773 2.21733C0.731263 2.12509 0.65508 2.01474 0.602671 1.89274C0.550262 1.77074 0.522676 1.63951 0.521522 1.50674C0.520368 1.37396 0.54567 1.24228 0.595951 1.11938C0.646232 0.996485 0.720485 0.884834 0.814377 0.790941C0.90827 0.697048 1.01992 0.622795 1.14282 0.572514C1.26572 0.522233 1.3974 0.496931 1.53017 0.498085C1.66295 0.499239 1.79417 0.526824 1.91617 0.579234C2.03818 0.631643 2.14852 0.707825 2.24077 0.803336L7.24077 5.80334C7.42824 5.99086 7.53355 6.24517 7.53355 6.51033C7.53355 6.7755 7.42824 7.02981 7.24077 7.21733L2.24077 12.2173C2.05217 12.3995 1.79956 12.5003 1.53737 12.498C1.27517 12.4957 1.02436 12.3906 0.838953 12.2052C0.653545 12.0197 0.548376 11.7689 0.546097 11.5067C0.543819 11.2445 0.644614 10.9919 0.826772 10.8033L5.11977 6.51033Z'
													fill='#387E1B'
												/>
											</g>
											<defs>
												<clipPath id='clip0_461_5635'>
													<rect
														width='8'
														height='13'
														fill='white'
														transform='translate(0.521484)'
													/>
												</clipPath>
											</defs>
										</svg>
									</div>
								</a>
							</div>
						</div>
					</div>
				</div>

				<div className='lg:py-[109px] lg:px-[120px] grid grid-cols-1 lg:grid-cols-2 gap-6'>
					<img
						src={home11}
						className='hidden lg:flex w-[583px] h-[493px]'
						alt='Experience'
					/>

					<div className='lg:ml-14'>
						<span className='lets'>Let’s get started!</span>

						<h2 className='experience mt-[23px]'>
							Experience the Future of Payments
						</h2>

						<div className='flex flex-col'>
							<span className='join mt-[20px]'>
								Join the ranks of successful businesses and corporates that
								trust Ndovupay for their payment needs. Say goodbye to payment
								headaches and hello to efficiency, security, and peace of mind.
							</span>

							<span className='join mt-[20px]'>
								Ready to get started? Contact us today to schedule a demo and
								see how Ndovupay can revolutionize your financial operations.
							</span>

							<a
								rel='noreferrer'
								target='_blank'
								href='mailto:admin@ndovupay.org'
								className='btn bg-[#FFB600] p-[12px] mt-[20px] w-[128px]'
								type='button'
							>
								Contact us
							</a>
						</div>
					</div>
				</div>

				<div className='flex flex-col justify-center items-center mb-20 mt-20 lg:mt:0'>
					<h3 className='faq mb-7'>Frequently asked questions</h3>
					<Accordion defaultActiveKey='0' className='commonAccording'>
						<Accordion.Item eventKey='0'>
							<Accordion.Header>
								Do I need to have internet to use NdovuPay?
							</Accordion.Header>
							<Accordion.Body>
								No. Dial *873# to use NdovuPay via our USSD code.
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey='1'>
							<Accordion.Header>How does NdovuPay work?</Accordion.Header>
							<Accordion.Body>
								Protecting yourself while transacting is simple regardless of
								the platform you use; mobile, USSD, or website. The buyer and
								seller agree on the price of the product or service inclusive of
								the delivery price and agree to transact via NdovuPay.
								<h3>Step 1</h3>
								The seller creates a transaction, enters the transaction details
								(product name, price, quantity, agreed price, location, delivery
								date, and the phone number of the buyer.
								<h3>Step 2</h3>
								The buyer receives an invitation to pay for the transaction and
								deposits the agreed amount with the escrow fee into NdovuPay
								escrow account. The buyer can deposit via multiple channels
								available.
								<h3>Step 3</h3>
								NdovuPay notifies the seller that they have received the agreed
								amount and instructs the seller to deliver the product/ service.
								<h3>Step 4</h3>
								The buyer receives the product/service that they ordered and
								verifies that the delivered product/ service is the correct
								one(s) as ordered. The buyer does this within the Inspection
								Period. If the product/ service meets the expectations of the
								buyer, the buyer accepts and confirms delivery.
								<h3>Step 5</h3>
								NdovuPay releases the funds held in the escrow account to the
								seller.
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey='2'>
							<Accordion.Header>How does NdovuPay protect me?</Accordion.Header>
							<Accordion.Body>
								Buyers are usually afraid to pay before receiving a product
								while sellers are shy to release a product before it is paid
								for. These interests conflict meaning a transaction may never
								take place because of lack of trust. Mistrust is intensified
								further when both parties are strangers to each other, are in
								different areas geographically, or transacting online. NdovuPay
								brings trust to both the seller and buyer to to transact
								anywhere, anytime in a safe and secure way using any device. It
								is our commitment to ensure a buyer will receive a product or
								service after paying for it and guarantee a seller will receive
								timely payment after delivering a product or service. This way
								we’ll have done our part in stamping out corruption, fraud, and
								scam in e-commerce.
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey='3'>
							<Accordion.Header>
								What is the inspection period?
							</Accordion.Header>
							<Accordion.Body>
								It is the period of time agreed by the seller and buyer for the
								buyer to inspect the product/ service before accepting it and
								releasing payment to the seller. It ends on the delivery
							</Accordion.Body>
						</Accordion.Item>
						<Accordion.Item eventKey='4'>
							<Accordion.Header>Who pays the NdovuPay fee?</Accordion.Header>
							<Accordion.Body>
								NdovuPay fee is 3% of the value of the product. The fee is
								shared by both the buyer and seller. The buyer pays 2% while the
								seller pays 1%.
							</Accordion.Body>
						</Accordion.Item>
					</Accordion>
				</div>

				<div className='px-2 py-2 mt-[12px] bg-[#212529] lg:!py-[109px] lg:!px-[120px]  w-full'>
					<div className='flex flex-col lg:flex-row lg:items-center'>
						<div className='flex flex-col w-full lg:w-[40%]'>
							<span className='what'>What people say about NdovuPay</span>
							<h3 className='hear mt-[23px]'>Trusted by Leading Businesses</h3>
							<p className='hear-p mt-[20px]'>
								See what our partners say about us.
							</p>
						</div>
						<div className='w-full mt-10 lg:w-[50%] lg:ml-[160px] lg:mt-0'>
							<Splide
								options={{
									type: 'loop',
									drag: 'free',
									perPage: 1,
									arrows: false,
									gap: 100,
								}}
								aria-label='Hear our users'
							>
								<SplideSlide>
									<div className='block w-full lg:w-[475px] p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100'>
										<p className='here'>
											Best funds collection and money transfer platform on the
											market. Managing our funds has never been easier and
											transparent.
										</p>
										<div className='flex items-center space-x-4 mt-[18px]'>
											<div className='flex-shrink-0'>
												<img
													className='w-12 h-12 rounded-full'
													src={home10}
													alt='Smart CLoud'
												/>
											</div>
											<div className='flex-1 min-w-0'>
												<p className='text-sm font-medium text-gray-900 truncate'>
													Smart Cloud Africa Limited
												</p>
												<p className='text-sm text-gray-500 truncate'>
													Internet service provider
												</p>
											</div>
										</div>
									</div>
								</SplideSlide>
								<SplideSlide>
									<div className='block w-full lg:w-[475px] p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100'>
										<p className='here'>
											Nothing beats NdovuPay Corporate on the various options
											available for collecting and disbursing money.
										</p>
										<div className='flex items-center space-x-4 mt-[18px]'>
											<div className='flex-shrink-0'>
												<img
													className='w-12 h-12 rounded-full'
													src={dee}
													alt='Diana Mongina'
												/>
											</div>
											<div className='flex-1 min-w-0'>
												<p className='text-sm font-medium text-gray-900 truncate'>
													Diana Mongina
												</p>
												<p className='text-sm text-gray-500 truncate'>
													Software Solutions Manager
												</p>
											</div>
										</div>
									</div>
								</SplideSlide>
							</Splide>
						</div>
						<div className='mb-28'></div>
					</div>

					<div className='mt-44'>
						<footer className=''>
							<div className='w-full'>
								<div className='flex justify-between flex-wrap lg:flex-nowrap'>
									<div className='flex flex-col'>
										<span className='stay'>Stay Connected</span>

										<span className='follow mt-[20px]'>
											Follow us on social media for updates, industry insights,
											and more:
										</span>
									</div>
									<div className='grid grid-cols-2 lg:grid-cols-4 mt-4 lg:mt-0'>
										<div>
											<h2 className='f-header'>PRODUCT</h2>
											<ul className=''>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Why NdovuPay
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Features
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														How NdovuPay works
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Platform
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Security
													</a>
												</li>
											</ul>
										</div>

										<div>
											<h2 className='f-header'>COMPANY</h2>
											<ul className=''>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														About us
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Careers
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Resources
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Plans and prices
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Blog
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Support
													</a>
												</li>
											</ul>
										</div>

										<div>
											<h2 className='f-header'>HELP & SUPPORT</h2>
											<ul className=''>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Help center
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Developers
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Contact us
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														User guide
													</a>
												</li>
											</ul>
										</div>

										<div>
											<h2 className='f-header'>CONTACT US</h2>
											<ul className=''>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Have questions or need assistance? Reach out to our
														team:
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														admin@ndovupay.org
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														0798423681
													</a>
												</li>
												<li className='mb-[16px]'>
													<a
														href='https://corporate.ndovupay.org'
														className='f-body hover:underline'
													>
														Nairobi, Karen, Fair Acres, Hekima Road, Building 48
													</a>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<hr className='my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8' />
								<div className='sm:flex sm:items-center sm:justify-between'>
									<span className='text-sm text-white'>
										Copyright © 2023 NdovuPay. All Rights Reserved.
									</span>
									<span className='text-sm text-white'>
										Privacy & Terms of Use
									</span>
								</div>
							</div>
						</footer>
					</div>
				</div>
			</div>
		</>
	);
}
export default Home;





























































// import { React, useEffect, useRef, useState } from 'react';
// import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
// import LandingHeader from '../../components/header/LandingHeader';
// import LandingFooter from '../../components/footer/LandingFooter';
// import { Splide, SplideSlide } from '@splidejs/react-splide';
// import mpesa from '../../assets/mpesa.png';
// import family from '../../assets/family.png';
// import pesa from '../../assets/pesa.png';
// import master from '../../assets/master.png';
// import visa from '../../assets/visa.png';
// import ndovupay from '../../assets/ndovupay.png';
// import tick from '../../assets/tick.svg';
// import hand from '../../assets/hand.jpg';
// import ndovuHome from '../../assets/ndovuhome.png';
// import coin from '../../assets/coin.svg';
// import cardTick from '../../assets/card-tick.svg';
// import moneys from '../../assets/moneys.svg';
// import dee from '../../assets/dee.jpg';
// import collab from '../../assets/collab.svg';
// import receipt from '../../assets/receipt.svg';
// import people from '../../assets/people.svg';
// import experience from '../../assets/experience.png';
// import { useNavigate } from 'react-router-dom';

// function Home() {
// 	const ref1 = useRef(null);
// 	const ref2 = useRef(null);
// 	const ref3 = useRef(null);

// 	const [hasMargin, sethasMargin] = useState(false);

// 	const navigate = useNavigate();

// 	const handleAbout = () => {
// 		console.log('CLICK 1');
// 		ref1.current?.scrollIntoView({ behavior: 'smooth' });
// 		console.log(ref1.current);
// 	};

// 	const handleFeature = () => {
// 		ref2.current?.scrollIntoView({ behavior: 'smooth' });
// 	};

// 	const handleWhy = () => {
// 		ref3.current?.scrollIntoView({ behavior: 'smooth' });
// 	};

// 	const handleGetStarted = () => {
// 		navigate('/sign-up');
// 	};

// 	function toggleMargin() {
// 		console.log(hasMargin);
// 		sethasMargin(!hasMargin);
// 	}

// 	useEffect(() => {}, [hasMargin]);

// 	return (
// 		<>
// 			<div className='p-4 lg:!p-0 !overflow-x-hidden'>
// 				<div className='lg:mx-[120px]'>
// 					<LandingHeader
// 						handleAbout={handleAbout}
// 						handleFeature={handleFeature}
// 						handleWhy={handleWhy}
// 						toggleMargin={toggleMargin}
// 					/>

// 					<div className='mt-[102px] flex flex-col lg:flex-row lg:justify-between w-full'>
// 						<div className='w-full lg:w-[40%] mt-[50px]'>
// 							<h1
// 								style={{
// 									marginTop: hasMargin ? 20 : 0,
// 								}}
// 								className='meet'
// 							>
// 								Welcome to Ndovu<span className='text-[#DB2A12]'>Pay</span>.
// 								Streamline Your Financial Transactions.
// 							</h1>

// 							<p className='with mt-[24px]'>
// 								Are you ready to transform the way your business handles
// 								payments? Look no further. At Ndovupay, we are dedicated to
// 								providing top-notch payment solutions tailored for businesses
// 								and corporates like yours.
// 							</p>

// 							<div className='flex items-center mt-[48px]'>
// 								<button
// 									onClick={handleGetStarted}
// 									className='p-[12px] btn bg-[#FFB600]'
// 									type='button'
// 								>
// 									<span className='btn-home-yellow'>Get started</span>
// 								</button>
// 								<button
// 									onClick={handleWhy}
// 									className='p-[12px] btn bg-transparent text-[#1E2432] border-[1.5px] border-[#E2E8F0] ml-[24px]'
// 									type='button'
// 								>
// 									Learn more
// 								</button>
// 							</div>
// 						</div>
// 						<div className='hidden lg:flex w-[60%]'>
// 							<img
// 								src={ndovuHome}
// 								className='w-[100%] h-[580px]'
// 								alt='NDOVUPAY'
// 							/>
// 						</div>
// 					</div>
// 				</div>

// 				<div
// 					id='about'
// 					className='mt-[157px] w-full lg:px-[131px] py-[20px] bg-[#F6F6F6]'
// 				>
// 					<div className='bg-white flex items-center lg:justify-between flex-wrap'>
// 						<img
// 							src={mpesa}
// 							className='w-full lg:w-[118px] h-[78px] object-contain'
// 							alt='Mpesa'
// 						/>
// 						<img
// 							src={family}
// 							className='w-full lg:w-[176px] h-[78px] object-contain'
// 							alt='Family bank'
// 						/>
// 						<img
// 							src={pesa}
// 							className='w-full lg:w-[84px] h-[78px] object-contain'
// 							alt='Pesa Link'
// 						/>
// 						<img
// 							src={master}
// 							className='w-full lg:w-[103px] h-[78px] object-contain'
// 							alt='Master card'
// 						/>
// 						<img
// 							src={visa}
// 							className='w-full lg:w-[137px] h-[78px] object-contain'
// 							alt='Visa'
// 							ref={ref1}
// 						/>
// 					</div>
// 				</div>

// 				<div className='mt-[129px] grid grid-cols-1 lg:grid-cols-2'>
// 					<img
// 						src={ndovupay}
// 						className='w-full md:w-[400px] h-[400] lg:ml-[173px]'
// 						alt='Ndovupay'
// 					/>

// 					<div className='w-full lg:w-[80%] mt-7 lg:ml-[10%] lg:mt-0'>
// 						<span className='make'>Make Payments</span>
// 						<h2 className='make2 mt-[23px]'>
// 							Secure, Seamless, and Reliable Payment Services
// 						</h2>
// 						<p className='ndov'>
// 							NdovuPay is an all-in-one account. From fast transactions for all
// 							payments across all your organization, to easy bookkeeping and
// 							management.
// 						</p>

// 						<div className='mt-[24px] px-2'>
// 							<div className='flex items-center mb-[23px]'>
// 								<img src={tick} className='w-[32px] h-[32px]' alt='tick' />
// 								<span className='tick ml-3'>Cross platform payments</span>
// 							</div>
// 							<div className='flex items-center mb-[23px]'>
// 								<img src={tick} className='w-[32px] h-[32px]' alt='tick' />
// 								<span className='tick ml-3'>
// 									Seamless transactions between Bank & M-PESA
// 								</span>
// 							</div>
// 							<div className='flex items-center mb-[23px]'>
// 								<img src={tick} className='w-[32px] h-[32px]' alt='tick' />
// 								<span className='tick ml-3'>Licensed & regulated</span>
// 							</div>
// 						</div>
// 						<div onClick={handleWhy} className='flex mt-[49px] cursor-pointer'>
// 							<span className='read mr-2'>Read more</span>
// 							<TrendingFlatIcon className='text-[#017EFA] text-[25px]' />
// 						</div>
// 					</div>
// 				</div>

// 				<div className='flex items-center mt-[130px]'>
// 					<div
// 						ref={ref2}
// 						className='w-full lg:w-[704px] lg:h-[704px] bg-[#212529]'
// 					>
// 						<div className='px-2 py-3 lg:!px-[120px] lg:!py-[161px]'>
// 							<span className='collections'>Collections</span>
// 							<h3 className='mt-[23px] manage'>Manage collections</h3>

// 							<ol className='mt-[30px] text-white'>
// 								<li className='mb-[28px] flex flex-col'>
// 									<span className='ol'>01. Daily collection targets</span>
// 									<span className='ol-span mt-[12px] ml-7'>
// 										Know how much you collect in day
// 									</span>
// 								</li>
// 								<li className='mb-[28px] flex flex-col'>
// 									<span className='ol'>
// 										02. Set and monitor collection targets
// 									</span>
// 									<span className='ol-span mt-[12px] ml-7'>
// 										Set and monitor collection targets
// 									</span>
// 								</li>
// 								<li className='mb-[28px] flex flex-col'>
// 									<span className='ol'>03. Collections transfer</span>
// 									<span className='ol-span mt-[12px] ml-7'>
// 										Transfer collection to different wallet <br />
// 										accounts as per your needs
// 									</span>
// 								</li>
// 							</ol>
// 						</div>
// 					</div>

// 					<div className='hidden lg:-ml-[5%] lg:flex'>
// 						<img
// 							className='w-[751px] h-[515px] object-contain'
// 							src={hand}
// 							alt='handshake'
// 						/>
// 					</div>
// 				</div>

// 				<div
// 					ref={ref3}
// 					className='mt-[164px] flex flex-col lg:mx-[120px] lg:flex-row'
// 				>
// 					<div className='flex flex-col w-full lg:w-[44%]'>
// 						<h4 className='why'>Why Choose Ndovupay?</h4>
// 						<h3 className='all mt-[22px]'>All-in-one payments.</h3>
// 						<h2 className='faster'>
// 							Faster, easier, and more secure way of managing your money.
// 						</h2>
// 						<p className='fast-p mt-[20px]'>
// 							Simplify your financial operations with a comprehensive platform
// 							that handles both collections and disbursements across all payment
// 							channels, including banks and M-Pesa.
// 						</p>
// 						{/* <div className='hidden lg:flex lg:mt-[49px]'>
// 						<span className='read mr-2'>Read more</span>
// 						<TrendingFlatIcon className='text-[#017EFA] text-[25px]' />
// 					</div> */}
// 					</div>

// 					<div className='grid grid-cols-1 md:grid-cols-2 gap-4 w-full lg:w-[40%] lg:ml-[10%]'>
// 						<div className='p-[20px] flex flex-col w-full md:w-[300px]'>
// 							<img
// 								src={cardTick}
// 								className='w-[56px] h-[56px] rounded-full p-[10px] object-contain bg-gradient-to-t from-[#f4c85833] to-[#e3eaff00]'
// 								alt='Coin'
// 							/>
// 							<span className='why-span mt-[18px]'>Robust Security</span>
// 							<p className='why-p mt-[18px]'>
// 								Our platform is fortified with the latest encryption technology
// 								and security protocols to ensure your data and transactions are
// 								safeguarded at all times.
// 							</p>
// 						</div>
// 						<div className='p-[20px] flex flex-col w-full md:w-[300px] ml-0 lg:ml-[71px]'>
// 							<img
// 								src={collab}
// 								className='w-[56px] h-[56px] rounded-full p-[10px] object-contain bg-opacity-20 bg-gradient-to-t from-[#f4585833] to-[#e3eaff00]'
// 								alt='Coin'
// 							/>
// 							<span className='why-span mt-[18px]'>
// 								Hassle-Free Integration
// 							</span>
// 							<p className='why-p mt-[18px]'>
// 								Seamlessly integrate our payment services into your existing
// 								systems and applications, saving you time and resources.
// 							</p>
// 						</div>
// 						<div className='p-[20px] flex flex-col w-full md:w-[300px]'>
// 							<img
// 								src={receipt}
// 								className='w-[56px] h-[56px] rounded-full p-[10px] object-contain bg-opacity-20 bg-gradient-to-t from-[#002f6461] to-[#e3eaff00]'
// 								alt='Coin'
// 							/>
// 							<span className='why-span mt-[18px]'>Real-time Reporting</span>
// 							<p className='why-p mt-[18px]'>
// 								Gain deep insights into your financial transactions with our
// 								real-time reporting and analytics tools. Stay in control of your
// 								finances with ease.
// 							</p>
// 						</div>
// 						<div className='p-[20px] flex flex-col w-full md:w-[300px] ml-0 lg:ml-[71px]'>
// 							<img
// 								src={people}
// 								className='w-[56px] h-[56px] rounded-full p-[10px] object-contain bg-opacity-20 bg-gradient-to-t from-[#F7EFDA] to-[#e3eaff00]'
// 								alt='Coin'
// 							/>
// 							<span className='why-span mt-[18px]'> Dedicated Support</span>
// 							<p className='why-p mt-[18px]'>
// 								Our team of experts is ready to assist you around the clock.
// 								We're committed to providing exceptional customer support
// 								whenever you need it.
// 							</p>
// 						</div>
// 					</div>
// 				</div>

// 				<div className='lg:py-[109px] lg:px-[120px] grid grid-cols-1 lg:grid-cols-2 gap-6'>
// 					<img
// 						src={experience}
// 						className='hidden lg:flex w-[583px] h-[493px]'
// 						alt='Experience'
// 					/>

// 					<div className='lg:ml-14'>
// 						<span className='lets'>Let’s get started!</span>

// 						<h2 className='experience mt-[23px]'>
// 							Experience the Future of Payments
// 						</h2>

// 						<div className='flex flex-col'>
// 							<span className='join mt-[20px]'>
// 								Join the ranks of successful businesses and corporates that
// 								trust Ndovupay for their payment needs. Say goodbye to payment
// 								headaches and hello to efficiency, security, and peace of mind.
// 							</span>

// 							<span className='join mt-[20px]'>
// 								Ready to get started? Contact us today to schedule a demo and
// 								see how Ndovupay can revolutionize your financial operations.
// 							</span>

// 							<a
// 								rel='noreferrer'
// 								target='_blank'
// 								href='mailto:admin@ndovupay.org'
// 								className='btn bg-[#FFB600] p-[12px] mt-[20px] w-[128px]'
// 								type='button'
// 							>
// 								Contact us
// 							</a>
// 						</div>
// 					</div>
// 				</div>

// 				<div className='px-2 py-2 mt-[12px] bg-[#212529] lg:!py-[109px] lg:!px-[120px]  w-full'>
// 					<div className='flex flex-col lg:flex-row lg:items-center'>
// 						<div className='flex flex-col w-full lg:w-[40%]'>
// 							<span className='what'>What people say about NdovuPay</span>
// 							<h3 className='hear mt-[23px]'>Trusted by Leading Businesses</h3>
// 							<p className='hear-p mt-[20px]'>
// 								See what our partners say about us.
// 							</p>
// 						</div>
// 						<div className='w-full mt-10 lg:w-[50%] lg:ml-[160px] lg:mt-0'>
// 							<Splide
// 								options={{
// 									type: 'loop',
// 									drag: 'free',
// 									perPage: 1,
// 									arrows: false,
// 									gap: 100,
// 								}}
// 								aria-label='Hear our users'
// 							>
// 								<SplideSlide>
// 									<div className='block w-full lg:w-[475px] p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100'>
// 										<p className='here'>
// 											Here are the biggest enterprise technology acquisitions of
// 											2023 so far, in reverse chronological order.
// 										</p>
// 										<div className='flex items-center space-x-4 mt-[18px]'>
// 											<div className='flex-shrink-0'>
// 												<img
// 													className='w-12 h-12 rounded-full'
// 													src={dee}
// 													alt='Diana Mongina'
// 												/>
// 											</div>
// 											<div className='flex-1 min-w-0'>
// 												<p className='text-sm font-medium text-gray-900 truncate'>
// 													Diana Mongina
// 												</p>
// 												<p className='text-sm text-gray-500 truncate'>
// 													Software Developer
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 								</SplideSlide>
// 								<SplideSlide>
// 									<div className='block w-full lg:w-[475px] p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100'>
// 										<p className='here'>
// 											Here are the biggest enterprise technology acquisitions of
// 											2023 so far, in reverse chronological order.
// 										</p>
// 										<div className='flex items-center space-x-4 mt-[18px]'>
// 											<div className='flex-shrink-0'>
// 												<img
// 													className='w-12 h-12 rounded-full'
// 													src={dee}
// 													alt='Diana Mongina'
// 												/>
// 											</div>
// 											<div className='flex-1 min-w-0'>
// 												<p className='text-sm font-medium text-gray-900 truncate'>
// 													Diana Mongina
// 												</p>
// 												<p className='text-sm text-gray-500 truncate'>
// 													Software Developer
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 								</SplideSlide>
// 								<SplideSlide>
// 									<div className='block w-full lg:w-[475px] p-6 bg-white border border-gray-200 rounded-lg shadow hover:bg-gray-100'>
// 										<p className='here'>
// 											Here are the biggest enterprise technology acquisitions of
// 											2023 so far, in reverse chronological order.
// 										</p>
// 										<div className='flex items-center space-x-4 mt-[18px]'>
// 											<div className='flex-shrink-0'>
// 												<img
// 													className='w-12 h-12 rounded-full'
// 													src={dee}
// 													alt='Diana Mongina'
// 												/>
// 											</div>
// 											<div className='flex-1 min-w-0'>
// 												<p className='text-sm font-medium text-gray-900 truncate'>
// 													Diana Mongina
// 												</p>
// 												<p className='text-sm text-gray-500 truncate'>
// 													Software Developer
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 								</SplideSlide>
// 							</Splide>
// 						</div>
// 						<div className='mb-28'></div>
// 					</div>

// 					<div className='mt-44'>
// 						<footer className=''>
// 							<div className='w-full'>
// 								<div className='flex justify-between flex-wrap lg:flex-nowrap'>
// 									<div className='flex flex-col'>
// 										<span className='stay'>Stay Connected</span>

// 										<span className='follow mt-[20px]'>
// 											Follow us on social media for updates, industry insights,
// 											and more:
// 										</span>
// 									</div>
// 									<div className='grid grid-cols-2 lg:grid-cols-4 mt-4 lg:mt-0'>
// 										<div>
// 											<h2 className='f-header'>PRODUCT</h2>
// 											<ul className=''>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Why NdovuPay
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Features
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														How NdovuPay works
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Platform
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Security
// 													</a>
// 												</li>
// 											</ul>
// 										</div>

// 										<div>
// 											<h2 className='f-header'>COMPANY</h2>
// 											<ul className=''>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														About us
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Careers
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Resources
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Plans and prices
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Blog
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Support
// 													</a>
// 												</li>
// 											</ul>
// 										</div>

// 										<div>
// 											<h2 className='f-header'>HELP & SUPPORT</h2>
// 											<ul className=''>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Help center
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Developers
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Contact us
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														User guide
// 													</a>
// 												</li>
// 											</ul>
// 										</div>

// 										<div>
// 											<h2 className='f-header'>CONTACT US</h2>
// 											<ul className=''>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Have questions or need assistance? Reach out to our
// 														team:
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														admin@ndovupay.org
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														0798423681
// 													</a>
// 												</li>
// 												<li className='mb-[16px]'>
// 													<a
// 														href='https://ndovupay.org'
// 														className='f-body hover:underline'
// 													>
// 														Nairobi, Karen, Fair Acres, Hekima Road, Building 48
// 													</a>
// 												</li>
// 											</ul>
// 										</div>
// 									</div>
// 								</div>
// 								<hr className='my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8' />
// 								<div className='sm:flex sm:items-center sm:justify-between'>
// 									<span className='text-sm text-white'>
// 										Copyright © 2023 NdovuPay. All Rights Reserved.
// 									</span>
// 									<span className='text-sm text-white'>
// 										Privacy & Terms of Use
// 									</span>
// 								</div>
// 							</div>
// 						</footer>
// 					</div>
// 				</div>
// 			</div>
// 		</>
// 	);
// }
// export default Home;


